const fr = {
  _name: 'Français',
  _flag: '🇫🇷',

    'comm.anonymousVisitor': 'Visiteur anonyme',
  'comm.deletedVisitor': 'Visiteur supprimé',
'notifAuto.timezone': 'Fuseau horaire',
  'notifAuto.timezoneHint': 'Détermine quand les rappels sont envoyés',
  'notifAuto.tzKyiv': 'Kiev (UTC+2/+3)',
  'notifAuto.tzWarsaw': 'Varsovie (UTC+1/+2)',
  'notifAuto.tzBerlin': 'Berlin (UTC+1/+2)',
  'notifAuto.tzParis': 'Paris (UTC+1/+2)',
  'notifAuto.tzLondon': 'Londres (UTC+0/+1)',
  'notifAuto.tzMadrid': 'Madrid (UTC+1/+2)',
  'notifAuto.tzRome': 'Rome (UTC+1/+2)',
  'notifAuto.tzNewYork': 'New York (UTC-5/-4)',

  'errors.rateLimited': 'Trop de requêtes. Réessayez dans {seconds} s 🙂',
  'errors.serverError': 'Erreur serveur. Réessayez dans un instant',
  'errors.networkError': 'Pas de connexion. Vérifiez votre internet',

  // ── Navigation sections ──
  'nav.businessMonitor': 'Moniteur Business',
  'nav.dashboard': 'Tableau de bord',
  'nav.clients': 'Clients',
  'nav.communication': 'Communication',
  'nav.staff': 'Personnel',
  'nav.inventory': 'Stock',
  'nav.salary': 'Salaires',
  'nav.finances': 'Finances',
  'nav.system': 'Système',
  'nav.integrations': 'Intégrations',
  'nav.sales': 'Ventes',

  // ── Navigation items ──
  'nav.pos': 'Boutique',
  'nav.salesProducts': 'Expédition entrepôt',
  'nav.salesServices': 'Réserver services',
  'nav.clientsBase': 'Base clients',
  'nav.categories': 'Catégories clients',
  'nav.messages': 'Messages',
  'nav.employees': 'Employés',
  'nav.schedule': 'Planning',
  'nav.scheduleTemplates': 'Modèles de planning',
  'nav.services': 'Services',
  'nav.tariffPlans': 'Plans tarifaires',
  'nav.products': 'Produits',
  'nav.stock': 'Inventaire',
  'nav.purchases': 'Achats',
  'nav.movements': 'Mouvements de stock',
  'nav.orders': 'Commandes',
  'nav.salaryCalc': 'Calcul',
  'nav.salarySchemes': 'Schémas de motivation',
  'nav.financialOps': 'Opérations financières',
  'nav.cashRegister': 'Caisse',
  'nav.reports': 'Rapports',
  'nav.financialResult': 'Résultat financier',
  'nav.users': 'Utilisateurs',
  'nav.roles': 'Rôles',
  'nav.checkbox': 'Checkbox POS',
  'nav.telegram': 'Rappels Telegram',
  'nav.sms': 'Envoi SMS',
  'nav.email': 'Envoi Email',
  'nav.novaPoshta': 'Nova Poshta',
  'nav.meestExpress': 'Meest Express',
  'nav.olx': 'OLX',
  'olx.tagline': 'Messages d\'annonces + synchronisation du catalogue',
  'olx.connected': 'Connecté',
  'olx.notConnected': 'Non connecté',
  'olx.connectIntro': 'Connecte ton compte OLX via OAuth pour recevoir les messages des annonces dans le CRM et publier des produits.',
  'olx.connectBtn': 'Connecter OLX',
  'olx.tabOpened': 'OLX ouvert dans un nouvel onglet. Autorise et reviens.',
  'olx.connectFailed': 'Échec de connexion :',
  'olx.connectedToast': 'OLX connecté',
  'olx.confirmDisconnect': 'Déconnecter l\'intégration OLX ?',
  'olx.disconnected': 'OLX déconnecté',
  'olx.disconnectBtn': 'Déconnecter',
  'olx.testBtn': 'Tester la connexion',
  'olx.testOk': 'Connecté en tant que : {name} (ID {id})',
  'olx.testFailed': 'Échec du test',
  'olx.accountId': 'OLX ID',
  'olx.scope': 'Permissions',
  'olx.connectedAt': 'Connecté le',
  'olx.reconnectRequired': 'Ré-autorisation requise',
  'olx.reconnectExplain': 'OLX a révoqué nos jetons (généralement après 30 jours d\'inactivité ou un changement de mot de passe). Clique sur « Connecter OLX » pour reprendre la réception des messages.',
  'olx.refreshBtn': 'Vérifier les nouveaux messages',
  'olx.refreshFound': '{n} nouveaux messages — voir Communications',
  'olx.refreshNoNew': 'Aucun nouveau message',
  'olx.refreshFailed': 'Échec de la mise à jour',
  'comm.olxThreadMissing': 'Impossible de déterminer le fil OLX',
  'olx.howItWorks': 'Comment ça marche',
  'olx.step1': 'Clique sur « Connecter OLX » — l\'autorisation OLX s\'ouvre dans un nouvel onglet.',
  'olx.step2': 'Connecte-toi à ton compte OLX et accorde l\'accès à l\'application.',
  'olx.step3': 'Reviens ici — le statut se rafraîchira automatiquement ; vérifie avec « Tester la connexion ».',
  'olx.capabilities': 'Ce que l\'intégration débloque',
  'olx.capInboxTitle': 'Discussions d\'annonces — dans le CRM',
  'olx.capInboxText': 'Chaque message d\'acheteur sur tes annonces OLX apparaît dans Sidebar → Communications. Vérification toutes les 10 min ; utilise « Vérifier les nouveaux messages » ci-dessus pour récupérer immédiatement.',
  'olx.capOutboundTitle': 'Répondre depuis le CRM dans le chat OLX',
  'olx.capOutboundText': 'Ouvre un fil dans Communications, choisis le canal OLX — ton message arrive dans le chat OLX de l\'acheteur comme si tu l\'avais écrit sur olx.ua.',
  'olx.capPublishTitle': 'Publier des produits comme annonces OLX',
  'olx.capPublishText': 'Sidebar → Inventaire → ouvre un produit → « Publier sur OLX ». Titre, description, prix et photo sont pré-remplis — tu choisis catégorie, ville, contact, et l\'annonce part en modération OLX.',
  'olx.limitations': 'Limitations',
  'olx.limitationsText': 'Les commandes OLX Delivery ne sont pas encore exposées via l\'API partenaire. Gère-les sur olx.ua pour l\'instant.',
  'nav.locations': 'Emplacements',
  'nav.myPlan': 'Mon Plan',
  'nav.onlineBooking': 'Réservation en ligne',
  'nav.help': 'Aide',
  'booking.title': 'Réservation en ligne',
  'booking.subtitle': 'Configurer la page publique de réservation pour vos clients',
  'booking.enable': 'Activer la réservation en ligne',
  'booking.yourLink': 'Votre lien',
  'booking.copy': 'Copier',
  'booking.urlCopied': 'Lien copié',
  'booking.linkHint': 'Partagez ce lien avec vos clients — sur Instagram, Telegram, votre site',
  'booking.businessInfo': 'Informations sur l\'entreprise',
  'booking.businessName': 'Nom de l\'entreprise',
  'booking.businessNameHint': 'Comment vos clients vous verront',
  'booking.slug': 'Identifiant URL',
  'booking.slugHint': 'Lettres latines, chiffres, tirets. Ex: mon-salon',
  'booking.description': 'Description',
  'booking.descriptionHint': 'Brève description de votre entreprise',
  'booking.themeColor': 'Couleur du thème',
  'booking.locale': 'Langue de la page',
  'booking.rules': 'Règles de réservation',
  'booking.minHours': 'Délai minimum',
  'booking.hours': 'heures',
  'booking.minHoursHint': 'Combien d\'heures à l\'avance peut-on réserver',
  'booking.maxDays': 'Profondeur max.',
  'booking.days': 'jours',
  'booking.maxDaysHint': 'Combien de jours à l\'avance la réservation est disponible',
  'booking.allowedServices': 'Services pour la réservation en ligne',
  'booking.allowedServicesHint': 'Sélectionnez les services disponibles en ligne. Si aucun n\'est sélectionné — tous sont disponibles.',
  'booking.allowedStaff': 'Spécialistes pour la réservation en ligne',
  'booking.allowedStaffHint': 'Sélectionnez les spécialistes disponibles en ligne. Si aucun n\'est sélectionné — tous sont disponibles.',
  'booking.selectAll': 'Tout sélectionner',
  'booking.deselectAll': 'Tout désélectionner',
  'booking.tabGeneral': 'Général',
  'booking.tabServices': 'Services',
  'booking.tabProducts': 'Produits',
  'booking.tabAfter': 'Après',
  'booking.serviceCategories': 'Catégories de services',
  'booking.serviceCategoriesHint': 'Sélectionnez les catégories pour la réservation. Si aucune — toutes disponibles.',
  'booking.productCategories': 'Catégories de produits',
  'booking.productCategoriesHint': 'Sélectionnez les catégories pour la vente. Si aucune — toutes disponibles.',
  'booking.noCategoriesYet': 'Pas encore de catégories. Créez-les dans la section correspondante.',
  'booking.mode': 'Mode de fonctionnement',
  'booking.modeServices': 'Services',
  'booking.modeShop': 'Boutique',
  'booking.modeBoth': 'Les deux',
  'booking.modeHint': 'Services — réservation. Boutique — commandes en ligne. Les deux — services et produits.',
  'booking.shopSettings': 'Paramètres boutique',
  'booking.shopMinOrder': 'Commande minimum',
  'booking.shopShowOutOfStock': 'Rupture de stock',
  'booking.shopShowOutOfStockLabel': 'Afficher les produits en rupture',
  'booking.shopDelivery': 'Modes de livraison',
  'booking.deliveryPickup': 'Retrait',
  'booking.deliveryNP': 'Nova Poshta',
  'booking.deliveryMeest': 'Meest Express',
  'booking.deliveryCourier': 'Coursier',
  'booking.gallery': 'Galerie',
  'booking.galleryHint': 'Photos de travaux, intérieur, produits — jusqu\'à 10 images',
  'booking.galleryCount': 'photos',
  'booking.promo': 'Bannière promo',
  'booking.promoEnable': 'Afficher la bannière',
  'booking.promoText': 'Texte de la promo',
  'booking.promoPlaceholder': 'Ex. : -20% sur la première visite',
  'booking.promoColor': 'Couleur',
  'booking.colorScheme': 'Palette de couleurs',
  'booking.bgColor': 'Couleur de fond',
  'booking.presetLight': 'Clair',
  'booking.presetDark': 'Sombre',
  'booking.presetWarm': 'Chaud',
  'booking.presetFresh': 'Frais',
  'booking.presetRose': 'Rose',
  'booking.presetPurple': 'Violet',
  'booking.branding': 'Image de marque',
  'booking.logo': 'Logo',
  'booking.uploadLogo': 'Télécharger le logo',
  'booking.changeLogo': 'Changer le logo',
  'booking.headerImage': 'Image d\'en-tête',
  'booking.uploadImage': 'Télécharger une photo',
  'booking.changeImage': 'Changer la photo',
  'booking.logoTooLarge': 'Le logo est trop volumineux. Maximum 1 Mo.',
  'booking.imageTooLarge': 'L\'image est trop volumineuse. Maximum 5 Mo.',
  'booking.headerImageHint': 'Photo de votre entreprise — salon, studio, boutique',
  'booking.contacts': 'Contacts',
  'booking.contactsHint': 'L\'adresse et les horaires sont repris des paramètres d\'emplacement',
  'booking.address': 'Adresse',
  'booking.addressHint': 'Rue, numéro, ville',
  'booking.businessPhone': 'Téléphone',
  'booking.website': 'Site web',
  'booking.workingHours': 'Heures d\'ouverture',
  'booking.workingHoursHint': 'Lun-Ven 9h-18h',
  'booking.afterBooking': 'Après réservation',
  'booking.successMsg': 'Message de confirmation',
  'booking.successMsgHint': 'Ex : Nous vous attendons ! N\'oubliez pas votre pièce d\'identité.',
  'booking.cancelPolicy': 'Politique d\'annulation',
  'booking.cancelPolicyHint': 'Ex : Annulation possible jusqu\'à 24h avant',
  'booking.disableTitle': 'Désactiver la réservation en ligne ?',
  'booking.disableText': 'Les clients ne pourront plus réserver en ligne. Vous pourrez le réactiver à tout moment.',
  'booking.disableConfirm': 'Désactiver',

  // ── Calendar months & days ──
  'months.0': 'Janvier', 'months.1': 'Février', 'months.2': 'Mars',
  'months.3': 'Avril', 'months.4': 'Mai', 'months.5': 'Juin',
  'months.6': 'Juillet', 'months.7': 'Août', 'months.8': 'Septembre',
  'months.9': 'Octobre', 'months.10': 'Novembre', 'months.11': 'Décembre',
  'dow.0': 'Lu', 'dow.1': 'Ma', 'dow.2': 'Me',
  'dow.3': 'Je', 'dow.4': 'Ve', 'dow.5': 'Sa', 'dow.6': 'Di',

  // ── Common UI ──
  'common.save': 'Enregistrer',
  'common.saving': 'Enregistrement...',
  'common.saved': 'Enregistré',
  'common.cancel': 'Annuler',
  'common.delete': 'Supprimer',
  'common.edit': 'Modifier',
  'common.add': 'Ajouter',
  'common.search': 'Rechercher',
  'onboarding.title': 'Configurez votre entreprise',
  'onboarding.subtitle': '{done} sur {total} étapes complétées',
  'onboarding.allDone': 'Tout est configuré !',
  'onboarding.allDoneHint': 'Vous êtes prêt à travailler 💪',
  'onboarding.stepBusiness': 'Type d\'activité sélectionné',
  'onboarding.stepStaff': 'Ajouter votre premier employé',
  'onboarding.stepService': 'Ajouter votre premier service',
  'onboarding.stepAppointment': 'Créer votre premier rendez-vous',
  'onboarding.stepClient': 'Ajouter votre premier client',
  'onboarding.noStaffYet': 'Aucun employé',
  'onboarding.noStaffHint': 'Ajoutez votre premier employé pour commencer à accepter des rendez-vous',
  'onboarding.goAddStaff': '+ Ajouter un employé',
  'gsearch.placeholder': 'Rechercher clients, rendez-vous, employés...',
  'gsearch.quickActions': 'Actions rapides',
  'gsearch.customers': 'Clients',
  'gsearch.staff': 'Employés',
  'gsearch.appointments': 'Rendez-vous',
  'gsearch.noResults': 'Rien trouvé',
  'gsearch.goCalendar': 'Planning — aujourd\'hui',
  'gsearch.goClients': 'Base clients',
  'gsearch.goFinances': 'Finances',
  'gsearch.goDashboard': 'Tableau de bord',
  'gsearch.newClient': 'Nouveau client',
  'common.close': 'Fermer',
  'common.loading': 'Chargement...',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.and': 'et',
  'common.confirm': 'Confirmer',
  'common.back': 'Retour',
  'common.next': 'Suivant',
  'common.create': 'Créer',
  'common.actions': 'Actions',
  'common.name': 'Nom',
  'common.phone': 'Téléphone',
  'common.email': 'Email',
  'common.date': 'Date',
  'common.time': 'Heure',
  'common.status': 'Statut',
  'common.total': 'Total',
  'common.price': 'Prix',
  'common.quantity': 'Quantité',
  'common.note': 'Note',
  'common.all': 'Tous',
  'common.filter': 'Filtre',
  'common.export': 'Exporter',
  'common.shown': 'Affiché',
  'common.of': 'sur',
  'common.logout': 'Déconnexion',
  'common.profile': 'Profil',
  'common.settings': 'Paramètres',
  'common.language': 'Langue',

  // ── Clients page ──
  'clients.title': 'Base clients',
  'clients.subtitle': 'Gestion des fiches clients',
  'clients.addClient': 'Ajouter un client',
  'clients.import': 'Importer',
  'import.title': 'Importer des clients',
  'import.uploadHint': 'Téléchargez un fichier avec votre base clients. Excel et CSV sont pris en charge.',
  'import.maxRows': 'maximum {max} lignes',
  'import.tooManyRowsTitle': 'Fichier trop volumineux',
  'import.tooManyRowsBody': 'Le fichier contient {count} lignes — le maximum par import est {max}. Divisez le fichier en parties plus petites ou contactez le support.',
  'import.selectFile': 'Choisir un fichier',
  'import.downloadTemplate': 'Télécharger le modèle',
  'import.or': 'ou',
  'import.rows': 'lignes',
  'import.fieldName': 'Nom',
  'import.fieldLastName': 'Nom de famille',
  'import.fieldFirstName': 'Prénom',
  'import.fieldPhone': 'Téléphone',
  'import.fieldAdditionalPhone': 'Tél. supplémentaire',
  'import.fieldEmail': 'Email',
  'import.fieldGender': 'Genre',
  'import.fieldBirthday': 'Date de naissance',
  'import.fieldCategory': 'Catégorie',
  'import.fieldCardNumber': 'Nº de carte',
  'import.fieldNote': 'Note',

  'importProducts.btn': 'Importer',
  'importProducts.btnTitle': 'Import en masse de produits depuis Excel/CSV',
  'importProducts.title': 'Import de produits',
  'importProducts.uploadHint': 'Téléversez un fichier Excel ou CSV avec vos produits. Champs requis : nom et prix de vente.',
  'importProducts.maxRows': 'maximum {max} lignes',
  'importProducts.tooManyRowsTitle': 'Fichier trop volumineux',
  'importProducts.tooManyRowsBody': 'Le fichier contient {count} lignes — maximum par import : {max}. Découpez-le en plusieurs fichiers.',
  'importProducts.selectFile': 'Sélectionner un fichier',
  'importProducts.downloadTemplate': 'Télécharger le modèle',
  'importProducts.or': 'ou',
  'importProducts.rows': 'lignes',
  'importProducts.fieldName': 'Nom',
  'importProducts.fieldSku': 'SKU',
  'importProducts.fieldCategory': 'Catégorie',
  'importProducts.fieldUnit': 'Unité',
  'importProducts.fieldMinStock': 'Stock min.',
  'importProducts.fieldSellPrice': 'Prix de vente',
  'importProducts.statusCol': 'Statut',
  'importProducts.mapHint': 'Associez les colonnes du fichier aux champs produit. Les champs obligatoires sont marqués d\'un astérisque.',
  'importProducts.notMapped': 'non sélectionné',
  'importProducts.back': 'Retour',
  'importProducts.next': 'Suivant',
  'importProducts.startOver': 'Autre fichier',
  'importProducts.willImport': 'seront importés',
  'importProducts.willSkip': 'seront ignorés',
  'importProducts.newCategories': 'nouvelles catégories',
  'importProducts.newCategoriesWarning': 'Le fichier mentionne des catégories qui n\'existent pas encore — elles seront créées automatiquement lors de l\'import.',
  'importProducts.errMissingName': 'Nom vide',
  'importProducts.errInvalidPrice': 'Prix invalide',
  'importProducts.errInvalidMinStock': 'Stock min. invalide',
  'importProducts.errSkuExisting': 'SKU déjà existant',
  'importProducts.previewTruncated': 'Affichage des 100 premières sur {count}',
  'importProducts.importing': 'Import en cours...',
  'importProducts.importBtn': 'Importer {count}',
  'importProducts.doneTitle': '{count} produits importés',
  'importProducts.doneNewCategories': '{count} nouvelles catégories créées',
  'importProducts.doneSkipped': '{count} lignes ignorées',
  'importProducts.close': 'Fermer',
  'importProducts.toastSuccess': 'Produits importés',

  'importServices.btn': 'Importer',
  'importServices.btnTitle': 'Import en masse de services depuis Excel/CSV',
  'importServices.title': 'Import de services',
  'importServices.uploadHint': 'Téléversez un fichier Excel ou CSV avec vos services. Requis : nom et prix. Durée par défaut : 30 min.',
  'importServices.maxRows': 'maximum {max} lignes',
  'importServices.tooManyRowsTitle': 'Fichier trop volumineux',
  'importServices.tooManyRowsBody': 'Le fichier contient {count} lignes — maximum par import : {max}.',
  'importServices.selectFile': 'Sélectionner un fichier',
  'importServices.downloadTemplate': 'Télécharger le modèle',
  'importServices.or': 'ou',
  'importServices.rows': 'lignes',
  'importServices.fieldName': 'Nom',
  'importServices.fieldGroup': 'Groupe',
  'importServices.fieldPrice': 'Prix',
  'importServices.fieldDuration': 'Durée (min)',
  'importServices.statusCol': 'Statut',
  'importServices.mapHint': 'Associez les colonnes du fichier aux champs service. Les champs obligatoires sont marqués d\'un astérisque.',
  'importServices.notMapped': 'non sélectionné',
  'importServices.back': 'Retour',
  'importServices.next': 'Suivant',
  'importServices.startOver': 'Autre fichier',
  'importServices.willImport': 'seront importés',
  'importServices.willSkip': 'seront ignorés',
  'importServices.newGroups': 'nouveaux groupes',
  'importServices.newGroupsWarning': 'Le fichier mentionne des groupes qui n\'existent pas encore — ils seront créés automatiquement.',
  'importServices.errMissingName': 'Nom vide',
  'importServices.errInvalidPrice': 'Prix invalide',
  'importServices.errInvalidDuration': 'Durée invalide (1-1440 min)',
  'importServices.errNameExisting': 'Le service existe déjà',
  'importServices.previewTruncated': 'Affichage des 100 premières sur {count}',
  'importServices.importing': 'Import en cours...',
  'importServices.importBtn': 'Importer {count}',
  'importServices.doneTitle': '{count} services importés',
  'importServices.doneNewGroups': '{count} nouveaux groupes créés',
  'importServices.doneSkipped': '{count} lignes ignorées',
  'importServices.close': 'Fermer',
  'importServices.toastSuccess': 'Services importés',

  'import.skip': 'ignorer',
  'import.phoneRequired': 'Le champ "Téléphone" est obligatoire',
  'import.preview': 'Aperçu',
  'import.back': 'Retour',
  'import.adjustColumns': 'Ajuster les colonnes',
  'import.newClients': 'Nouveaux clients',
  'import.duplicates': 'Doublons (ignorés)',
  'import.duplicate': 'doublon',
  'import.new': 'nouveau',
  'import.status': 'Statut',
  'import.andMore': '...et {count} de plus',
  'import.importing': 'Importation...',
  'import.importBtn': 'Importer ({count})',
  'import.success': '{count} clients importés !',
  'import.skippedDuplicates': '{count} doublons ignorés',
  'import.error': "Erreur d'importation",
  'import.close': 'Fermer',
  'helpPage.title': 'Help',
  'helpPage.subtitle': 'Guides and instructions for Systemic CRM',
  'clients.searchPlaceholder': 'Rechercher par nom, téléphone, email, numéro de carte...',
  'clients.allCategories': 'Toutes les catégories',
  'clients.clientsCount': 'Clients',
  'clients.grid': 'Grille',
  'clients.list': 'Liste',
  'clients.deleteTitle': 'Supprimer le client ?',
  'clients.deleteMessage': 'Vous êtes sur le point de supprimer la fiche client',
  'clients.cannotDeleteTitle': 'Suppression impossible',
  'clients.cannotDeleteMessage': 'Le client a des rendez-vous ou un historique financier et ne peut pas être supprimé',
  'clients.duplicatePhone': 'Un client avec ce numéro de téléphone existe déjà',
  'clients.duplicatePhoneWithName': 'Un client avec ce téléphone existe déjà : {name}',
  'clients.openExisting': 'Ouvrir le client',
  'clients.understood': 'Compris',
  'clients.deleteWarning': 'Cette action est irréversible. Toutes les données du client seront perdues.',

  // ── Delete modal ──
  'delete.title': 'Confirmer la suppression',
  'delete.message': 'Vous êtes sur le point de supprimer un enregistrement',
  'delete.confirm': 'Oui, supprimer',
  'delete.warning': 'Cette action est irréversible. Toutes les données seront perdues.',

  // ── Sidebar ──
  'sidebar.crmSystem': 'Système CRM',
  'sidebar.version': 'v1.0',

  // ── Login ──
  'login.title': 'Connexion',
  'login.setupTitle': 'Configuration du système',
  'login.setupSubtitle': 'Créez un compte administrateur',
  'login.subtitle': 'Entrez vos identifiants',
  'login.email': 'Email',
  'login.password': 'Mot de passe',
  'login.submit': 'Se connecter',
  'login.setupSubmit': 'Créer l\'administrateur',
  'login.wait': 'Veuillez patienter…',
  'login.forgotPassword': 'Mot de passe oublié ?',
  'login.resetTitle': 'Réinitialiser le mot de passe',
  'login.resetSubtitle': 'Entrez votre email — nous vous enverrons les instructions',
  'login.resetSend': 'Envoyer',
  'login.resetSentHint': 'Vérifiez votre boîte mail — nous avons envoyé les instructions',
  'login.backToLogin': 'Retour à la connexion',
  'login.nameLabel': 'Nom',
  'login.namePlaceholder': 'Votre nom',
  'login.businessLabel': "Nom de l'entreprise",
  'login.businessPlaceholder': 'Mon salon / magasin / studio',
  'login.errorEnterBusiness': "Entrez le nom de l'entreprise",
  'login.businessTypeLabel': "Type d'activité",
  'login.businessTypePlaceholder': "Sélectionnez le type d'activité...",
  'login.errorSelectBusinessType': "Sélectionnez le type d'activité",
  'login.showPassword': 'Afficher le mot de passe',
  'login.hidePassword': 'Masquer le mot de passe',
  'login.errorInvalidCreds': 'Email ou mot de passe incorrect',
  'login.errorTooMany': 'Trop de tentatives. Réessayez plus tard.',
  'login.errorGeneric': 'Erreur de connexion : ',
  'login.errorEnterName': 'Entrez votre nom',
  'login.errorEnterEmail': 'Entrez l\'email',
  'login.errorMinPassword': 'Le mot de passe doit comporter au moins 6 caractères',
  'login.errorSetup': 'Erreur : ',
  'login.tabLogin': 'Connexion',
  'login.tabRegister': 'Inscription',
  'login.registerTitle': 'Créer un compte',
  'login.registerSubtitle': '7 jours gratuits, tous les modules inclus',
  'login.registerSubmit': "S'inscrire",
  'login.registerSuccess': 'Compte créé ! Connexion en cours...',
  'login.errorEmailExists': 'Cet email est déjà enregistré',
  'login.errorRegister': "Erreur d'inscription : ",
  'login.confirmPassword': 'Confirmer le mot de passe',
  'login.errorPasswordMismatch': 'Les mots de passe ne correspondent pas',
  'login.agreeTerms': 'En vous inscrivant, vous acceptez les',
  'login.agreeCheckbox': 'J\'accepte les',
  'login.errorAgreeTerms': 'Vous devez accepter les conditions d\'utilisation',
  'login.terms': 'Conditions d\'utilisation',
  'login.privacy': 'Politique de confidentialité',

  // ── Blocked ──
  'blocked.title': 'Compte bloqué',
  'blocked.desc': "Contactez l'administrateur pour restaurer l'accès",
  'blocked.trialExpired': "Période d'essai terminée",
  'blocked.trialExpiredDesc': 'Choisissez un plan pour continuer',
  'blocked.paymentOverdue': 'Abonnement en retard',
  'blocked.paymentOverdueDesc': 'Votre abonnement a expiré. Veuillez le renouveler pour continuer à travailler.',
  'blocked.subscriptionExpiredDesc': 'Votre abonnement a expiré. Veuillez le renouveler pour continuer à travailler.',
  'blocked.contact': 'Contacter le support',
  'blocked.logout': 'Se déconnecter',

  // ── My Plan ──
  'myPlan.title': 'Mon Plan',
  'myPlan.subtitle': 'Gestion de l\'abonnement',
  'myPlan.loadError': 'Impossible de charger les données du plan',
  'myPlan.trial': 'Essai',
  'myPlan.active': 'Actif',
  'myPlan.trialExpired': 'Essai expiré',
  'myPlan.blocked': 'Bloqué',
  'myPlan.daysLeft': 'jours restants',
  'myPlan.month': 'mois',
  'myPlan.year': 'an',
  'myPlan.orYearly': 'ou',
  'myPlan.chooseBillingPeriod': 'choisis la périodicité',
  'myPlan.periodMonthly': 'Mensuel',
  'myPlan.periodYearly': 'Annuel',
  'myPlan.yearlySaving': 'économise {n} ₴ vs mensuel',
  'myPlan.monthlyTotal': '{n} ₴/an',
  'myPlan.proceedToPayment': 'Aller au paiement',
  'myPlan.cancel': 'Annuler',
  'myPlan.oldRateTitle': 'Vous avez un ancien tarif',
  'myPlan.oldRateText': 'Vous payez actuellement {old} ₴ ; le tarif actuel pour {plan} est {new} ₴. Vous pouvez conserver l\'ancien tarif indéfiniment ou passer au nouveau.',
  'myPlan.upgradeRate': 'Passer au nouveau tarif',
  'myPlan.users': 'Utilisateurs',
  'myPlan.locations': 'Emplacements',
  'myPlan.availablePlans': 'Plans disponibles',
  'myPlan.popular': 'Populaire',
  'myPlan.usersIncl': 'utilisateurs',
  'myPlan.locationsIncl': 'emplacements',
  'myPlan.allModules': 'Les 46 modules',
  'myPlan.trialActive': 'Essai actif',
  'myPlan.currentPlan': 'Plan actuel',
  'myPlan.upgrade': 'Choisir un plan',
  'myPlan.changePlan': 'Changer de plan',
  'myPlan.trialHint': 'Après la période d\'essai, choisissez un plan pour continuer. Toutes vos données seront conservées.',
  'myPlan.limitUsers': 'Limite d\'utilisateurs atteinte. Passez à un plan supérieur.',
  'myPlan.limitLocations': 'Limite d\'emplacements atteinte. Passez à un plan supérieur.',
  'myPlan.cancelSubscription': 'Annuler l\'abonnement',
  'myPlan.cancelledNotice': 'Abonnement annulé. Votre plan reste actif jusqu\'à la fin de la période payée.',
  'myPlan.cancelTitle': 'Annuler l\'abonnement ?',
  'myPlan.cancelDescription': 'Votre plan restera actif jusqu\'à la fin de la période payée. Ensuite, votre compte sera rétrogradé au plan d\'essai.',
  'myPlan.cancelReasonLabel': 'Raison de l\'annulation (facultatif)',
  'myPlan.cancelReasonPlaceholder': 'Dites-nous pourquoi vous avez décidé d\'annuler...',
  'myPlan.confirmCancel': 'Oui, annuler',
  'myPlan.keepSubscription': 'Garder l\'abonnement',
  'myPlan.cancelError': 'Erreur d\'annulation',
  'myPlan.subscriptionExpired': 'expiré',

  // ── Checkout (post-registration) ──
  'checkout.title': 'Votre compte est prêt !',
  'checkout.subtitle': 'Choisissez comment commencer avec Systemic CRM',
  'checkout.recommended': 'Recommandé',
  'checkout.payNow': 'Payer et commencer',
  'checkout.trialTitle': 'Essai gratuit',
  'checkout.days': 'jours',
  'checkout.trialFeature1': 'Accès complet à toutes les fonctionnalités',
  'checkout.trialFeature2': 'Sans engagement',
  'checkout.trialFeature3': 'Vos données sont conservées après le paiement',
  'checkout.tryFree': 'Essayer gratuitement',

  // ── Dashboard ──
  'dash.title': 'Tableau de bord',
  'dash.myOffice': 'Mon bureau',
  'dash.subtitle': 'Écran principal',
  'dash.personalStats': 'Statistiques personnelles',
  'dash.todayAppointments': 'Rendez-vous aujourd\'hui',
  'dash.completed': 'terminé(s)',
  'dash.todayRevenue': 'Chiffre d\'affaires du jour',
  'dash.clientsCount': 'Clients',
  'dash.newThisMonth': 'ce mois-ci',
  'dash.unread': 'Non lus',
  'dash.todaySchedule': 'Planning du jour',
  'dash.allAppointments': 'Tous les rendez-vous',
  'dash.noAppointmentsToday': 'Aucun rendez-vous aujourd\'hui',
  'dash.moreAppointments': 'rendez-vous',
  'dash.weekRevenue': 'Chiffre d\'affaires de la semaine',
  'dash.needsAttention': 'Nécessite attention',
  'dash.unreadMessages': 'messages non lus',
  'dash.lowStock': 'stock faible',
  'dash.topClients': 'Top clients (mois)',
  'dash.noPaymentsThisMonth': 'Aucun paiement ce mois-ci',
  'dash.birthdays': 'Anniversaires',
  'dash.noBirthdaysThisWeek': 'Aucun anniversaire cette semaine',
  'dash.today': 'Aujourd\'hui !',
  'dash.tomorrow': 'Demain',
  'dash.inDays': 'Dans {n} j.',
  'dash.congratulate': 'Féliciter',
  'dash.atRisk': 'Risque de perte',
  'dash.allClientsActive': 'Tous les clients sont actifs',
  'dash.daysWithoutVisit': 'jours sans visite',
  'dash.write': 'Écrire',
  'dash.todayOrderSales': 'Ventes produits',
  'dash.serviceSales': 'Ventes services',
  'dash.appointmentsToday': 'rendez-vous aujourd\'hui',
  'dash.ordersToday': 'commandes aujourd\'hui',
  'dash.activeOrders': 'actives',
  'dash.recentOrders': 'Commandes récentes',
  'dash.allOrders': 'Toutes les commandes',
  'dash.items': 'articles',
  'dash.statusWaiting': 'En attente',
  'dash.statusConfirmed': 'Terminé',
  'dash.statusArrived': 'Arrivé',
  'dash.statusNoShow': 'Absent',
  'dash.dowSun': 'Di', 'dash.dowMon': 'Lu', 'dash.dowTue': 'Ma',
  'dash.dowWed': 'Me', 'dash.dowThu': 'Je', 'dash.dowFri': 'Ve', 'dash.dowSat': 'Sa',

  // ── Profile modal ──
  'profile.title': 'Profil',
  'profile.name': 'Nom',
  'profile.namePlaceholder': 'Votre nom',
  'profile.email': 'Email',
  'profile.changePassword': 'Changer le mot de passe',
  'profile.passwordHint': 'Laissez les champs vides si vous ne souhaitez pas changer le mot de passe',
  'profile.currentPassword': 'Mot de passe actuel',
  'profile.newPassword': 'Nouveau mot de passe',
  'profile.newPasswordPlaceholder': 'Au moins 6 caractères',
  'profile.confirmPassword': 'Confirmer le mot de passe',
  'profile.confirmPasswordPlaceholder': 'Répétez le nouveau mot de passe',
  'profile.saved': 'Enregistré !',
  'profile.passwordChanged': 'Mot de passe changé',
  'profile.homePage': 'Page d\'accueil',
  'profile.startingLocation': 'Emplacement initial',
  'profile.startingLocationAuto': 'Automatique (par défaut)',
  'profile.homeBizMonitor': 'Moniteur Business',
  'profile.homeDashboard': 'Tableau de bord',
  'profile.homeCalendar': 'Calendrier',
  'profile.homeClients': 'Clients',
  'profile.homePos': 'Boutique',
  'profile.homeOrders': 'Commandes',
  'profile.homeFinances': 'Finances',
  'profile.homeCommunication': 'Messages',
  'profile.homeStaff': 'Personnel',
  'profile.homeStock': 'Stock',
  'profile.homePurchases': 'Achats',
  'profile.homeProduction': 'Production',
  'profile.homeSalary': 'Paie',
  'profile.homeCashRegister': 'Caisse',
  'profile.homeReports': 'Rapports',
  'profile.homeFinResult': 'Résultat financier',
  'profile.profileUpdated': 'Profil mis à jour',
  'profile.errorEnterName': 'Entrez votre nom',
  'profile.errorEnterCurrentPassword': 'Entrez le mot de passe actuel',
  'profile.errorMinPassword': 'Le nouveau mot de passe doit comporter au moins 6 caractères',
  'profile.errorPasswordMismatch': 'Les mots de passe ne correspondent pas',
  'profile.errorWrongPassword': 'Mot de passe actuel incorrect',
  'profile.errorTooMany': 'Trop de tentatives. Réessayez plus tard.',
  'profile.errorGeneric': 'Erreur : ',

  // ── Calendar page ──
  'cal.monthGen.0': 'janvier', 'cal.monthGen.1': 'février', 'cal.monthGen.2': 'mars',
  'cal.monthGen.3': 'avril', 'cal.monthGen.4': 'mai', 'cal.monthGen.5': 'juin',
  'cal.monthGen.6': 'juillet', 'cal.monthGen.7': 'août', 'cal.monthGen.8': 'septembre',
  'cal.monthGen.9': 'octobre', 'cal.monthGen.10': 'novembre', 'cal.monthGen.11': 'décembre',
  'cal.weekday.0': 'Dimanche', 'cal.weekday.1': 'Lundi', 'cal.weekday.2': 'Mardi',
  'cal.weekday.3': 'Mercredi', 'cal.weekday.4': 'Jeudi', 'cal.weekday.5': 'Vendredi', 'cal.weekday.6': 'Samedi',
  'cal.today': 'Aujourd\'hui',
  'cal.daySchedule': 'Planning du jour',
  'cal.appointments': 'rendez-vous',
  'cal.working': 'Travaille',
  'cal.dayOff': 'Jour de repos',
  'cal.noStaffWorking': 'Aucun employé ne travaille ce jour',
  'cal.clickToAdd': 'Cliquez sur l\'heure pour ajouter un rendez-vous',
  'cal.service': 'Service',
  'cal.paid': 'Payé',
  'cal.unpaid': 'Non payé',
  'cal.batchBooking': 'Réservation groupée',
  'cal.batchCreated': 'Rendez-vous créés',
  'cal.fiscalReceiptCreated': 'Reçu fiscal créé',
  'cal.fiscalReceiptError': 'Erreur de fiscalisation',
  'cal.refundRecorded': 'Remboursement enregistré',
  'cal.cannotDeletePaid': 'Impossible de supprimer un rendez-vous payé. Effectuez d\'abord un remboursement.',

  // ── Appointment modal ──
  'apt.newTitle': 'Nouveau rendez-vous',
  'apt.editTitle': 'Modifier le rendez-vous',
  'apt.closeEsc': 'Fermer (Esc)',
  'apt.client': 'Client',
  'apt.nameOrPhone': 'Nom ou téléphone',
  'apt.startTyping': 'Commencez à taper...',
  'apt.phone': 'Téléphone',
  'apt.viewProfile': 'Aller au profil',
  'apt.dateAndTime': 'Date et heure',
  'apt.date': 'Date',
  'apt.startTime': 'Début',
  'apt.endTime': 'Fin',
  'apt.servicesAndPayment': 'Services et paiement',
  'apt.pricelist': 'Tarifs',
  'apt.addService': 'Ajouter un service',
  'apt.standardPrice': 'Prix standard',
  'apt.tariffPlan': 'Plan tarifaire',
  'apt.min': 'min',
  'apt.discount': 'Remise',
  'apt.uah': 'UAH',
  'apt.total': 'Total',
  'apt.toPay': 'À payer',
  'apt.paymentMethod': 'Mode de paiement',
  'apt.cash': 'Espèces',
  'apt.terminal': 'Terminal',
  'apt.transfer': 'Virement',
  'apt.paid': 'Payé',
  'apt.clientGave': 'Le client a donné',
  'apt.change': 'Monnaie',
  'apt.note': 'Note',
  'apt.author': 'Auteur',
  'apt.notePlaceholder': 'Commentaire sur le rendez-vous...',
  'apt.notesPlaceholder': 'Commentaire sur le rendez-vous...',
  'apt.book': 'Réserver',
  'apt.saveChanges': 'Enregistrer les modifications',
  'apt.cancel': 'Annuler',
  'apt.delete': 'Supprimer',
  'apt.printBill': 'Devis',
  'apt.deleteTitle': 'Supprimer le rendez-vous ?',
  'apt.deleteMessage': 'Vous êtes sur le point de supprimer ce rendez-vous. Cette action est irréversible.',
  'apt.payBtn': 'Payer',
  'apt.confirmPayment': 'Confirmer le paiement ?',
  'apt.refund': 'Remboursement',
  'apt.refundTitle': 'Remboursement',
  'apt.refundMessage': 'Êtes-vous sûr de vouloir rembourser ce rendez-vous ?',
  'apt.refundWarning': 'Cette action est irréversible.',
  'apt.confirmRefund': 'Confirmer le remboursement',
  'apt.refunded': 'Remboursé',
  'apt.back': 'Retour',
  'apt.batchBooking': 'Réservation groupée',
  'apt.createMultiple': 'Créer plusieurs',
  'apt.materials': 'Matériaux',
  'apt.product': 'Produit',
  'apt.qty': 'Qté',
  'apt.pcs': 'pcs',
  'apt.add': 'Ajouter',
  'apt.noProductsAdded': 'Aucun produit ajouté',
  'apt.noProductsInStock': 'Aucun produit en stock',
  'apt.notEnough': 'Insuffisant',
  'apt.notEnoughInStock': 'Stock insuffisant',
  'apt.notEnoughStock': 'Stock insuffisant',
  'apt.appointmentNote': 'Note du rendez-vous',
  'apt.clientDocs': 'Documents du client',
  'apt.addDocument': 'Ajouter un document',
  'apt.docName': 'Nom du document',
  'apt.docNamePlaceholder': 'Entrez le nom...',
  'apt.docText': 'Texte du document',
  'apt.noDocsYet': 'Aucun document pour le moment',
  'apt.attachFile': 'Joindre un fichier',
  'apt.maxFileSize': 'Taille max. du fichier : 2 Mo',
  'apt.errClientName': 'Entrez le nom du client',
  'apt.errClientPhone': 'Entrez le téléphone du client',
  'apt.errDate': 'Sélectionnez une date',
  'apt.errDiscount': 'La remise ne peut pas dépasser le montant',
  'apt.errDayOff': 'Le spécialiste ne travaille pas ce jour',
  'apt.errOutsideWorkingHours': 'L\'heure est en dehors des heures de travail ({start} – {end})',
  'apt.errOverlap': 'L\'horaire chevauche le rendez-vous {start}–{end} ({client})',
  'apt.workingHoursHint': 'Heures de travail : {start} – {end}',
  'apt.statusWaiting': 'En attente',
  'apt.statusConfirmed': 'Terminé',
  'apt.statusArrived': 'Arrivé',
  'apt.statusNoShow': 'Absent',

  // ── Batch appointment modal ──
  'batchApt.title': 'Réservation groupée',
  'batchApt.subtitle': 'Création de plusieurs rendez-vous simultanément',
  'batchApt.closeEsc': 'Fermer (Esc)',
  'batchApt.client': 'Client',
  'batchApt.nameOrPhone': 'Nom ou téléphone',
  'batchApt.phone': 'Téléphone',
  'batchApt.staffMember': 'Praticien',
  'batchApt.service': 'Service',
  'batchApt.discount': 'Remise',
  'batchApt.uah': 'UAH',
  'batchApt.addDate': 'Ajouter une date',
  'batchApt.delete': 'Supprimer',
  'batchApt.entries': 'rendez-vous',
  'batchApt.entrySingle': 'rendez-vous',
  'batchApt.entryPlural': 'rendez-vous',
  'batchApt.create': 'Créer',
  'batchApt.cancel': 'Annuler',
  'batchApt.errClientName': 'Entrez le nom du client',
  'batchApt.errClientPhone': 'Entrez le téléphone du client',
  'batchApt.errDiscount': 'La remise ne peut pas dépasser le montant',
  'batchApt.errNoRows': 'Ajoutez au moins un rendez-vous',

  // ── Customer card ──
  'custCard.edit': 'Modifier',
  'custCard.delete': 'Supprimer',
  'custCard.book': 'Réserver',
  'custCard.order': 'Commande',
  'custCard.sell': 'Vendre',
  'custCard.sellProduct': 'Produit',
  'custCard.sellService': 'Service',
  'custCard.sellSubscription': 'Abonnement',
  'custCard.openFinances': 'Finances',
  'custCard.paid': 'Payé',
  'custCard.sold': 'Vendu',
  'custCard.balance': 'Solde',
  'custCard.importance': 'Importance',
  'custCard.forbidOnlineBooking': 'Réservation en ligne interdite',

  // ── Customer grid ──
  'custGrid.noCustomersFound': 'Aucun client trouvé',
  'custGrid.tryChangeSearch': 'Essayez de modifier la recherche ou le filtre de catégorie',

  // ── Customer modal ──
  'custModal.newCustomer': 'Nouveau client',
  'custModal.editCustomer': 'Modifier le client',
  'custModal.closeEsc': 'Fermer (Esc)',
  'custModal.tabMain': 'Principal',
  'custModal.tabDetails': 'Détails',
  'custModal.tabVisits': 'Visites',
  'custModal.tabFinancial': 'Finances',
  'custModal.tabAnalytics': 'Analytique',
  'custModal.tabNotes': 'Notes',
  'custModal.tabDocuments': 'Documents',
  'custModal.personalData': 'Données personnelles',
  'custModal.fullName': 'Nom et prénom',
  'custModal.fullNamePlaceholder': 'Entrez le nom complet',
  'custModal.mobilePhone': 'Téléphone mobile',
  'custModal.additionalPhone': 'Téléphone supplémentaire',
  'custModal.birthDate': 'Date de naissance',
  'custModal.day': 'Jour',
  'custModal.month': 'Mois',
  'custModal.year': 'Année',
  'custModal.gender': 'Genre',
  'custModal.genderMale': 'Masculin',
  'custModal.genderFemale': 'Féminin',
  'custModal.genderOther': 'Autre',
  'custModal.cardNumber': 'Numéro de carte',
  'custModal.profilePhoto': 'Photo de profil',
  'custModal.uploadPhoto': 'Télécharger une photo',
  'custModal.changePhoto': 'Changer la photo',
  'custModal.deletePhoto': 'Supprimer la photo',
  'custModal.avatar': 'Avatar',
  'custModal.categoryAndClassification': 'Catégorie et classification',
  'custModal.category': 'Catégorie',
  'custModal.importanceLabel': 'Importance',
  'custModal.discountLabel': 'Remise',
  'custModal.discountRange': '0–100%',
    'custModal.referral': 'Referral program',
  'custModal.referredBy': 'Referred by',
  'custModal.referredByHint': 'Select the client who referred this person',
'custModal.restrictions': 'Restrictions',
  'custModal.forbidOnlineBooking': 'Interdire la réservation en ligne',
  'custModal.forbidOnlineBookingDesc': 'Le client ne pourra pas réserver lui-même',
  'custModal.telegramReminders': 'Rappels Telegram',
  'custModal.telegramConnected': 'Telegram connecté',
  'custModal.setupTelegramBot': 'Configurez le bot Telegram',
  'custModal.sendLinkToCustomer': 'Envoyer le lien au client',
  'custModal.send': 'Envoyer',
  'custModal.sending': 'Envoi en cours...',
  'custModal.specifyPhoneFirst': 'Spécifiez d\'abord le téléphone',
  'custModal.save': 'Enregistrer',
  'custModal.cancel': 'Annuler',
  'custModal.close': 'Fermer',
  'custModal.editBtn': 'Modifier',
  'custModal.viewCustomer': 'Fiche client',
  'custModal.back': 'Retour',
  'custModal.next': 'Suivant',
  'custModal.nameRequired': 'Le nom est obligatoire',
  'custModal.phoneRequired': 'Le téléphone est obligatoire',
  'custModal.nameDuplicate': 'Un client avec ce nom existe déjà',
  'custModal.phoneDuplicate': 'Un client avec ce numéro de téléphone existe déjà',
  'custModal.note': 'Note',
  'custModal.notePlaceholder': 'Ajouter une note...',
  'custModal.comments': 'Commentaires',
  'custModal.commentsPlaceholder': 'Écrire un commentaire...',
  'custModal.writeMessagePlaceholder': 'Écrire un message...',
  // Customer modal — visits tab
  'custModal.visitHistory': 'Historique des visites',
  'custModal.totalVisits': 'Total des visites',
  'custModal.lastVisit': 'Dernière visite',
  'custModal.visitFrequency': 'Fréquence des visites',
  'custModal.days': 'j.',
  'custModal.visitsByMonth': 'Visites par mois',
  'custModal.noVisitsYet': 'Aucune visite pour le moment',
  'custModal.tabOrders': 'Achats',
  'custModal.orderHistory': 'Historique des commandes',
  'custModal.ordersTotal': 'Commandes',
  'custModal.ordersDelivered': 'Livrées',
  'custModal.ordersPaid': 'Payé',
  'custModal.noOrdersYet': 'Aucun achat pour le moment',
  'custModal.posSalesCount': 'Ventes',
  'custModal.orderStatusNew': 'Nouveau',
  'custModal.orderStatusConfirmed': 'Confirmé',
  'custModal.orderStatusPacked': 'Emballé',
  'custModal.orderStatusShipped': 'Expédié',
  'custModal.orderStatusDelivered': 'Livré',
  'custModal.orderStatusCancelled': 'Annulé',
  'custModal.posCompleted': 'Terminé',
  'custModal.posSourceLabel': 'Magasin',
  'custModal.orderSourceLabel': 'Commande',
  'custModal.subscriptionsLabel': 'Abonnements',
  'custModal.completed': 'Terminé',
  'custModal.noShow': 'Absent',
  'custModal.statusWaiting': 'En attente',
  'custModal.statusConfirmed': 'Terminé',
  'custModal.statusArrived': 'Arrivé',
  'custModal.statusNoShow': 'Absent',
  // Customer modal — financial tab
  'custModal.financialIndicators': 'Indicateurs financiers',
  'custModal.finPaid': 'Payé',
  'custModal.finBalance': 'Solde',
  'custModal.avgCheck': 'Ticket moyen',
  'custModal.ltv': 'LTV',
  'custModal.charges': 'Charges',
  'custModal.noChargesYet': 'Aucune charge pour le moment',
  'custModal.noPaymentsYet': 'Aucun paiement pour le moment',
  'custModal.date': 'Date',
  'custModal.dateTime': 'Date/heure',
  'custModal.service': 'Service',
  'custModal.serviceLabel': 'Service',
  'custModal.price': 'Prix',
  'custModal.discount': 'Remise',
  'custModal.total': 'Total',
  'custModal.paidLabel': 'Paiement',
  'custModal.payment': 'Paiement',
  'custModal.paymentMethod': 'Mode de paiement',
  'custModal.amount': 'Montant',
  'custModal.totalAmount': 'Montant total',
  'custModal.methodCash': 'Espèces',
  'custModal.methodCard': 'Carte',
  'custModal.methodTransfer': 'Virement',
  'custModal.cash': 'Espèces',
  'custModal.terminal': 'Terminal',
  'custModal.transfer': 'Virement',
  'custModal.online': 'En ligne',
  'custModal.refund': 'Remboursement',
  'custModal.sold': 'Vendu',
  'custModal.finCharged': 'Facturé',
  'custModal.serviceCharges': 'Frais de services',
  'custModal.productCharges': 'Frais de produits',
  'custModal.productLabel': 'Produit',
  'custModal.noProductChargesYet': 'Aucune vente de produits pour le moment',
  'custModal.time': 'Heure',
  'custModal.unknown': 'Inconnu',
  // Customer modal — analytics tab
  'custModal.favoriteMaster': 'Praticien préféré',
  'custModal.favoriteService': 'Service préféré',
  'custModal.favoriteProduct': 'Produit préféré',
  'custModal.lastActivity': 'Dernière activité',
  'custModal.spendingBreakdown': 'Répartition des dépenses',
  'custModal.purchasesByMonth': 'Achats par mois',
  'custModal.churn_low': 'Client actif',
  'custModal.churn_medium': 'Risque de désabonnement — absent depuis un moment',
  'custModal.churn_high': 'Risque élevé de désabonnement — contact nécessaire',
  // Customer modal — documents tab
  'custModal.customerDocuments': 'Documents du client',
  'custModal.addDocument': 'Ajouter un document',
  'custModal.addDoc': 'Ajouter',
  'custModal.addBtn': 'Ajouter',
  'custModal.noDocumentsYet': 'Aucun document pour le moment',
  'custModal.docName': 'Nom du document',
  'custModal.docNamePlaceholder': 'Entrez le nom...',
  'custModal.docNameRequired': 'Entrez le nom du document',
  'custModal.docText': 'Texte du document',
  'custModal.docTextPlaceholder': 'Entrez le texte...',
  'custModal.attachFile': 'Joindre un fichier',
  'custModal.fileUpTo2MB': 'Fichier jusqu\'à 2 Mo',
  'custModal.fileTooLarge': 'Fichier trop volumineux (max. 2 Mo)',
  'custModal.emptyDocument': 'Document vide',
  'custModal.deleteDoc': 'Supprimer le document',
  'custModal.deleteThisDoc': 'Supprimer ce document ?',
  'custModal.deleteBtn': 'Supprimer',
  'custModal.download': 'Télécharger',
  'custModal.copy': 'Copier',
  'custModal.specifyPhoneForDocs': 'Spécifiez le téléphone pour les documents',
  'custModal.loading': 'Chargement...',
  'custModal.error': 'Erreur',
  // Customer modal — month abbreviations
  'custModal.monthJan': 'Janvier', 'custModal.monthFeb': 'Février', 'custModal.monthMar': 'Mars',
  'custModal.monthApr': 'Avril', 'custModal.monthMay': 'Mai', 'custModal.monthJun': 'Juin',
  'custModal.monthJul': 'Juillet', 'custModal.monthAug': 'Août', 'custModal.monthSep': 'Septembre',
  'custModal.monthOct': 'Octobre', 'custModal.monthNov': 'Novembre', 'custModal.monthDec': 'Décembre',
  'custModal.monthAbbrJan': 'Jan', 'custModal.monthAbbrFeb': 'Fév', 'custModal.monthAbbrMar': 'Mar',
  'custModal.monthAbbrApr': 'Avr', 'custModal.monthAbbrMay': 'Mai', 'custModal.monthAbbrJun': 'Jui',
  'custModal.monthAbbrJul': 'Jul', 'custModal.monthAbbrAug': 'Aoû', 'custModal.monthAbbrSep': 'Sep',
  'custModal.monthAbbrOct': 'Oct', 'custModal.monthAbbrNov': 'Nov', 'custModal.monthAbbrDec': 'Déc',
  'custModal.monthShortJan': 'Jan', 'custModal.monthShortFeb': 'Fév', 'custModal.monthShortMar': 'Mar',
  'custModal.monthShortApr': 'Avr', 'custModal.monthShortMay': 'Mai', 'custModal.monthShortJun': 'Jui',
  'custModal.monthShortJul': 'Jul', 'custModal.monthShortAug': 'Aoû', 'custModal.monthShortSep': 'Sep',
  'custModal.monthShortOct': 'Oct', 'custModal.monthShortNov': 'Nov', 'custModal.monthShortDec': 'Déc',

  // ── Categories page ──
  'categories.title': 'Catégories clients',
  'categories.subtitle': 'Gestion des catégories et niveaux d\'importance',
  'categories.categoriesTab': 'Catégories',
  'categories.importanceTab': 'Importance',
  'categories.categoriesDesc': 'Regroupez les clients par types',
  'categories.importanceDesc': 'Définissez les niveaux d\'importance des clients',
  'categories.addCategory': 'Ajouter une catégorie',
  'categories.newCategory': 'Nouvelle catégorie',
  'categories.editCategory': 'Modifier la catégorie',
  'categories.noCategories': 'Aucune catégorie pour le moment',
  'categories.categoryName': 'Nom de la catégorie',
  'categories.name': 'Nom',
  'categories.namePlaceholder': 'Entrez le nom...',
  'categories.nameDuplicate': 'Une catégorie avec ce nom existe déjà',
  'categories.importanceDuplicate': 'Un niveau d\'importance avec ce nom existe déjà',
  'categories.icon': 'Icône',
  'categories.changeIcon': 'Changer l\'icône',
  'categories.chooseIcon': 'Choisir une icône',
  'categories.color': 'Couleur',
  'categories.bgColor': 'Couleur de fond',
  'categories.textColor': 'Couleur du texte',
  'categories.borderColor': 'Couleur de bordure',
  'categories.indicatorColor': 'Couleur de l\'indicateur',
  'categories.preview': 'Aperçu',
  'categories.save': 'Enregistrer',
  'categories.cancel': 'Annuler',
  'categories.delete': 'Supprimer',
  'categories.edit': 'Modifier',
  'categories.add': 'Ajouter',
  'categories.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
  'categories.hasCustomersBlocked': 'Cette catégorie contient des clients et ne peut pas être supprimée',
  'categories.yes': 'Oui',
  'categories.no': 'Non',
  'categories.addLevel': 'Ajouter un niveau',
  'categories.newImportanceLevel': 'Nouveau niveau d\'importance',
  'categories.editLevel': 'Modifier le niveau',
  'categories.noImportanceLevels': 'Aucun niveau d\'importance pour le moment',
  'categories.levelName': 'Nom du niveau',
  'categories.levelPlaceholder': 'Entrez le nom du niveau...',
  'categories.iconBusiness': 'Business',
  'categories.iconClients': 'Clients',
  'categories.iconNature': 'Nature',
  'categories.iconOther': 'Autre',
  'categories.iconStatus': 'Statut',
  'categories.iconSymbols': 'Symboles',

  // ── Staff page ──
  'staff.title': 'Employés',
  'staff.subtitle': 'Gestion du personnel',
  'staff.addStaff': 'Ajouter un employé',
  'staff.searchPlaceholder': 'Rechercher par nom, poste, téléphone...',
  'staff.activeStaff': 'Actifs',
  'staff.activeStaffDesc': 'employés',
  'staff.statusActive': 'Actif (afficher dans le calendrier)',
  'staff.statusActiveHidden': 'Actif (masquer du calendrier)',
  'staff.statusDismissed': 'Licencié',
  'staff.shown': 'Affiché',
  'staff.of': 'sur',
  'staff.total': 'total',
  'staff.notFound': 'Aucun employé trouvé',
  'staff.notFoundHint': 'Essayez de modifier la recherche',
  'staff.newStaff': 'Nouvel employé',
  'staff.editStaff': 'Modifier l\'employé',
  'staff.closeEsc': 'Fermer (Esc)',
  'staff.tabMain': 'Principal',
  'staff.tabDetails': 'Détails',
  'staff.tabServices': 'Services',
  'staff.tabSchedule': 'Planning',
  'staff.personalData': 'Données personnelles',
  'staff.fullName': 'Nom complet',
  'staff.fullNamePlaceholder': 'Entrez le nom complet',
  'staff.nameRequired': 'Le nom est obligatoire',
  'staff.nameDuplicate': 'Un employé avec ce nom existe déjà',
  'staff.phoneDuplicate': 'Un employé avec ce numéro de téléphone existe déjà',
  'staff.phone': 'Téléphone',
  'staff.position': 'Poste',
  'staff.positionPlaceholder': 'Entrez le poste...',
  'staff.status': 'Statut',
  'staff.active': 'Actif',
  'staff.profilePhoto': 'Photo de profil',
  'staff.uploadPhoto': 'Télécharger une photo',
  'staff.changePhoto': 'Changer la photo',
  'staff.avatar': 'Avatar',
  'staff.avatarColor': 'Couleur de l\'avatar',
  'staff.birthDate': 'Date de naissance',
  'staff.day': 'Jour',
  'staff.month': 'Mois',
  'staff.year': 'Année',
  'staff.address': 'Adresse',
  'staff.addressPlaceholder': 'Entrez l\'adresse...',
  'staff.note': 'Note',
  'staff.notePlaceholder': 'Ajouter une note...',
  'staff.salaryScheme': 'Schéma de rémunération',
  'staff.notSelected': 'Non sélectionné',
  'staff.locations': 'Emplacements',
  'staff.servicesEmpty': 'Aucun service attribué',
  'staff.servicesHint': 'Sélectionnez les services fournis par cet employé',
  'staff.priceUah': 'Prix (UAH)',
  'staff.uah': 'UAH',
  'staff.min': 'min',
  'staff.mins': 'min',
  'staff.workSchedule': 'Planning de travail',
  'staff.dayOff': 'Jour de repos',
  'staff.save': 'Enregistrer',
  'staff.saveChanges': 'Enregistrer les modifications',
  'staff.cancel': 'Annuler',
  'staff.back': 'Retour',
  'staff.next': 'Suivant',
  'staff.add': 'Ajouter',
  'staff.edit': 'Modifier',
  'staff.delete': 'Supprimer',
  'staff.deleteConfirmTitle': 'Supprimer l\'employé ?',
  'staff.deleteForever': 'Supprimer définitivement',
  'staff.hasAppointments': 'L\'employé a des rendez-vous et ne peut pas être supprimé',
  'staff.understood': 'Compris',
  'staff.scheduleConflict': 'Conflit de planning',
  'staff.dayMon': 'Lu', 'staff.dayTue': 'Ma', 'staff.dayWed': 'Me',
  'staff.dayThu': 'Je', 'staff.dayFri': 'Ve', 'staff.daySat': 'Sa', 'staff.daySun': 'Di',
  'staff.monthJan': 'Janvier', 'staff.monthFeb': 'Février', 'staff.monthMar': 'Mars',
  'staff.monthApr': 'Avril', 'staff.monthMay': 'Mai', 'staff.monthJun': 'Juin',
  'staff.monthJul': 'Juillet', 'staff.monthAug': 'Août', 'staff.monthSep': 'Septembre',
  'staff.monthOct': 'Octobre', 'staff.monthNov': 'Novembre', 'staff.monthDec': 'Décembre',

  // ── Schedule page ──
  'schedule.title': 'Planning de travail',
  'schedule.subtitle': 'Gestion des horaires des employés',
  'schedule.active': 'Actifs',
  'schedule.inactive': 'Inactifs',
  'schedule.staffMember': 'Employé',
  'schedule.hrsPerWeek': 'H/sem',
  'schedule.prevWeek': '← Semaine précédente',
  'schedule.nextWeek': 'Semaine suivante →',
  'schedule.current': 'Actuelle',
  'schedule.working': 'Travaille',
  'schedule.dayOff': 'Jour de repos',
  'schedule.noActiveStaff': 'Aucun employé actif',
  'schedule.noActiveStaffHint': 'Ajoutez des employés dans la section "Personnel"',
  'schedule.scheduleSettings': 'Paramètres du planning',
  'schedule.dayType': 'Type de jour',
  'schedule.workDay': 'Jour ouvré',
  'schedule.workHours': 'Heures de travail',
  'schedule.breaks': 'Pauses',
  'schedule.noBreaks': 'Aucune pause',
  'schedule.oneBreak': '1 pause',
  'schedule.nBreaks': 'pauses',
  'schedule.addBreak': 'Ajouter une pause',
  'schedule.deleteBreak': 'Supprimer la pause',
  'schedule.save': 'Enregistrer',
  'schedule.cancel': 'Annuler',
  'schedule.apply': 'Appliquer',
  'schedule.vacation': 'Vacances',
  'schedule.sickLeave': 'Arrêt maladie',
  'schedule.repeat1': '2 semaines (1 cycle)',
  'schedule.repeatN': '{n} semaines',
  'schedule.repeatWeekly': 'Hebdomadaire (année)',
  'schedule.templateAppliedWeeks': 'Modèle appliqué pour {n} semaines',
  'schedule.scheduleTemplate': 'Modèle de planning',
  'schedule.noTemplate': 'Sans modèle',
  'schedule.saveTwoWeeksTemplate': 'Enregistrer comme modèle (2 semaines)',
  'schedule.templateDuplicate': 'A template with this name already exists',
  'schedule.templateNamePlaceholder': 'Nom du modèle...',
  'schedule.scheduleConflict': 'Conflit de planning',
  'schedule.appointmentConflict': 'Impossible de modifier le planning : rendez-vous à {time} ({count} au total) en dehors des nouvelles heures de travail',
  'schedule.h': 'h',
  'schedule.hrs': 'h',
  'schedule.min': 'min',
  'schedule.dayMonFull': 'Lundi', 'schedule.dayTueFull': 'Mardi', 'schedule.dayWedFull': 'Mercredi',
  'schedule.dayThuFull': 'Jeudi', 'schedule.dayFriFull': 'Vendredi', 'schedule.daySatFull': 'Samedi', 'schedule.daySunFull': 'Dimanche',
  'schedule.dayMon': 'Lu', 'schedule.dayTue': 'Ma', 'schedule.dayWed': 'Me',
  'schedule.dayThu': 'Je', 'schedule.dayFri': 'Ve', 'schedule.daySat': 'Sa', 'schedule.daySun': 'Di',

  // ── Schedule templates page ──
  'schedTpl.title': 'Modèles de planning',
  'schedTpl.subtitle': 'Créez et gérez les modèles de planning',
  'schedTpl.templates': 'Modèles',
  'schedTpl.newTemplate': 'Nouveau modèle',
  'schedTpl.noTemplates': 'Aucun modèle pour le moment',
  'schedTpl.noTemplatesHint': 'Créez un modèle de planning pour une application rapide',
  'schedTpl.templateSettings': 'Paramètres du modèle',
  'schedTpl.templateNamePlaceholder': 'Nom du modèle...',
  'schedTpl.dayType': 'Type de jour',
  'schedTpl.workDay': 'Jour ouvré',
  'schedTpl.dayOff': 'Jour de repos',
  'schedTpl.vacation': 'Vacances',
  'schedTpl.sickLeave': 'Arrêt maladie',
  'schedTpl.workHours': 'Heures de travail',
  'schedTpl.breaks': 'Pauses',
  'schedTpl.noBreaks': 'Aucune pause',
  'schedTpl.addBreak': 'Ajouter une pause',
  'schedTpl.save': 'Enregistrer',
  'schedTpl.cancel': 'Annuler',
  'schedTpl.create': 'Créer',
  'schedTpl.delete': 'Supprimer',
  'schedTpl.rename': 'Renommer',
  'schedTpl.deleteTitle': 'Supprimer le modèle ?',
  'schedTpl.deleteMessage': 'Vous êtes sur le point de supprimer ce modèle. Cette action est irréversible.',
  'schedTpl.hPerWeek': 'h/sem',
  'schedTpl.hrs': 'h',
  'schedTpl.min': 'min',
  'schedTpl.workShort': 'Trav',
  'schedTpl.offShort': 'Repos',
  'schedTpl.week1': 'Semaine 1',
  'schedTpl.week2': 'Semaine 2',
  'schedTpl.dayMonFull': 'Lundi', 'schedTpl.dayTueFull': 'Mardi', 'schedTpl.dayWedFull': 'Mercredi',
  'schedTpl.dayThuFull': 'Jeudi', 'schedTpl.dayFriFull': 'Vendredi', 'schedTpl.daySatFull': 'Samedi', 'schedTpl.daySunFull': 'Dimanche',
  'schedTpl.dayMon': 'Lu', 'schedTpl.dayTue': 'Ma', 'schedTpl.dayWed': 'Me',
  'schedTpl.dayThu': 'Je', 'schedTpl.dayFri': 'Ve', 'schedTpl.daySat': 'Sa', 'schedTpl.daySun': 'Di',

  // ── Services page ──
  'services.title': 'Services',
  'services.subtitle': 'Catalogue des services',
  'services.servicesCount': 'Services',
  'services.groups': 'Groupes',
  'services.addService': 'Ajouter un service',
  'services.newGroup': 'Nouveau groupe',
  'services.emptyCatalog': 'Le catalogue de services est vide',
  'services.emptyCatalogHint': 'Ajoutez un groupe et des services',
  'services.noServicesInGroup': 'Aucun service dans ce groupe',
  'services.serviceName': 'Nom du service',
  'services.durationMin': 'Durée (min)',
  'services.durationMinError': 'La durée doit être supérieure à 0',
  'services.priceUah': 'Prix (UAH)',
  'services.priceNegativeError': 'Le prix ne peut pas être négatif',
  'services.nameDuplicate': 'Un service avec ce nom existe déjà',
  'services.groupDuplicate': 'Un groupe avec ce nom existe déjà',
  'services.min': 'min',
  'services.uah': 'UAH',
  'services.save': 'Enregistrer',
  'services.cancel': 'Annuler',
  'services.edit': 'Modifier',
  'services.delete': 'Supprimer',
  'services.renameGroup': 'Renommer le groupe',
  'services.deleteGroup': 'Supprimer le groupe',
  'services.deleteGroupTitle': 'Supprimer le groupe ?',
  'services.deleteGroupMessage': 'Tous les services de ce groupe seront également supprimés.',
  'services.deleteServiceTitle': 'Supprimer le service ?',
  'services.deleteServiceMessage': 'Cette action est irréversible.',
  'services.cannotDelete': 'Suppression impossible',
  'services.serviceHasAppointments': 'Ce service a des rendez-vous et ne peut pas être supprimé',
  'services.groupHasAppointments': 'Ce groupe contient des services avec des rendez-vous et ne peut pas être supprimé',
  'services.cannotDeleteGroupHasServices': 'Déplacez ou supprimez d\'abord les services de ce groupe',
  'services.deleteError': 'Échec de la suppression',
  'services.understood': 'Compris',

  // ── Tariff plans page ──
  'tariffs.title': 'Plans tarifaires',
  'tariffs.subtitle': 'Gestion des plans tarifaires',
  'tariffs.tariffsCount': 'Tarifs',
  'tariffs.addTariff': 'Ajouter un tarif',
  'tariffs.noTariffs': 'Aucun plan tarifaire',
  'tariffs.newTariffPlan': 'Nouveau plan tarifaire',
  'tariffs.editTariff': 'Modifier le tarif',
  'tariffs.tariffName': 'Nom du tarif',
  'tariffs.tariffNamePlaceholder': 'Entrez le nom du tarif...',
  'tariffs.nameDuplicate': 'Un tarif avec ce nom existe déjà',
  'tariffs.tariffType': 'Type de tarif',
  'tariffs.discount': 'Remise',
  'tariffs.surcharge': 'Supplément',
  'tariffs.noChange': 'Sans changement',
  'tariffs.priceModifierPercent': 'Modificateur de prix (%)',
  'tariffs.percentModifier': '% modificateur',
  'tariffs.modifier': 'Modificateur',
  'tariffs.modifierHint': 'Valeur négative — remise, positive — supplément',
  'tariffs.modifierPlaceholder': 'Par exemple : -10 ou +15',
  'tariffs.activeCheckbox': 'Actif',
  'tariffs.active': 'Actif',
  'tariffs.inactive': 'Inactif',
  'tariffs.tabServices': 'Services',
  'tariffs.tabProducts': 'Produits',
  'tariffs.servicePrices': 'Prix des services',
  'tariffs.customPriceServices': 'Prix personnalisés des services',
  'tariffs.customPriceProducts': 'Prix personnalisés des produits: {n}',
  'tariffs.productPrices': 'Prix des produits',
  'tariffs.productPricesHint': 'Recherchez et ajoutez des produits pour définir des prix promotionnels',
  'tariffs.searchProduct': 'Rechercher un produit par nom ou référence...',
  'tariffs.noCategory': 'Sans catégorie',
  'tariffs.priceList': 'Liste de prix',
  'tariffs.leaveEmptyDefault': 'Laissez vide pour le prix standard',
  'tariffs.uah': 'UAH',
  'tariffs.save': 'Enregistrer',
  'tariffs.create': 'Créer',
  'tariffs.cancel': 'Annuler',
  'tariffs.edit': 'Modifier',
  'tariffs.delete': 'Supprimer',
  'tariffs.deleteConfirm': 'Êtes-vous sûr de vouloir supprimer ce tarif ?',
  'tariffs.cannotDelete': 'Impossible de supprimer le tarif',
  'tariffs.appointmentsCount': 'rendez-vous',
  'tariffs.ordersCount': 'commandes',
  'tariffs.yes': 'Oui',
  'tariffs.no': 'Non',

  // ── Finances page ──
  'fin.title': 'Opérations financières',
  'fin.subtitle': 'Journal des paiements et remboursements',
  'fin.searchPlaceholder': 'Rechercher par client, téléphone, service...',
  'fin.period': 'Période',
  'fin.today': 'Aujourd\'hui',
  'fin.week': 'Semaine',
  'fin.month': 'Mois',
  'fin.from': 'du',
  'fin.to': 'au',
  'fin.allTime': 'Tout le temps',
  'fin.typeLabel': 'Type',
  'fin.all': 'Tous',
  'fin.payments': 'Paiements',
  'fin.refunds': 'Remboursements',
  'fin.type_all': 'Tous',
  'fin.type_payment': 'Paiement',
  'fin.type_refund': 'Remboursement',
  'fin.type_product_sale': 'Vente de produit',
  'fin.methodLabel': 'Mode de paiement',
  'fin.cash': 'Espèces',
  'fin.terminal': 'Terminal',
  'fin.transfer': 'Virement',
  'fin.online': 'En ligne',
  'fin.total': 'Total',
  'fin.uah': 'UAH',
  'fin.exportExcel': 'Exporter Excel',
  'fin.exportFileName': 'Opérations_financières',
  'fin.noOperations': 'Aucune opération',
  'fin.noOperationsHint': 'Essayez de modifier les filtres ou la période',
  'fin.colDate': 'Date',
  'fin.colClient': 'Client',
  'fin.colPhone': 'Téléphone',
  'fin.colService': 'Service',
  'fin.colMaster': 'Praticien',
  'fin.colType': 'Type',
  'fin.colPayMethod': 'Mode de paiement',
  'fin.colMethod': 'Méthode',
  'fin.colAmount': 'Montant',
  'fin.colSum': 'Montant',
  'fin.colAuthor': 'Auteur',
  'fin.colReceipt': 'Reçu',
  'fin.service': 'Service',
  'fin.receipt': 'Reçu',
  'fin.receiptNum': 'Reçu N°',
  'fin.receiptSubtitle': 'Reçu fiscal',
  'fin.receiptDate': 'Date',
  'fin.receiptClient': 'Client',
  'fin.receiptPhone': 'Téléphone',
  'fin.receiptMaster': 'Praticien',
  'fin.receiptMethod': 'Mode de paiement',
  'fin.receiptTotal': 'Montant',
  'fin.receiptThanks': 'Merci pour votre visite !',
  'fin.printReceipt': 'Imprimer le reçu',
  'fin.fiscalCode': 'Code fiscal',
  'fin.noFiscal': 'Sans fiscalisation',
  'fin.retryFiscal': 'Réessayer la fiscalisation',
  'fin.fiscalRetrySuccess': 'Fiscalisation réessayée avec succès',
  'fin.fiscalRetryError': 'Erreur de fiscalisation',

  // ── Cash register page ──
  'cashReg.title': 'Caisse',
  'cashReg.subtitle': 'Gestion des sessions de caisse',
  'cashReg.currentShift': 'Session en cours',
  'cashReg.openNewShift': 'Ouvrir une nouvelle session',
  'cashReg.openNewShiftHint': 'La session n\'est pas ouverte. Ouvrez une session pour accepter les paiements.',
  'cashReg.openingBalance': 'Solde d\'ouverture',
  'cashReg.openingBalanceLabel': 'Solde d\'ouverture de caisse',
  'cashReg.openShift': 'Ouvrir la session',
  'cashReg.closeShift': 'Fermer la session',
  'cashReg.prro': 'POS',
  'cashReg.processing': 'Traitement...',
  'cashReg.opened': 'Ouverte',
  'cashReg.closed': 'Fermée',
  'cashReg.openedAt': 'Ouverte à',
  'cashReg.openBal': 'Solde ouv.',
  'cashReg.closeBal': 'Solde ferm.',
  'cashReg.revenue': 'Chiffre d\'affaires',
  'cashReg.totalRevenue': 'Chiffre d\'affaires total',
  'cashReg.operations': 'Opérations',
  'cashReg.inRegister': 'En caisse',
  'cashReg.cash': 'Espèces',
  'cashReg.terminal': 'Terminal',
  'cashReg.transfer': 'Virement',
  'cashReg.uah': 'UAH',
  'cashReg.shift': 'Session',
  'cashReg.shiftLog': 'Journal des sessions',
  'cashReg.historyEmpty': 'L\'historique des sessions est vide',
  'cashReg.historyEmptyHint': 'Les sessions fermées apparaîtront ici',
  'cashReg.shiftOpened': 'Session ouverte',
  'cashReg.shiftClosed': 'Session fermée',
  'cashReg.checkboxNotConfigured': 'Pour utiliser la caisse, configurez la connexion Checkbox ПРРО dans Paramètres → Checkbox ПРРО',

  // ── Reports page ──
  'reports.reportType_cash_day': 'Revenus par période',
  'reports.reportType_work_hours': 'Heures de travail',
  'reports.reportType_services_sales': 'Ventes de services',
  'reports.reportType_mutual': 'Règlements avec les clients',
  'reports.reportType_inventory_flow': 'Flux de stock',
  'reports.reportType_client_analytics': 'Analytique clients',
  'reports.reportType_staff_revenue': 'Revenus par employé',
  'reports.reportType_service_profitability': 'Rentabilité des services',
  'reports.reportType_abc_analysis': 'Analyse ABC des produits',
  'reports.reportType_revenue_dynamics': 'Dynamique des revenus',
  'reports.reportType_discount_analytics': 'Analytique des remises',
  'reports.reportType_purchases_by_supplier': 'Achats par fournisseur',
  'reports.reportType_purchase_dynamics': 'Dynamique des achats',
  'reports.reportType_top_purchased_products': 'Top produits achetés',
  'reports.reportType_supplier_price_compare': 'Comparaison des prix fournisseurs',
  'reports.reportType_product_turnover': 'Rotation des produits',
  'reports.reportType_subscriptions': 'Abonnements',
  'reports.subsEmpty': 'Aucun abonnement pour la période sélectionnée',
  'reports.subsAll': 'Tous',
  'reports.subsActive': 'Actifs',
  'reports.subsNearExpiry': 'Près d\'expirer',
  'reports.subsNearExpiryHint': 'expirent dans <14 jours',
  'reports.subsExpired': 'Expirés',
  'reports.subsUsedUp': 'Épuisés',
  'reports.subsRefunded': 'Remboursés',
  'reports.subsRevenue': 'Revenus',
  'reports.subsSold': 'vendus',
  'reports.subsUnusedVisits': 'Visites non utilisées',
  'reports.subsUnusedHint': 'dans actifs + expirés',
  'reports.subsPurchaseDate': 'Date d\'achat',
  'reports.subsPlan': 'Plan',
  'reports.subsBoughtVisits': 'Achetées',
  'reports.subsUsage': 'Utilisation',
  'reports.subsPaid': 'Payé',
  'reports.subsValidUntil': 'Valide jusqu\'à',
  'reports.subsStatus': 'Statut',
  'reports.reportType_no_shows': 'Analyse des absences',
  'reports.nsEmpty': 'Aucun rendez-vous pour la période sélectionnée',
  'reports.nsTotal': 'Total rendez-vous',
  'reports.nsNoShow': 'Absence',
  'reports.nsCancelled': 'Annulés',
  'reports.nsLostRevenue': 'Revenus perdus',
  'reports.nsRepeatOffenders': 'Récidivistes (≥2 absences)',
  'reports.nsByStaff': 'Par personnel',
  'reports.nsByService': 'Par service (top-15 problématiques)',
  'reports.nsNoShowPct': '% Absence',
  'reports.nsCancelPct': '% Annulation',
  'reports.nsRepeatOffendersTitle': 'Clients récidivistes',
  'reports.nsRepeatOffendersHint': '≥2 absences dans la période',
  'reports.nsLastNoShow': 'Dernière absence',
  'reports.reportType_service_profitability': 'Rentabilité des services',
  'reports.reportType_payment_methods': 'Modes de paiement',
  'reports.reportType_sales_by_channel': 'Ventes par canal',
  'reports.reportType_customer_ltv': 'LTV / Clients VIP',
  'reports.profitEmpty': 'Aucun service pour la période',
  'reports.profitRevenue': 'Revenus',
  'reports.profitCost': 'Coût',
  'reports.profitGross': 'Bénéfice',
  'reports.profitMargin': 'Marge',
  'reports.profitVisits': 'Visites',
  'reports.group': 'Groupe',
  'reports.visits': 'Visites',
  'reports.pmEmpty': 'Aucune transaction pour la période',
  'reports.tryChangeDate': 'Essayez de changer la période',
  'reports.pmMethod': 'Méthode',
  'reports.pmCount': 'Transactions',
  'reports.pmAmount': 'Montant',
  'reports.pmShare': 'Part',
  'reports.pmTotalTx': 'Transactions',
  'reports.pmMethodsCount': 'Méthodes utilisées',
  'reports.pmCash': 'Espèces',
  'reports.pmTerminal': 'Terminal',
  'reports.pmOnline': 'En ligne',
  'reports.pmTransfer': 'Virement',
  'reports.pmSubscription': 'Abonnement',
  'reports.pmGiftCard': 'Carte cadeau',
  'reports.pmPoints': 'Points fidélité',
  'reports.pmUnknown': 'Non spécifié',
  'reports.ltvEmpty': 'Aucun client pour la période',
  'reports.ltvCustomers': 'Clients',
  'reports.ltvTotalRevenue': 'Revenus totaux',
  'reports.ltvAvgTicket': 'Ticket moyen',
  'reports.ltvVip': 'Clients VIP (top 20%)',
  'reports.ltvSleepingVip': 'VIP dormants',
  'reports.ltvSleepingHint': '>60 jours sans visite',
  'reports.ltvTotal': 'Total',
  'reports.ltvLastVisit': 'Dernière visite',
  'reports.ltvSleepingBadge': '😴 VIP dormant',
  'reports.ltvVipBadge': '👑 VIP',
  'reports.reportType_salary_archive': 'Archives des salaires',
  'reports.reportType_salary_efficiency': 'Efficacité du personnel (ROI)',
  'reports.reportType_salary_ratio': 'Ratio salaires / revenus',
  'reports.salaryArchiveEmpty': 'Pas encore d\'enregistrements de salaire',
  'reports.salaryArchiveEmptyHint': 'Calculez le salaire dans "Calcul des salaires" — il apparaîtra ici.',
  'reports.salaryArchiveMonth': 'Mois',
  'reports.salaryArchiveSavedAt': 'Enregistré',
  'reports.salaryFund': 'Fonds total',
  'reports.salaryStaffCount': 'Personnel',
  'reports.salaryAvg': 'Moyenne',
  'reports.salaryRevenue': 'Revenus du mois',
  'reports.salaryScheme': 'Schéma',
  'reports.salaryByRules': 'Selon règles',
  'reports.salaryAdjustments': 'Ajustements',
  'reports.salaryEffEmpty': 'Pas de salaires calculés pour la période',
  'reports.salaryEffEmptyHint': 'Essayez une période où les salaires sont déjà calculés.',
  'reports.salaryEffRevenue': 'Revenus',
  'reports.salaryEffSalary': 'Salaire',
  'reports.salaryEffProfit': 'Marge',
  'reports.salaryEffAvgRoi': 'ROI moyen',
  'reports.salaryEffRoiHint': '>3 sain, <1.5 problème',
  'reports.salaryRatioEmpty': 'Pas d\'historique des salaires',
  'reports.salaryRatioCurrent': 'Ratio actuel',
  'reports.salaryRatioAvg': 'Moyenne de la période',
  'reports.salaryRatioTrend': 'Changement vs mois précédent',
  'reports.salaryRatioHealthy': 'Plage saine',
  'reports.salaryRatioHealthyHint': 'pour secteur beauté',
  'reports.salaryRatioPct': 'Ratio',
  'reports.loading': 'Chargement…',
  'reports.reportType_sales_managers': 'Responsables de vente',
  'reports.smEmpty': 'Aucune commande pour la période sélectionnée',
  'reports.smUnknown': '— Non spécifié',
  'reports.smManagersCount': 'Responsables',
  'reports.smOrdersCreated': 'Commandes créées',
  'reports.smDelivered': 'Livrées',
  'reports.smNetRevenue': 'Revenus nets',
  'reports.smAvgCheck': 'Ticket moyen',
  'reports.smManager': 'Responsable',
  'reports.smCreated': 'Créées',
  'reports.smCancelled': 'Annulées',
  'reports.smReturned': 'Retours',
  'reports.smCancelRate': '% Annulation',
  'reports.smReturnRate': '% Retour',
  'reports.smAvgTime': 'Jours à livraison',
  'reports.reportType_admin_activity': 'Activité des administrateurs',
  'reports.aaEmpty': 'Aucune activité createdBy pour la période',
  'reports.aaAdmins': 'Admins actifs',
  'reports.aaTotalApts': 'RDV créés',
  'reports.aaTotalProcessed': 'Argent traité',
  'reports.aaSubsRevenue': 'Revenus abonnements',
  'reports.aaAdmin': 'Admin',
  'reports.aaApts': 'RDV',
  'reports.aaConfirmed': 'Confirm.',
  'reports.aaNoShowPct': '% Absence',
  'reports.aaTx': 'Tx',
  'reports.aaProcessed': 'Montant',
  'reports.aaSubsSold': 'Abonn.',
  'reports.aaSubsRev': 'Abonn. ₴',
  'reports.aaDiscounts': 'Remises ₴',
  'reports.groupSales': 'Revenus et ventes',
  'reports.groupCustomers': 'Clients',
  'reports.groupStaff': 'Personnel et salaires',
  'reports.groupLoyalty': 'Fidélité et promos',
  'reports.groupInventory': 'Stock',
  'reports.groupProcurement': 'Achats',
  'reports.reportType_loyalty_points': 'Points de fidélité',
  'reports.reportType_coupons': 'Coupons',
  'reports.lpEmpty': 'Aucune activité de fidélité pour la période',
  'reports.lpEarned': 'Crédités',
  'reports.lpRedeemed': 'Utilisés',
  'reports.lpReversed': 'Annulés',
  'reports.lpReversedHint': 'remboursements / annulations',
  'reports.lpNet': 'Net pour la période',
  'reports.lpSourcesTitle': 'Origine des points',
  'reports.lpSource': 'Origine',
  'reports.lpPoints': 'Points',
  'reports.lpShare': 'Part',
  'reports.lpRefService': 'Services',
  'reports.lpRefProduct': 'Produits',
  'reports.lpRefOrder': 'Commandes',
  'reports.lpRefReferral': 'Parrainage',
  'reports.lpRefBirthday': 'Anniversaire',
  'reports.lpRefManual': 'Manuel',
  'reports.lpRefSubscription': 'Abonnement',
  'reports.lpRefOther': 'Autre',
  'reports.cpEmpty': 'Vous n\'avez pas encore de coupons',
  'reports.cpEmptyHint': 'Ajoutez des coupons dans Fidélité pour voir les stats.',
  'reports.cpTotal': 'Total des coupons',
  'reports.cpUsedInPeriod': 'Utilisés sur la période',
  'reports.cpDiscount': 'Remise accordée',
  'reports.cpOrderAmount': 'Revenus avec coupons',
  'reports.cpCode': 'Code',
  'reports.cpType': 'Type',
  'reports.cpValue': 'Valeur',
  'reports.cpUsage': 'Utilisé',
  'reports.cpInPeriod': 'Sur la période',
  'reports.cpOrderSum': 'Revenus ₴',
  'reports.cpStatus': 'Statut',
  'reports.cpStatusActive': 'Actif',
  'reports.cpStatusExpired': 'Expiré',
  'reports.cpStatusExhausted': 'Épuisé',
  'reports.cpStatusDisabled': 'Désactivé',
  'reports.reportType_production_runs': 'Production',
  'reports.reportType_cash_shifts_report': 'Sessions de caisse',
  'reports.reportType_heatmap_dow_hour': 'Carte thermique jour × heure',
  'reports.prEmpty': 'Aucune production sur la période',
  'reports.prRuns': 'Lots',
  'reports.prCancelled': 'annulés',
  'reports.prOutputQty': 'Quantité produite',
  'reports.prInputCost': 'Coût des matières',
  'reports.prAvgUnitCost': 'Coût moyen unité',
  'reports.prRecipe': 'Recette',
  'reports.csEmpty': 'Aucune session de caisse sur la période',
  'reports.csEmptyHint': 'Les sessions sont synchronisées avec Checkbox.',
  'reports.csShifts': 'Sessions',
  'reports.csCash': 'Espèces',
  'reports.csCard': 'Carte',
  'reports.csAvgDuration': 'Durée moyenne',
  'reports.csDiscrep': 'Avec écart',
  'reports.csOpened': 'Ouverte',
  'reports.csClosed': 'Fermée',
  'reports.csLocation': 'Lieu',
  'reports.csOpenBal': 'Début ₴',
  'reports.csCloseBal': 'Fin ₴',
  'reports.csDiff': 'Δ',
  'reports.csOpen': 'Ouverte',
  'reports.hmEmpty': 'Aucun rendez-vous sur la période',
  'reports.hmTotal': 'Total RDV',
  'reports.hmPeak': 'Heure de pointe',
  'reports.hmTopDay': 'Jour top',
  'reports.hmRecords': 'rendez-vous',
  'reports.hmLow': 'Bas',
  'reports.hmMedium': 'Moyen',
  'reports.hmHigh': 'Élevé',
  'reports.hmPeakLegend': 'Pic',
  'reports.dowMon': 'Lun',
  'reports.dowTue': 'Mar',
  'reports.dowWed': 'Mer',
  'reports.dowThu': 'Jeu',
  'reports.dowFri': 'Ven',
  'reports.dowSat': 'Sam',
  'reports.dowSun': 'Dim',
  'reports.period_day': 'Jour',
  'reports.period_week': 'Semaine',
  'reports.period_month': 'Mois',
  'reports.period_year': 'Année',
  'reports.period_custom': 'Personnalisé',
  'period.today': "Aujourd'hui",
  'period.yesterday': 'Hier',
  'period.thisWeek': 'Cette semaine',
  'period.lastWeek': 'Semaine dernière',
  'period.thisMonth': 'Ce mois',
  'period.lastMonth': 'Mois dernier',
  'period.thisQuarter': 'Ce trimestre',
  'period.thisYear': 'Cette année',
  'period.last30': '30 derniers jours',
  'period.last90': '90 derniers jours',
  'period.custom': 'Personnalisé',
  'reports.title': 'Rapports',
  'reports.subtitle': 'Analytique et rapports',
  'reports.allStaff': 'Tous les employés',
  'reports.allClients': 'Tous les clients',
  'reports.allCategories': 'Toutes les catégories',
  'reports.allProducts': 'Tous les produits',
  'reports.allLocations': 'Tous les emplacements',
  'reports.appointments': 'Rendez-vous',
  'reports.clients': 'Clients',
  'reports.masters': 'Praticiens',
  'reports.revenue': 'Chiffre d\'affaires',
  'reports.service': 'Service',
  'reports.serviceOrProduct': 'Produit/Service',
  'reports.client': 'Client',
  'reports.master': 'Praticien',
  'reports.date': 'Date',
  'reports.dateTime': 'Date/heure',
  'reports.time': 'Heure',
  'reports.duration': 'Durée',
  'reports.price': 'Prix',
  'reports.discount': 'Remise',
  'reports.paid': 'Payé',
  'reports.payment': 'Paiement',
  'reports.method': 'Méthode',
  'reports.cash': 'Espèces',
  'reports.online': 'En ligne',
  'reports.total': 'Total',
  'reports.grandTotal': 'Total général',
  'reports.sum': 'Montant',
  'reports.position': 'Position',
  'reports.positions': 'positions',
  'reports.product': 'Produit',
  'reports.category': 'Catégorie',
  'reports.qty': 'Qté',
  'reports.pcs': 'pcs',
  'reports.cost': 'Coût de revient',
  'reports.balance': 'Solde',
  'reports.debt': 'Dette',
  'reports.charges': 'Charges',
  'reports.productCharges': 'Charges produits',
  'reports.serviceRefunds': 'Remboursements services',
  'reports.subscriptionVisit': 'Visite par abonnement',
  'reports.charged': 'Facturé',
  'reports.visits': 'Visites',
  'reports.days': 'j.',
  'reports.hrs': 'h',
  'reports.min': 'min',
  'reports.avgCheck': 'Ticket moyen',
  'reports.avgDuration': 'Durée moyenne',
  'reports.totalClients': 'Total clients',
  'reports.totalHours': 'Total heures',
  'reports.servicesSold': 'Services fournis',
  'reports.withDiscount': 'Avec remise',
  'reports.utilization': 'Taux d\'occupation',
  'reports.worked': 'Travaillé',
  'reports.workingHours': 'Heures de travail',
  'reports.noVisitDays': 'Jours sans visite',
  'reports.forOrder': 'Pour commande',
  'reports.mainRegister': 'Caisse principale',
  'reports.settlementAccount': 'Compte courant',
  'reports.other': 'Autre',
  'reports.incoming': 'Entrées',
  'reports.incomingQty': 'Nombre d\'entrées',
  'reports.incomingSum': 'Montant des entrées',
  'reports.incomings': 'Entrées',
  'reports.writeoff': 'Radiation',
  'reports.writeoffsExpenses': 'Radiations/dépenses',
  'reports.writtenOff': 'Radié',
  'reports.writtenOffQty': 'Nombre de radiations',
  'reports.writtenOffSum': 'Montant des radiations',
  'reports.remainQty': 'Qté restante',
  'reports.remainSum': 'Montant restant',
  'reports.transferMove': 'Transfert',
  'reports.together': 'Ensemble',
  'reports.exportExcel': 'Exporter vers Excel',
  'reports.exportPdf': 'Imprimer / PDF',
  'reports.print': 'Imprimer',
  'reports.noService': 'Sans service',
  'reports.noDataForPeriod': 'Aucune donnée pour la période sélectionnée',
  'reports.noCompletedForPeriod': 'Aucun rendez-vous terminé pour la période sélectionnée',
  'reports.noRecordsForPeriod': 'Aucun enregistrement pour la période sélectionnée',
  'reports.noInventoryForPeriod': 'Aucune donnée de stock pour la période sélectionnée',
  'reports.segment_all': 'Tous',
  'reports.segment_no30': 'Absents 30+ jours',
  'reports.segment_new': 'Nouveaux',
  'reports.segment_vip': 'VIP',
  'reports.segment_once': 'Une seule fois',
  'reports.segment_services_only': 'Services seuls',
  'reports.segment_products_only': 'Produits seuls',
  'reports.productContactsCol': 'Com. prod.',
  'reports.serviceContactsCol': 'Com. serv.',
  'reports.servicesIncome': 'Services ₴',
  'reports.productsIncome': 'Produits ₴',
  'reports.lastContact': 'Dern. contact',
  'reports.operations': 'Opérations',
  'reports.noClientsInSegment': 'Aucun client dans ce segment',
  'reports.tryChangeDateOrStaff': 'Essayez de changer la date ou l\'employé',
  'reports.tryChangeDateOrFilters': 'Essayez de changer la date ou les filtres',
  'reports.tryChangeDateOrClient': 'Essayez de changer la date ou le client',
  'reports.servicesRevenue': 'Revenus des services',
  'reports.productSales': 'Ventes de produits',
  'reports.totalRevenue': 'Revenu total',
  'reports.share': 'Part',
  'reports.materialCosts': 'Coûts des matériaux',
  'reports.margin': 'Marge',
  'reports.abcClass': 'Classe',
  'reports.abcLeaders': 'leaders',
  'reports.abcMiddle': 'moyens',
  'reports.abcSlow': 'faible rotation',
  'reports.avgPerDay': 'Moy. par jour',
  'reports.discountCount': 'Nombre de remises',
  'reports.discountSum': 'Montant des remises',
  'reports.discountShare': 'Part des remises',
  'reports.noDiscountsForPeriod': 'Aucune remise pour la période sélectionnée',
  'reports.grossPrice': 'Prix brut',
  'reports.avgDiscount': 'Remise moy.',
  'reports.supplier': 'Fournisseur',
  'reports.allSuppliers': 'Tous les fournisseurs',
  'reports.suppliersCount': 'Fournisseurs',
  'reports.invoices': 'Factures',
  'reports.avgPrice': 'Prix moy.',
  'reports.noPurchasesForPeriod': 'Aucun achat pour la période sélectionnée',
  'reports.productUnits': 'Unités de produit',
  'reports.invoiceCount': 'Nb. factures',
  'reports.netto': 'Net',
  'reports.peakDay': 'Pic',
  'reports.purchases': 'Achats',
  'reports.categories': 'Catégories',
  'reports.remainder': 'Restant',
  'reports.ordered': 'Commandé',
  'reports.returned': 'Retourné',
  'reports.received': 'Reçu',
  'reports.productsCompared': 'Produits comparés',
  'reports.noPriceComparison': 'Aucune donnée de comparaison',
  'reports.needMultipleSuppliers': 'Achats d\'un produit auprès de différents fournisseurs nécessaires',
  'reports.turnoverRatio': 'Rotation',
  'reports.turnoverStatus': 'Statut',
  'reports.highTurnover': 'Élevée',
  'reports.medTurnover': 'Moyenne',
  'reports.lowTurnover': 'Faible',

  // ── Financial result page ──
  'finResult.month_jan': 'Janvier', 'finResult.month_feb': 'Février', 'finResult.month_mar': 'Mars',
  'finResult.month_apr': 'Avril', 'finResult.month_may': 'Mai', 'finResult.month_jun': 'Juin',
  'finResult.month_jul': 'Juillet', 'finResult.month_aug': 'Août', 'finResult.month_sep': 'Septembre',
  'finResult.month_oct': 'Octobre', 'finResult.month_nov': 'Novembre', 'finResult.month_dec': 'Décembre',
  'finResult.sourceDeleted': 'Ce document a été supprimé du système',
  'finResult.title': 'Résultat financier',
  'finResult.subtitle': 'Analyse des revenus et dépenses',
  'finResult.allLocations': 'Tous les emplacements',
  'finResult.income': 'Revenu',
  'finResult.incomes': 'Revenus',
  'finResult.expenses': 'Dépenses',
  'finResult.financialResult': 'Résultat financier',
  'finResult.profitability': 'Rentabilité',
  'finResult.sales': 'Ventes',
  'finResult.servicesCompleted': 'Services fournis',
  'finResult.productSales': 'Ventes de produits',
  'finResult.orderProductSales': 'Ventes de produits (expéditions)',
  'finResult.posProductSales': 'Ventes de produits (POS / magasin)',
  'finResult.aptProductSales': 'Ventes de produits dans les services',
  'finResult.subscriptions': 'Abonnements',
  'finResult.refunds': 'remboursements',
  'finResult.cogsOrders': 'Coût — expéditions',
  'finResult.cogsAppointments': 'Coût — services',
  'finResult.cogsPos': 'Coût — magasin',
  'finResult.cogsWriteoffs': 'Coût des autres sorties',
  'finResult.orders': 'Commandes',
  'finResult.visits': 'Visites',
  'finResult.salaries': 'Salaires',
  'finResult.addExpense': 'Ajouter une dépense',
  'finResult.otherIncome': 'Autres revenus',
  'finResult.addOtherIncome': 'Ajouter un autre revenu',
  'finResult.incomeName': 'Nom du revenu',
  'finResult.deleteIncomeConfirm': 'Supprimer ce revenu ?',
  'finResult.exportExcel': 'Exporter vers Excel',
  'finResult.add': 'Ajouter',
  'finResult.cancel': 'Annuler',
  'finResult.delete': 'Supprimer',
  'finResult.expenseName': 'Nom de la dépense',
  'finResult.expenseSum': 'Montant',
  'finResult.monthly': 'Mensuel',
  'finResult.monthlyOption': 'Mensuelle',
  'finResult.oneTime': 'Ponctuelle',
  'finResult.oneTimeOption': 'Ponctuelle',
  'finResult.deleteExpenseTitle': 'Supprimer la dépense ?',
  'finResult.deleteExpenseConfirm': 'Êtes-vous sûr de vouloir supprimer cette dépense ?',
  'finResult.notCalculated': 'Non calculé',
  'finResult.print': 'Imprimer',
  'finResult.printPdf': 'Imprimer PDF',
  'finResult.dynamics6months': 'Dynamique sur 6 mois',
  'finResult.expenseStructure': 'Structure des dépenses',
  'finResult.incomeStructure': 'Structure des revenus',
  'finResult.donutServices': 'Services',
  'finResult.donutProducts': 'Produits',
  'finResult.noIncomeYet': 'Aucun revenu ce mois-ci',
  'finResult.salaryFundTitle': 'Structure du fonds salarial',
  'finResult.salaryNotCalculated': 'Les salaires de ce mois ne sont pas encore calculés',
  'finResult.salaryNoData': 'Aucune donnée à afficher',
  'finResult.fundSalary': 'Salaire fixe',
  'finResult.fundPercent': 'Pourcentage',
  'finResult.fundHybrid': 'Par action',
  'finResult.vsPrev': 'vs préc.',
  'finResult.cashFlowTitle': 'Flux de trésorerie (par jour)',
  'finResult.cashFlowEmpty': 'Aucune transaction ce mois-ci',
  'finResult.cashFlowReceipts': 'Encaissements',
  'finResult.cashFlowRefunds': 'Remboursements',
  'finResult.cashFlowNet': 'Flux net',
  'finResult.groupCogsProducts': 'Coût des marchandises',
  'finResult.groupSalaries': 'Salaires',
  'finResult.groupFixed': 'Frais fixes',
  'finResult.groupOther': 'Annulations & autres',
  'finResult.noExpensesYet': 'Pas encore de dépenses ce mois-ci',
  'finResult.effectiveFrom': 'En vigueur dès',
  'finResult.edit': 'Modifier',
  'finResult.save': 'Enregistrer',
  'finResult.applyForwardOnly': 'Appliquer uniquement à partir du mois choisi (conserver l\'ancien montant pour les mois passés)',
  'finResult.total': 'Total',
  'finResult.hintAddNew': 'La dépense s\'appliquera à partir de {month} (jusqu\'à modification).',
  'finResult.hintMutateSingle': 'Le montant sera mis à jour pour : {month}',
  'finResult.hintMutateRange': 'Le montant sera mis à jour pour : {from} — {to}',
  'finResult.hintMutateForward': 'Le montant sera mis à jour pour : {month} et tous les mois suivants',
  'finResult.hintSplit': 'Une nouvelle version sera créée à partir de {newMonth}. Les mois précédents ({oldFrom} — {oldTo}) conserveront {oldAmount} ₴.',

  // ── Inventory products page ──
  'invProd.title': 'Produits',
  'invProd.subtitle': 'Gestion des produits, catégories et entrepôts',
  'invProd.tabProducts': 'Produits',
  'invProd.tabCategories': 'Catégories',
  'invProd.tabWarehouses': 'Entrepôts',
  'invProd.statProducts': 'Produits',
  'invProd.statCategories': 'Catégories',
  'invProd.statWarehouses': 'Entrepôts',
  'invProd.productsCount': 'Produits',
  'invProd.positionsCount': 'Positions',
  'invProd.searchPlaceholder': 'Rechercher par nom, référence...',
  'invProd.allCategories': 'Toutes les catégories',
  'invProd.addProduct': 'Ajouter un produit',
  'invProd.newProduct': 'Nouveau produit',
  'invProd.editProduct': 'Modifier le produit',
  'invProd.emptyProducts': 'Aucun produit pour le moment',
  'invProd.emptyProductsHint': 'Ajoutez le premier produit',
  'invProd.emptyCategories': 'Créez votre première catégorie de produits',
  'invProd.emptyCategoriesHint': 'Les catégories aident à organiser les produits et à trouver rapidement ce dont vous avez besoin',
  'invProd.emptyWarehouses': 'Ajoutez votre premier entrepôt',
  'invProd.emptyWarehousesHint': 'Les entrepôts sont nécessaires pour suivre les stocks et effectuer les achats',
  'invProd.colName': 'Nom',
  'invProd.colSku': 'Référence',
  'invProd.colCategory': 'Catégorie',
  'invProd.colUnit': 'Unité',
  'invProd.colStock': 'Stock',
  'invProd.colMin': 'Min.',
  'invProd.colSellPrice': 'Prix de vente',
  'invProd.labelName': 'Nom',
  'invProd.labelSku': 'Référence',
  'invProd.labelCategory': 'Catégorie',
  'invProd.labelUnit': 'Unité de mesure',
  'invProd.labelMinStock': 'Stock min.',
  'invProd.labelSellPrice': 'Prix de vente',
  'invProd.labelImageUrl': "URL de l'image",
  'invProd.labelImage': 'Photo du produit',
  'invProd.uploadImage': 'Télécharger photo',
  'invProd.maxSize': "jusqu'à 200 Ko",
  'invProd.pasteUrl': 'Ou coller URL',
  'invProd.noCategory': 'Sans catégorie',
  'invProd.unitPcs': 'pcs',
  'invProd.unitG': 'g',
  'invProd.unitKg': 'kg',
  'invProd.unitMl': 'ml',
  'invProd.unitL': 'l',
  'invProd.unitPack': 'paq',
  'invProd.save': 'Enregistrer',
  'invProd.cancel': 'Annuler',
  'invProd.publishOnOlx': 'Publier sur OLX',
  'invProd.olxPublished': 'OLX : annonce créée',
  'olxPublish.title': 'Publication sur OLX',
  'olxPublish.fieldTitle': 'Titre de l\'annonce',
  'olxPublish.fieldDescription': 'Description',
  'olxPublish.descriptionHint': 'OLX exige généralement ~80+ caractères. Décris l\'article, son état, ses détails.',
  'olxPublish.fieldCategory': 'Catégorie',
  'olxPublish.suggesting': 'Recherche d\'une catégorie d\'après le titre…',
  'olxPublish.noCategorySuggestions': 'Impossible de suggérer une catégorie. Précise le titre ou entre l\'ID ci-dessous.',
  'olxPublish.orManualCategoryId': 'ou entre l\'ID de catégorie OLX',
  'olxPublish.fieldCity': 'Ville',
  'olxPublish.cityPlaceholder': 'Commence à taper, ex. « Kyiv »',
  'olxPublish.searching': 'Recherche…',
  'olxPublish.fieldPrice': 'Prix',
  'olxPublish.fieldPhotoUrl': 'URL de la photo',
  'olxPublish.fieldContactName': 'Nom du contact',
  'olxPublish.contactNamePlaceholder': 'Comment signer l\'annonce',
  'olxPublish.fieldContactPhone': 'Téléphone',
  'olxPublish.errorTitle': 'OLX a renvoyé une erreur :',
  'olxPublish.showRawError': 'Afficher la réponse complète d\'OLX',
  'olxPublish.categoryAttrsTitle': 'OLX exige des champs supplémentaires pour cette catégorie :',
  'olxPublish.loadingAttrs': 'Chargement des champs de la catégorie…',
  'olxPublish.choose': 'choisir',
  'olxPublish.fieldDistrict': 'Quartier',
  'olxPublish.loadingDistricts': 'Chargement des quartiers de la ville…',
  'olxPublish.success': 'Annonce créée, envoyée à la modération OLX',
  'olxPublish.cancel': 'Annuler',
  'olxPublish.publish': 'Publier',
  'invProd.add': 'Ajouter',
  'invProd.delete': 'Supprimer',
  'invProd.deleteProduct': 'Supprimer le produit',
  'invProd.deleteCategory': 'Supprimer la catégorie',
  'invProd.deleteWarehouse': 'Supprimer l\'entrepôt',
  'invProd.deleteConfirmMsg': 'Êtes-vous sûr de vouloir supprimer ?',
  'invProd.cannotDelete': 'Suppression impossible',
  'invProd.errName': 'Entrez le nom',
  'invProd.nameDuplicate': 'Un produit avec ce nom existe déjà',
  'invProd.catDuplicate': 'Une catégorie avec ce nom existe déjà',
  'invProd.whDuplicate': 'Un entrepôt avec ce nom existe déjà',
  'invProd.understood': 'Compris',
  'invProd.newCategoryPlaceholder': 'Nom de la nouvelle catégorie',
  'invProd.newWarehousePlaceholder': 'Nom du nouvel entrepôt',
  'invProd.blockProduct': 'Produits',
  'invProd.blockCategory': 'Catégories',
  'invProd.blockWarehouse': 'Entrepôts',

  // ── Inventory stock page ──
  'invStock.title': 'Stocks',
  'invStock.subtitle': 'Contrôle des stocks en entrepôt',
  'invStock.statProducts': 'Produits',
  'invStock.statLow': 'Stock faible',
  'invStock.searchPlaceholder': 'Rechercher par nom...',
  'invStock.allCategories': 'Toutes les catégories',
  'invStock.allWarehouses': 'Tous les entrepôts',
  'invStock.lowStockOnly': 'Stock faible uniquement',
  'invStock.emptyTitle': 'Aucune donnée',
  'invStock.emptyHint': 'Ajoutez des produits dans la section "Produits"',
  'invStock.colProduct': 'Produit',
  'invStock.colCategory': 'Catégorie',
  'invStock.colUnit': 'Unité',
  'invStock.colTotal': 'Stock',
  'invStock.colMin': 'Min.',
  'invStock.colStatus': 'Statut',
  'invStock.statusLow': 'Faible',
  'invStock.statusEmpty': 'Aucun',
  'invStock.available': 'Disponible',
  'invStock.transfer': 'Transfert',
  'invStock.transferTitle': 'Transfert de produit',
  'invStock.transferBtn': 'Transférer',
  'invStock.labelProduct': 'Produit',
  'invStock.labelFromWarehouse': 'Depuis l\'entrepôt',
  'invStock.labelToWarehouse': 'Vers l\'entrepôt',
  'invStock.labelQuantity': 'Quantité',
  'invStock.cancel': 'Annuler',

  // ── Inventory purchases page ──
  'invPurch.title': 'Achats',
  'invPurch.subtitle': 'Suivi des achats de produits',
  'invPurch.statPurchases': 'Achats',
  'invPurch.searchPlaceholder': 'Rechercher par fournisseur...',
  'invPurch.newPurchase': 'Nouvel achat',
  'invPurch.emptyTitle': 'Aucun achat pour le moment',
  'invPurch.emptyHint': 'Créez le premier achat',
  'invPurch.colDate': 'Date',
  'invPurch.colSupplier': 'Fournisseur',
  'invPurch.colWarehouse': 'Entrepôt',
  'invPurch.colItems': 'Articles',
  'invPurch.colTotal': 'Total',
  'invPurch.modalTitle': 'Nouvel achat',
  'invPurch.labelSupplier': 'Fournisseur',
  'invPurch.supplierPlaceholder': 'Entrez le nom du fournisseur...',
  'invPurch.labelDestWarehouse': 'Entrepôt de destination',
  'invPurch.sectionProducts': 'Produits',
  'invPurch.selectProduct': 'Sélectionnez un produit',
  'invPurch.searchProduct': 'Rechercher un produit...',
  'invPurch.noProducts': 'Aucun produit trouvé',
  'invPurch.addItem': 'Ajouter un produit',
  'invPurch.qty': 'Qté',
  'invPurch.pricePerUnit': 'Prix unitaire',
  'invPurch.totalSum': 'Montant total',
  'invPurch.pos': 'positions',
  'invPurch.units': 'unités',
  'invPurch.receive': 'Réceptionner',
  'invPurch.cancel': 'Annuler',
  'invPurch.errWarehouse': 'Sélectionnez un entrepôt',
  'invPurch.errItems': 'Ajoutez au moins un produit',
  'invPurch.errNegPrice': 'Le prix ne peut pas être négatif',
  'invPurch.errZeroPrice': 'Indiquez le prix d\'achat pour chaque produit',
  'invPurch.periodWeek': 'Semaine',
  'invPurch.periodMonth': 'Mois',
  'invPurch.periodYear': 'Année',
  'invPurch.periodAll': 'Tout le temps',
  'invPurch.periodCustom': 'Personnalisé',
  'invPurch.returnToSupplier': 'Retourner au fournisseur',
  'invPurch.returnTitle': 'Retour au fournisseur',
  'invPurch.returnHint': 'Indiquez les quantités à retourner',
  'invPurch.returnAmount': 'Montant du retour',
  'invPurch.confirmReturn': 'Retourner',
  'invPurch.returnSuccess': 'Retour effectué',
  'invPurch.allReturned': 'Tous les articles déjà retournés ou en rupture',
  'invPurch.deletePurchase': 'Supprimer l\'achat',
  'invPurch.deleteTitle': 'Supprimer l\'achat',
  'invPurch.deleteWarning': 'Êtes-vous sûr ? Les articles suivants seront retirés du stock :',
  'invPurch.deleteStockNote': 'Les quantités en stock seront réduites en conséquence.',
  'invPurch.deleteConfirm': 'Supprimer',
  'invPurch.deleteBlockedTitle': 'Suppression impossible',
  'invPurch.deleteBlockedText': 'Cet achat ne peut pas être supprimé car il y a des mouvements ultérieurs pour ces produits :',
  'invPurch.deleteBlockedHint': 'Supprimez ou annulez d\'abord les opérations ultérieures, puis réessayez.',
  'invPurch.understood': 'Compris',

  // ── Tabs ──
  'invPurch.tabPurchases': 'Réceptions de marchandises',
  'invPurch.tabSuppliers': 'Fournisseurs',
  'invPurch.selectSupplier': 'Sélectionner un fournisseur',

  // ── Suppliers ──
  'invPurch.searchSupplier': 'Rechercher un fournisseur...',
  'invPurch.newSupplier': 'Nouveau fournisseur',
  'invPurch.editSupplier': 'Modifier le fournisseur',
  'invPurch.statSuppliers': 'fournisseurs',
  'invPurch.emptySuppliersTitle': 'Aucun fournisseur',
  'invPurch.emptySuppliersHint': 'Ajoutez des fournisseurs pour un suivi pratique des achats',
  'invPurch.colSupplierName': 'Nom',
  'invPurch.colContact': 'Personne de contact',
  'invPurch.colPhone': 'Téléphone',
  'invPurch.colEdrpou': 'SIRET',
    'invPurch.supplierDuplicate': 'A supplier with this name already exists',
'invPurch.supplierName': 'Nom',
  'invPurch.supplierNamePh': 'SARL "Fournisseur"',
  'invPurch.contactPerson': 'Personne de contact',
  'invPurch.contactPersonPh': 'Nom Prénom',
  'invPurch.phone': 'Téléphone',
  'invPurch.email': 'Email',
  'invPurch.bankDetails': 'Coordonnées bancaires',
  'invPurch.edrpou': 'SIRET',
  'invPurch.mfo': 'Code banque',
  'invPurch.iban': 'IBAN / Numéro de compte',
  'invPurch.supplierNotes': 'Notes',
  'invPurch.supplierNotesPh': 'Informations supplémentaires sur le fournisseur...',
  'invPurch.create': 'Créer',
  'invPurch.deleteSupplierTitle': 'Supprimer le fournisseur ?',
  'invPurch.deleteSupplierWarning': 'Êtes-vous sûr de vouloir supprimer le fournisseur',

  // ── Inventory movements page ──
  'invMov.title': 'Mouvements de stock',
  'invMov.subtitle': 'Historique des mouvements de produits en entrepôt',
  'invMov.statOperations': 'Opérations',
  'invMov.filterType': 'Type',
  'invMov.filterAll': 'Tous',
  'invMov.filterPurchase': 'Achat',
  'invMov.filterWriteoff': 'Radiation',
  'invMov.filterTransfer': 'Transfert',
  'invMov.filterAppointment': 'Rendez-vous',
  'invMov.filterOrder': 'Commande',
  'invMov.filterReturn': 'Retour',
  'invMov.filterAllProducts': 'Tous les produits',
  'invMov.emptyTitle': 'Aucune opération',
  'invMov.emptyHint': 'Toutes les opérations sur les produits s\'afficheront ici',
  'invMov.colDate': 'Date',
  'invMov.colType': 'Type',
  'invMov.colProduct': 'Produit',
  'invMov.colQty': 'Qté',
  'invMov.colCost': 'Coût',
  'invMov.colWarehouse': 'Entrepôt',
  'invMov.colAuthor': 'Auteur',
  'invMov.colDetails': 'Détails',
  'invMov.typePurchase': 'Achat',
  'invMov.typeWriteoff': 'Radiation',
  'invMov.typeTransfer': 'Transfert',
  'invMov.typeAppointment': 'Rendez-vous',
  'invMov.typeSale': 'Vente',
  'invMov.typeOrder': 'Commande',
  'invMov.typeOrderCancel': 'Annulation de commande',
  'invMov.typeSaleCancel': 'Annulation de vente',
  'invMov.typeAppointmentCancel': 'Annulation de rendez-vous',
  'invMov.typeReturn': 'Retour',
  'invMov.supplier': 'Fournisseur',
  'invMov.writeoffTitle': 'Radiation de produit',
  'invMov.writeoffBtn': 'Radier',
  'invMov.writeoffConfirm': 'Confirmer la radiation',
  'invMov.labelProduct': 'Produit',
  'invMov.labelQuantity': 'Quantité',
  'invMov.labelWarehouse': 'Entrepôt',
  'invMov.labelReason': 'Raison',
  'invMov.labelNote': 'Note',
  'invMov.available': 'Disponible',
  'invMov.cancel': 'Annuler',
  'invMov.reasonExpired': 'Expiré',
  'invMov.reasonDamaged': 'Endommagé',
  'invMov.reasonLost': 'Perdu',
  'invMov.reasonUsed': 'Utilisé',
  'invMov.reasonOther': 'Autre',

  // ── Salary calculation page ──
  'salCalc.month_jan': 'Janvier', 'salCalc.month_feb': 'Février', 'salCalc.month_mar': 'Mars',
  'salCalc.month_apr': 'Avril', 'salCalc.month_may': 'Mai', 'salCalc.month_jun': 'Juin',
  'salCalc.month_jul': 'Juillet', 'salCalc.month_aug': 'Août', 'salCalc.month_sep': 'Septembre',
  'salCalc.month_oct': 'Octobre', 'salCalc.month_nov': 'Novembre', 'salCalc.month_dec': 'Décembre',
  'salCalc.title': 'Calcul des salaires',
  'salCalc.subtitle': 'Calcul de la rémunération',
  'salCalc.selectMonthHint': 'Sélectionnez un mois pour le calcul',
  'salCalc.calculate': 'Calculer',
  'salCalc.save': 'Enregistrer',
  'salCalc.loadSaved': 'Charger la sauvegarde',
  'salCalc.exportExcel': 'Exporter Excel',
  'salCalc.staffCount': 'Employés',
  'salCalc.staffWithSchemes': 'Avec schémas',
  'salCalc.allStaff': 'Tous',
  'salCalc.noDataTitle': 'Aucune donnée',
  'salCalc.noDataDesc': 'Sélectionnez un mois et cliquez sur "Calculer"',
  'salCalc.noStaffTitle': 'Aucun employé',
  'salCalc.noStaffDesc': 'Ajoutez des employés dans la section "Personnel"',
  'salCalc.totalByRules': 'Selon les règles',
  'salCalc.manualAdjustments': 'Ajustements',
  'salCalc.totalLabel': 'Total',
  'salCalc.grandTotal': 'Montant total',
  'salCalc.adjustments': 'Ajustements',
  'salCalc.addAdjustment': 'Ajouter un ajustement',
  'salCalc.adjDescPlaceholder': 'Description...',
  'salCalc.adjAmountPlaceholder': 'Montant',
  'salCalc.edit': 'Modifier',
  'salCalc.back': 'Retour',
  'salCalc.cancel': 'Annuler',
  'salCalc.saved': 'Enregistré',
  'salCalc.savedNotice': 'Calcul enregistré',
  'salCalc.overwriteTitle': 'Écraser ?',
  'salCalc.overwriteDesc': 'Un calcul sauvegardé existe déjà pour ce mois. Écraser ?',
  'salCalc.overwrite': 'Écraser',
  'salCalc.hourlyRate': 'Taux horaire',
  'salCalc.monthlySalary': 'Salaire mensuel',
  'salCalc.monthlyFixed': 'fixe par mois',
  'salCalc.tiered': 'tranches',
  'salCalc.dailyRate': 'Taux journalier',
  'salCalc.fixedPerAppointment': 'Fixe par rendez-vous',
  'salCalc.percentOwnServices': '% des services propres',
  'salCalc.percentTotalRevenue': '% du chiffre d\'affaires total',
  'salCalc.percentOwnProductSales': '% own product sales',
  'salCalc.percentAllProductSales': '% all product sales',
  'salCalc.percentCreatedAppointments': '% created appointments',
  'salCalc.fixedPerCreatedAppointment': 'Fixed per created apt',
  'salCalc.percentOwnMaterials': '% materials',
  'salCalc.percentAllServices': '% of all location services',
  'salCalc.hours': 'h',
  'salCalc.days': 'j.',
  'salCalc.appts': 'rdv',
  'salCalc.services': 'serv.',
  'salCalc.individual': 'individuel',
  'salCalc.otherService': 'autre',
  'salCalc.exFileName': 'Salaires',
  'salCalc.exStaff': 'Employé',
  'salCalc.exScheme': 'Schéma',
  'salCalc.exByRules': 'Selon les règles',
  'salCalc.exAdjustments': 'Ajustements',
  'salCalc.exTotal': 'Total',

  // ── Salary schemes page ──
  'salSchemes.title': 'Schémas de motivation',
  'salSchemes.subtitle': 'Règles de calcul de la rémunération',
  'salSchemes.schemesCount': 'Schémas',
  'salSchemes.newScheme': 'Nouveau schéma',
  'salSchemes.emptyTitle': 'Aucun schéma pour le moment',
  'salSchemes.emptyDesc': 'Créez le premier schéma de rémunération',
  'salSchemes.newSchemeTitle': 'Nouveau schéma',
  'salSchemes.editScheme': 'Modifier le schéma',
  'salSchemes.schemeName': 'Nom du schéma',
  'salSchemes.nameDuplicate': 'Un schéma avec ce nom existe déjà',
  'salSchemes.schemeNamePlaceholder': 'Entrez le nom...',
  'salSchemes.rulesSection': 'Règles de calcul',
  'salSchemes.groupBase': 'Base',
  'salSchemes.groupServices': 'Services',
  'salSchemes.groupProducts': 'Products',
  'salSchemes.groupGeneral': 'General',
  'salSchemes.groupAdmin': 'Admin',
  'salSchemes.noRules': 'Aucune règle pour le moment',
  'salSchemes.hourlyRate': 'Taux horaire',
  'salSchemes.dailyRate': 'Taux journalier',
  'salSchemes.fixedPerAppointment': 'Fixe par service rendu',
  'salSchemes.percentOwnServices': '% des services propres',
  'salSchemes.percentTotalRevenue': '% du chiffre d\'affaires total',
  'salSchemes.hintHourlyRate': 'UAH/h',
  'salSchemes.hintDailyRate': 'UAH/jour',
  'salSchemes.hintFixedPer': 'UAH/rdv',
  'salSchemes.hintPercentOwn': '% des propres',
  'salSchemes.hintPercentTotal': '% du total',
  'salSchemes.percentOwnProductSales': '% own product sales',
  'salSchemes.hintPercentOwnProducts': '% of products sold by employee',
  'salSchemes.percentAllProductSales': '% all product sales',
  'salSchemes.hintPercentAllProducts': '% of total product sales',
  'salSchemes.percentCreatedAppointments': '% created appointments',
  'salSchemes.hintPercentCreated': '% from appointments created by employee',
  'salSchemes.fixedPerCreatedAppointment': 'Fixed per created appointment',
  'salSchemes.hintFixedCreated': 'Fixed amount per created appointment',
  'salSchemes.percentOwnMaterials': '% materials',
  'salSchemes.hintPercentMaterials': '% of materials in appointments',
  'salSchemes.percentAllServices': '% of all location services',
  'salSchemes.hintPercentAllServices': 'Percentage of total service and subscription revenue at location',
  'salSchemes.subscriptionLabel': 'Subscription services',
  'salSchemes.subModeVisitPrice': 'At subscription price',
  'salSchemes.subModeFullPrice': 'At list price',
  'salSchemes.subModeSkip': 'Do not count',
  'salSchemes.unitHour': 'UAH/h',
  'salSchemes.unitDay': 'UAH/jour',
  'salSchemes.unitRecord': 'UAH/rdv',
  'salSchemes.unitService': 'UAH/serv.',
  'salSchemes.useOverrides': 'Tarifs par service',
  'salSchemes.overrideService': 'Service',
  'salSchemes.overrideRate': 'Tarif',
  'salSchemes.overrideAdd': 'Ajouter une exception',
  'salSchemes.overrideRemove': 'Supprimer l\'exception',
  'salSchemes.overridesShort': 'exceptions',
  'salSchemes.staffShort': 'empl.',
  'salSchemes.save': 'Enregistrer',
  'salSchemes.create': 'Créer',
  'salSchemes.cancel': 'Annuler',
  'salSchemes.editBtn': 'Modifier',
  'salSchemes.deleteBtn': 'Supprimer',
  'salSchemes.delete': 'Supprimer',
  'salSchemes.deleteTitle': 'Supprimer le schéma ?',
  'salSchemes.deleteConfirmText': 'Êtes-vous sûr de vouloir supprimer ce schéma ?',
  'salSchemes.deleteAssigned': 'Ce schéma est attribué à des employés et ne peut pas être supprimé',
  'salSchemes.understood': 'Compris',
  'salSchemes.monthlySalary': 'Salaire mensuel',
  'salSchemes.hintMonthlySalary': 'Montant fixe par mois indépendamment du planning',
  'salSchemes.unitMonth': '₴/mois',
  'salSchemes.useBrackets': 'Tranches échelonnées',
  'salSchemes.bracketModeProgressive': 'Progressif (par tranche)',
  'salSchemes.bracketModeFlat': 'Plat (total au palier atteint)',
  'salSchemes.bracketFrom': 'De',
  'salSchemes.bracketTo': 'À',
  'salSchemes.bracketAdd': 'Ajouter une tranche',
  'salSchemes.bracketRemove': 'Supprimer la tranche',

  // ── Checkbox settings page ──
  'checkbox.title': 'Checkbox POS',
  'checkbox.subtitle': 'Configuration de la connexion à Checkbox',
  'checkbox.licenseKey': 'Clé de licence',
  'checkbox.licenseKeyHint': 'Clé de votre espace personnel Checkbox',
  'checkbox.licenseKeyPlaceholder': 'Entrez la clé de licence...',
  'checkbox.pinCode': 'Code PIN du caissier',
  'checkbox.pinCodeHint': 'Code PIN du caissier Checkbox',
  'checkbox.pinPlaceholder': 'Entrez le code PIN...',
  'checkbox.save': 'Enregistrer',
  'checkbox.saving': 'Enregistrement...',
  'checkbox.settingsSaved': 'Paramètres enregistrés',
  'checkbox.testConnection': 'Tester la connexion',
  'checkbox.testing': 'Test en cours...',
  'checkbox.connectionSuccess': 'Connexion réussie',
  'checkbox.connectionSuccessToast': 'Checkbox connecté avec succès',
  'checkbox.shiftOpen': 'Session ouverte',
  'checkbox.shiftClosed': 'Session fermée',
  'checkbox.guideTitle': 'Comment fonctionne l\'intégration',
  'checkbox.guideStep1': 'Inscrivez-vous sur checkbox.ua et créez une caisse. Copiez la clé de licence depuis votre cabinet.',
  'checkbox.guideStep2': 'Créez un caissier et notez le code PIN. Collez la clé et le PIN ci-dessus, cliquez sur "Tester la connexion".',
  'checkbox.guideStep3': 'C\'est fait ! Lors du traitement des paiements de commandes ou rendez-vous, le système créera automatiquement des reçus fiscaux.',
  'checkbox.guideCapabilities': 'Fonctionnalités :',
  'checkbox.guideCap1': 'Fiscalisation automatique lors des paiements de commandes et rendez-vous',
  'checkbox.guideCap2': 'Ouverture et fermeture des sessions de caisse',
  'checkbox.guideCap3': 'Prise en charge des paiements en espèces et par carte',
  'checkbox.guideCap4': 'Rapport X et rapport Z pour le contrôle de caisse',
  'checkbox.taxGroup': 'Groupe fiscal',
  'checkbox.taxGroupHint': 'Sélectionnez les taux de taxe à inclure dans chaque reçu. Cliquez sur "Tester la connexion" pour charger les taux disponibles.',
  'checkbox.noTax': 'Sans taxe',

  // ── Nova Poshta settings page ──
  'np.title': 'Nova Poshta',
  'np.subtitle': 'Paramètres d\'intégration Nova Poshta',
  'np.apiKey': 'Clé API',
  'np.apiKeyPlaceholder': 'Entrez la clé API Nova Poshta...',
  'np.apiKeyHint': 'Clé depuis my.novaposhta.ua → Paramètres → Sécurité',
  'np.save': 'Enregistrer',
  'np.saving': 'Enregistrement...',
  'np.settingsSaved': 'Paramètres Nova Poshta enregistrés',
  'np.error': 'Erreur : ',
  'np.testConnection': 'Tester la connexion',
  'np.testing': 'Test en cours...',
  'np.connectionSuccess': 'Connecté ! Expéditeurs trouvés : {count}',
  'np.connectionSuccessToast': 'Nova Poshta connecté avec succès',
  'np.connectionFailed': 'Échec de connexion. Vérifiez la clé API.',
  'np.senderSection': 'Données de l\'expéditeur',
  'np.sender': 'Expéditeur (contrepartie)',
  'np.contactPerson': 'Personne de contact',
  'np.senderPhone': 'Téléphone de l\'expéditeur',
  'np.senderAddress': 'Adresse d\'expédition',
  'np.senderAddressHint': 'Bureau Nova Poshta d\'où vous expédiez les colis',
  'np.loadingSenders': 'Chargement des données de l\'expéditeur...',
  'np.senderWarehouse': 'Entrepôt de l\'expéditeur',
  'np.senderWarehouseHint': 'Votre compte NP n\'a pas d\'adresses enregistrées. Sélectionnez le bureau d\'où vous expédiez.',
  'np.senderCity': 'Ville de l\'expéditeur',
  'np.senderCityPlaceholder': 'Entrez le nom de la ville...',
  'np.senderWarehouseSelect': 'Bureau',
  'np.noWarehouses': 'Aucun bureau trouvé',
  'np.clearSelection': 'Effacer',
  'np.guideTitle': 'Comment fonctionne l\'intégration',
  'np.guideStep1': 'Connectez-vous à my.novaposhta.ua → Paramètres → Sécurité → copiez la clé API.',
  'np.guideStep2': 'Collez la clé ci-dessus, cliquez sur "Tester la connexion". Sélectionnez l\'expéditeur, le contact et l\'adresse.',
  'np.guideStep3': 'C\'est fait ! Sélectionnez "Nova Poshta" comme mode de livraison lors de la création de commandes.',
  'np.guideCapabilities': 'Fonctionnalités :',
  'np.guideCap1': 'Créer un TTN en un clic depuis la page commande (statut "Emballé")',
  'np.guideCap2': 'Synchronisation automatique du statut de livraison toutes les 10 minutes',
  'np.guideCap3': 'Suivi des colis en temps réel',
  'np.guideCap4': 'Impression des étiquettes d\'expédition',
  'np.guideCap5': 'Calcul automatique du coût de livraison lors du choix de l\'agence',

  // ── Meest Express settings page ──
  'meest.title': 'Meest Express',
  'meest.subtitle': 'Paramètres d\'intégration',
  'meest.apiToken': 'Jeton API',
  'meest.apiTokenPlaceholder': 'Collez le jeton API du cabinet Meest',
  'meest.apiTokenHint': 'Trouvez-le sur 24.meest.com → Paramètres → Intégration API',
  'meest.contractId': 'Contract ID',
  'meest.contractIdPlaceholder': 'Ex. b0004cad-27a3-...',
  'meest.contractIdHint': 'Trouvez-le dans le cabinet Meest à côté du jeton API',
  'meest.save': 'Enregistrer',
  'meest.saving': 'Enregistrement...',
  'meest.settingsSaved': 'Paramètres Meest Express enregistrés',
  'meest.error': 'Erreur : ',
  'meest.testConnection': 'Tester la connexion',
  'meest.testing': 'Test...',
  'meest.testingConnection': 'Test de connexion à Meest Express...',
  'meest.connectionSuccess': 'Meest Express connecté avec succès',
  'meest.connectionSuccessToast': 'Meest Express connecté',
  'meest.connectionFailed': 'Échec de connexion. Vérifiez le jeton et le Contract ID.',
  'meest.senderSection': 'Données de l\'expéditeur',
  'meest.senderName': 'Nom complet de l\'expéditeur',
  'meest.senderNamePlaceholder': 'Nom Prénom',
  'meest.senderPhone': 'Téléphone de l\'expéditeur',
  'meest.senderCity': 'Ville de l\'expéditeur',
  'meest.senderCityPlaceholder': 'Commencez à saisir le nom de la ville',
  'meest.senderBranch': 'Agence de l\'expéditeur',
  'meest.branchPlaceholder': 'Rechercher une agence',
  'meest.noBranches': 'Aucune agence trouvée',
  'meest.clearSelection': 'Effacer',
  'meest.guideTitle': 'Comment fonctionne l\'intégration',
  'meest.guideStep1': 'Inscrivez-vous sur 24.meest.com et signez le contrat. Dans Paramètres → Intégration API copiez le jeton et le Contract ID.',
  'meest.guideStep2': 'Collez-les ci-dessus, cliquez sur "Tester la connexion". Les données de l\'expéditeur seront remplies automatiquement.',
  'meest.guideStep3': 'C\'est fait ! Sélectionnez "Meest Express" comme mode de livraison lors de la création de commandes.',
  'meest.guideCapabilities': 'Fonctionnalités :',
  'meest.guideCap1': 'Créer un envoi en un clic depuis la page commande (statut "Emballé")',
  'meest.guideCap2': 'Synchronisation automatique du statut de livraison toutes les 10 minutes',
  'meest.guideCap3': 'Suivi des colis en temps réel',
  'meest.guideCap4': 'Impression d\'étiquette pour le colis',

  // ── Telegram settings page ──
  'telegram.title': 'Rappels Telegram',
  'telegram.subtitle': 'Configuration du bot de rappels pour les clients',
  'telegram.botToken': 'Bot Token',
  'telegram.botTokenHint': 'Token du bot de @BotFather',
  'telegram.saveAndConnect': 'Enregistrer et connecter',
  'telegram.connecting': 'Connexion...',
  'telegram.checkingBot': 'Vérification du bot...',
  'telegram.settingWebhook': 'Configuration du webhook...',
  'telegram.botConnected': 'Bot connecté',
  'telegram.botReady': 'Le bot est prêt à fonctionner',
  'telegram.invalidToken': 'Token invalide',
  'telegram.webhookError': 'Erreur webhook',
  'telegram.webhookFailed': 'Impossible de configurer le webhook',
  'telegram.error': 'Erreur',
  'telegram.howItWorks': 'Comment ça marche',
  'telegram.step1': '1. Créez un bot via @BotFather dans Telegram',
  'telegram.step2': '2. Copiez le token du bot',
  'telegram.step3': '3. Collez le token ci-dessus et cliquez sur "Enregistrer et connecter"',
  'telegram.step4': '4. Les clients pourront se connecter via le lien',
  'telegram.guideCapabilities': 'Fonctionnalités :',
  'telegram.guideCap1': 'Rappels automatiques de rendez-vous pour les clients',
  'telegram.guideCap2': 'Les clients peuvent consulter leurs prochains rendez-vous',
  'telegram.guideCap3': 'Confirmer ou annuler un rendez-vous via le bot',
  'telegram.guideCap4': 'Lien personnel pour chaque client',

  // ── SMS settings page ──
  'sms.title': 'Envoi SMS',
  'sms.subtitle': 'Configuration de la passerelle SMS',
  'sms.provider': 'Fournisseur',
  'sms.apiKey': 'Clé API',
  'sms.apiKeyPlaceholder': 'Entrez la clé API...',
  'sms.senderName': 'Nom de l\'expéditeur',
  'sms.senderNameHint': 'Nom que le destinataire verra (jusqu\'à 11 caractères)',
  'sms.save': 'Enregistrer',
  'sms.settingsSaved': 'Paramètres enregistrés',
  'sms.testConnection': 'Tester la connexion',
  'sms.testing': 'Test en cours...',
  'sms.checkingConnection': 'Vérification de la connexion...',
  'sms.connectionSuccess': 'Connexion réussie',
  'sms.connectionError': 'Erreur de connexion',
  'sms.gatewayWorks': 'La passerelle SMS fonctionne',
  'sms.error': 'Erreur',
  'sms.unknown': 'Erreur inconnue',
  'sms.howItWorks': 'Comment ça marche',
  'sms.step1': '1. Inscrivez-vous auprès d\'un fournisseur SMS',
  'sms.step2': '2. Obtenez la clé API',
  'sms.step3': '3. Collez la clé ci-dessus et enregistrez',
  'sms.step4': '4. Vous pouvez maintenant envoyer des SMS aux clients',
  'sms.howToConnect': 'Comment connecter {name}',
  'sms.openSite': 'Ouvrir le site {name}',
  'sms.apiKeyLocation': 'La clé API se trouve ici : {path}',
  'sms.recommended': 'Recommandé',
  'sms.tagline_turbosms': 'Le plus populaire en Ukraine. Tableau de bord solide, API simple.',
  'sms.tagline_smsclub': 'Tarifs flexibles, alpha-name pris en charge.',
  'sms.tagline_alphasms': 'Tarification transparente, inscription rapide.',
  'sms.guide_turbosms.step1': 'Inscrivez-vous sur TurboSMS et rechargez votre solde.',
  'sms.guide_turbosms.step2': 'Commandez un alpha-name (étiquette d\'expéditeur) dans le tableau de bord. Approbation généralement le jour même.',
  'sms.guide_turbosms.step3': 'Allez dans Profil → API et copiez la clé API.',
  'sms.guide_turbosms.step4': 'Collez la clé + alpha-name ci-dessous et cliquez sur « Tester la connexion ».',
  'sms.guide_smsclub.step1': 'Créez un compte SMSClub et rechargez votre solde.',
  'sms.guide_smsclub.step2': 'Commandez un alpha-name (modération ~1 jour ouvré).',
  'sms.guide_smsclub.step3': 'Ouvrez Paramètres / Profil → trouvez le jeton API.',
  'sms.guide_smsclub.step4': 'Collez le jeton + alpha-name ci-dessous et cliquez sur « Tester la connexion ».',
  'sms.guide_alphasms.step1': 'Inscrivez-vous sur AlphaSMS et rechargez votre solde.',
  'sms.guide_alphasms.step2': 'Commandez un alpha-name (modération en quelques heures).',
  'sms.guide_alphasms.step3': 'Tableau de bord : Paramètres → API → copiez la clé API.',
  'sms.guide_alphasms.step4': 'Collez la clé + alpha-name ci-dessous et cliquez sur « Tester la connexion ».',

  // ── Email settings page ──
  'emailSet.title': 'Envoi Email',
  'emailSet.subtitle': 'Configuration de l\'envoi d\'emails',
  'emailSet.gmailAddress': 'Adresse Gmail',
  'emailSet.gmailHint': 'Adresse Gmail depuis laquelle les emails seront envoyés',
  'emailSet.appPassword': 'Mot de passe d\'application',
  'emailSet.appPasswordHint': 'Mot de passe d\'application Google (pas le mot de passe principal)',
  'emailSet.fromName': 'Nom de l\'expéditeur',
  'emailSet.fromNameHint': 'Nom que le destinataire verra',
  'emailSet.save': 'Enregistrer',
  'emailSet.settingsSaved': 'Paramètres enregistrés',
  'emailSet.sendTestEmail': 'Envoyer un email de test',
  'emailSet.sendingTest': 'Envoi en cours...',
  'emailSet.testing': 'Test en cours...',
  'emailSet.testSent': 'Email de test envoyé',
  'emailSet.testSubject': 'Email de test',
  'emailSet.testBody': 'Ceci est un email de test de Systemic CRM',
  'emailSet.emailWorks': 'L\'email fonctionne',
  'emailSet.sendError': 'Erreur d\'envoi',
  'emailSet.error': 'Erreur',
  'emailSet.unknown': 'Erreur inconnue',
  'emailSet.howToGetAppPassword': 'Comment obtenir le mot de passe d\'application',
  'emailSet.important': 'Important',
  'emailSet.importantText': 'Utilisez le mot de passe d\'application, pas le mot de passe principal Gmail',
  'emailSet.step1': '1. Connectez-vous à votre compte Google',
  'emailSet.step2': '2. Allez dans Sécurité → Vérification en deux étapes',
  'emailSet.step2direct': '2. Activez la vérification en deux étapes',
  'emailSet.step3': '3. Allez dans Mots de passe d\'application',
  'emailSet.step4': '4. Créez un nouveau mot de passe d\'application',
  'emailSet.step5': '5. Copiez le mot de passe généré',

  // ── Locations settings page ──
  'locations.title': 'Emplacements',
  'locations.subtitle': 'Gestion des emplacements de votre entreprise',
  'locations.locationsLabel': 'Emplacements',
  'locations.staffCount': 'Employés',
  'locations.warehousesCount': 'Entrepôts',
  'locations.addLocation': 'Ajouter un emplacement',
  'locations.tabMain': 'Général',
  'locations.tabBooking': 'Réservation en ligne',
  'locations.tabCompany': 'Données entreprise',
  'locations.photo': 'Photo du lieu',
  'locations.uploadPhoto': 'Télécharger photo',
  'locations.changePhoto': 'Changer photo',
  'locations.photoHint': 'Photo intérieur ou façade — affichée sur la page de réservation',
  'locations.scheduleLabel': 'Heures d\'ouverture',
  'locations.dayOff': 'Fermé',
  'locations.mon': 'Lun', 'locations.tue': 'Mar', 'locations.wed': 'Mer',
  'locations.thu': 'Jeu', 'locations.fri': 'Ven', 'locations.sat': 'Sam', 'locations.sun': 'Dim',
  'locations.workingHoursLabel': 'Heures d\'ouverture',
  'locations.workingHoursPlaceholder': 'Lun-Ven 9h-18h, Sam 10h-15h',
  'locations.hasLinkedData': 'Impossible de supprimer — l\'emplacement a du personnel ou des entrepôts liés.',
  'locations.limitReached': 'Limite d\'emplacements atteinte. Mettez à jour votre plan.',
  'locations.newLocation': 'Nouvel emplacement',
  'locations.editLocation': 'Modifier l\'emplacement',
  'locations.nameLabel': 'Nom',
  'locations.namePlaceholder': 'Entrez le nom...',
  'locations.nameDuplicate': 'Un emplacement avec ce nom existe déjà',
  'locations.addressLabel': 'Adresse',
  'locations.addressPlaceholder': '1 Rue de Rivoli',
  'locations.cityLabel': 'Ville',
  'locations.cityPlaceholder': 'Paris',
  'locations.phoneLabel': 'Téléphone',
  'locations.colorLabel': 'Couleur',
  'locations.save': 'Enregistrer',
  'locations.cancel': 'Annuler',
  'locations.add': 'Ajouter',
  'locations.edit': 'Modifier',
  'locations.delete': 'Supprimer',
  'locations.cannotDelete': 'Suppression impossible',
  'locations.ordersCount': 'Commandes',
  'locations.needAtLeastOne': 'Au moins un emplacement est nécessaire',
  'locations.added': 'Emplacement ajouté',
  'locations.updated': 'Emplacement mis à jour',
  'locations.deleted': 'Emplacement supprimé',
  'locations.deleteTitle': 'Supprimer le site',
  'locations.deleteMessage': 'Êtes-vous sûr? Cette action est irréversible.',
  'locations.companyDetailsHint': 'Détails de l\'entreprise (pour factures et documents)',
  'locations.officialNameLabel': 'Raison sociale',
  'locations.officialNamePlaceholder': 'SARL "Nom" / Auto-entrepreneur',
  'locations.edrpouLabel': 'SIRET / N° fiscal',
  'locations.edrpouShort': 'SIRET',
  'locations.bankAccountLabel': 'Compte bancaire (IBAN)',
  'locations.bankNameLabel': 'Nom de la banque',
  'locations.bankNamePlaceholder': 'Nom de la banque',

  // ── Users page ──
  'users.title': 'Utilisateurs',
  'users.subtitle': 'Gestion des utilisateurs du système',
  'users.usersCount': 'Utilisateurs',
  'users.addUser': 'Ajouter un utilisateur',
  'users.limitReached': 'Limite d\'utilisateurs atteinte. Mettez à jour votre plan.',
  'users.newUser': 'Nouvel utilisateur',
  'users.editUser': 'Modifier l\'utilisateur',
  'users.noUsers': 'Aucun utilisateur pour le moment',
  'users.thName': 'Nom',
  'users.thEmail': 'Email',
  'users.thRole': 'Rôle',
  'users.thStaff': 'Employé',
  'users.thActions': 'Actions',
  'users.nameLabel': 'Nom',
  'users.namePlaceholder': 'Entrez le nom...',
  'users.emailLabel': 'Email',
  'users.passwordLabel': 'Mot de passe',
  'users.passwordPlaceholder': 'Au moins 6 caractères',
  'users.passwordMin': 'Le mot de passe doit comporter au moins 6 caractères',
  'users.roleLabel': 'Rôle',
  'users.selectRole': 'Sélectionnez un rôle',
  'users.selectRoleOption': '— Sélectionnez un rôle —',
  'users.showPassword': 'Afficher le mot de passe',
  'users.hidePassword': 'Masquer le mot de passe',
  'users.enterName': 'Entrez le nom',
  'users.enterEmail': 'Entrez l\'email',
  'users.emailAlreadyUsed': 'Cet email est déjà utilisé',
  'users.error': 'Erreur',
  'users.edit': 'Modifier',
  'users.delete': 'Supprimer',
  'users.confirmDelete': 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
  'users.yes': 'Oui',
  'users.no': 'Non',
  'users.staffBinding': 'Liaison avec l\'employé',
  'users.noStaffBinding': '— Aucun —',
  'users.noPosition': 'sans poste',
  'users.staffBindingHint': 'Link user to employee for salary calculation and work schedule',
  'users.viewScope': 'Data visibility',
  'users.viewScopeAll': 'Show all records and orders',
  'users.viewScopeOwn': 'Show only own',
  'users.viewScopeHint': '"Own only" — user will see only their appointments, orders and sales',
  'users.createWarning': 'Attention : après la création de l\'utilisateur, vous pourriez être déconnecté. Reconnectez-vous simplement.',

  // ── Roles page ──
  'roles.title': 'Rôles',
  'roles.subtitle': 'Gestion des rôles et des droits d\'accès',
  'roles.rolesCount': 'Rôles',
  'roles.addRole': 'Ajouter un rôle',
  'roles.noRoles': 'Aucun rôle pour le moment.',
  'roles.systemBadge': 'Système',
  'roles.permsOf': 'droits',
  'roles.newRole': 'Nouveau rôle',
  'roles.editRole': 'Modifier le rôle',
  'roles.roleName': 'Nom du rôle',
  'roles.roleNamePlaceholder': 'Par exemple : Administrateur, Manager, Spécialiste',
  'roles.nameDuplicate': 'Un rôle avec ce nom existe déjà',
  'roles.permissions': 'Droits d\'accès',
  'roles.confirmDelete': 'Supprimer ?',
  'roles.cannotDelete': 'Impossible de supprimer le rôle',
  'roles.usersAssigned': 'utilisateurs avec ce rôle',
  'roles.groupClients': 'Clients',
  'roles.groupStaff': 'Personnel',
  'roles.groupCalendar': 'Calendrier',
  'roles.groupSales': 'Ventes',
  'roles.groupInventory': 'Entrepôt',
  'roles.groupLoyalty': 'Fidélité',
  'roles.groupSalary': 'Salaires',
  'roles.groupFinances': 'Finances et analytique',
  'roles.groupCommunication': 'Communications',
  'roles.groupSettings': 'Paramètres',
  'roles.groupSystem': 'Système',
  'roles.permClientsView': 'Voir les clients',
  'roles.permClientsEdit': 'Modifier les clients',
  'roles.permClientsDelete': 'Supprimer les clients',
  'roles.permClientsCategories': 'Catégories de clients',
  'roles.permClientsDocuments': 'Documents clients',
  'roles.permStaffView': 'Voir le personnel',
  'roles.permStaffEdit': 'Modifier le personnel',
  'roles.permScheduleView': 'Horaire de travail',
  'roles.permScheduleEdit': 'Modèles d\'horaires',
  'roles.permServicesView': 'Voir les services',
  'roles.permServicesEdit': 'Modifier les services',
  'roles.permCalendarView': 'Voir le calendrier',
  'roles.permCalendarCreate': 'Créer des rendez-vous',
  'roles.permCalendarEdit': 'Modifier les rendez-vous',
  'roles.permPosSell': 'Magasin (POS)',
  'roles.permOrdersView': 'Commandes (voir)',
  'roles.permOrdersCreate': 'Commandes (créer)',
  'roles.permOrdersEdit': 'Commandes (modifier)',
  'roles.permInvView': 'Produits et stock',
  'roles.permInvPurchases': 'Achats',
  'roles.permInvMovements': 'Mouvements de stock',
  'roles.permProductionView': 'Voir la production',
  'roles.permProductionCreate': 'Créer la production',
  'roles.permLoyaltyView': 'Voir les programmes de fidélité',
  'roles.permLoyaltyEdit': 'Modifier les programmes de fidélité',
  'roles.permSalaryView': 'Calcul des salaires',
  'roles.permSalaryEdit': 'Schémas de motivation',
  'roles.permFinancesView': 'Voir les finances',
  'roles.permCashRegister': 'Caisse (Checkbox)',
  'roles.permReportsView': 'Rapports',
  'roles.permFinancialResult': 'Résultat financier',
  'roles.permBusinessMonitor': 'Moniteur d\'activité',
  'roles.permCommunicationView': 'Messages',
  'roles.permCommSettingsEdit': 'Paramètres de communication',
  'roles.permSettingsLocations': 'Emplacements',
  'roles.permSettingsBooking': 'Réservation en ligne',
  'roles.permSettingsIntegrations': 'Intégrations',
  'roles.permSettingsTariffs': 'Plans tarifaires',
  'roles.permManageUsers': 'Utilisateurs',
  'roles.permManageRoles': 'Rôles',
  'roles.permAuditLog': 'Journal d\'audit',

  // ── Communication page ──
  'comm.title': 'Communication',
  'comm.subtitle': 'Messages et communication avec les clients',
  'comm.searchPlaceholder': 'Rechercher un client...',
  'comm.allClients': 'Tous les clients',
  'comm.nothingFound': 'Rien trouvé',
  'comm.noConnectedClients': 'Aucun client connecté',
  'comm.you': 'Vous : ',
  'comm.noMessages': 'Aucun message',
  'comm.noHistory': 'Aucun historique',
  'comm.selectChat': 'Sélectionnez un chat',
  'comm.selectChatHint': 'Choisissez un client à gauche pour commencer la communication',
  'comm.telegramNotConnected': 'Telegram non connecté',
  'comm.smsNotConfigured': 'Passerelle SMS non configurée',
  'comm.clientNoPhone': 'Le client n\'a pas de numéro de téléphone',
  'comm.noPhone': 'Pas de téléphone',
  'comm.emailNotConfigured': 'Email non configuré',
  'comm.clientNoEmail': 'Le client n\'a pas d\'adresse email',
  'comm.noEmail': 'Pas d\'email',
  'comm.defaultSubject': 'Message',
  'comm.emailSent': 'Email envoyé',
  'comm.smsSent': 'SMS envoyé',
  'comm.messageSent': 'Message envoyé',
  'comm.error': 'Erreur : ',
  'comm.linkCopied': 'Lien copié',
  'comm.yesterday': 'Hier',
  'comm.clientNoTelegram': 'Le client n\'a pas encore connecté Telegram',
  'comm.sendBotLink': 'Envoyez ce lien au client :',
  'comm.copy': 'Copier',
  'comm.sendSmsInstead': 'Envoyer un SMS à la place',
  'comm.botNotConfigured': 'Le bot Telegram n\'est pas configuré',
  'comm.configureTelegram': 'Configurez dans Système → Rappels Telegram',
  'comm.configureSms': 'Configurez dans Système → Envoi SMS',
  'comm.addPhoneToCard': 'Ajoutez un numéro de téléphone à la fiche client',
  'comm.configureEmail': 'Configurez dans Système → Envoi Email',
  'comm.addEmailToCard': 'Ajoutez un email à la fiche client',
  'comm.noMessagesYet': 'Pas encore de messages. Écrivez en premier !',
  'comm.openAttachment': 'Ouvrir la pièce jointe',
  'comm.attachHintWeb': 'La conversation sera rattachée à la fiche client avec son historique ; les prochains messages de ce chat y arriveront aussi.',
  'comm.createCardFromVisitor': 'Créer une fiche à partir des données du visiteur',
  'comm.cardCreated': 'Fiche créée',
  'comm.showOlder': 'Afficher les précédents',
  'comm.emailSubjectPlaceholder': 'Objet du message...',
  'comm.emailPlaceholder': 'Texte du message...',
  'comm.smsPlaceholder': 'Écrire un SMS...',
  'comm.sendingVia': 'Canal actuel : {channel}',
  'comm.messagePlaceholder': 'Écrire un message...',
  'comm.sendEnter': 'Envoyer (Entrée)',

  // ── Orders ──
  'orders.title': 'Commandes',
  'orders.subtitle': 'Vente de produits',
  'orders.statTotal': 'Total',
  'orders.statusNew': 'Nouvelles',
  'orders.statusPaid': 'Payées',
  'orders.searchPlaceholder': 'Rechercher par client ou produit...',
  'orders.filterAll': 'Toutes',
  'orders.status_new': 'Nouveau',
  'orders.status_confirmed': 'Confirmé',
  'orders.status_packed': 'Emballé',
  'orders.status_shipped': 'Expédié',
  'orders.status_delivered': 'Reçu',
  'orders.status_cancelled': 'Annulé',
  'orders.periodAll': 'Toutes',
  'orders.periodWeek': 'Semaine',
  'orders.periodMonth': 'Mois',
  'orders.periodYear': 'Année',
  'orders.periodCustom': 'Personnalisé',
  'orders.newOrder': 'Nouvelle commande',
  'orders.editOrder': 'Modifier la commande',
  'orders.emptyTitle': 'Aucune commande',
  'orders.emptyHint': 'Créez votre première commande de vente',
  'orders.pos': 'pos.',
  'orders.discount': 'Remise',
  'orders.total': 'Total',
  'orders.pay_unpaid': 'Non payé',
  'orders.pay_partial': 'Partiel',
  'orders.pay_paid': 'Payé',
  'orders.pay_refunded': 'Remboursé',
  'orders.refund': 'Rembourser',
  'orders.refunded': 'Paiement remboursé',
  'orders.refundTitle': 'Remboursement',
  'orders.refundMessage': 'Rembourser {amount} ₴ au client ?',
  'orders.refundWarning': 'Une transaction de remboursement sera créée',
  'orders.refundDescription': 'Remboursement commande',
  'orders.confirmRefund': 'Confirmer le remboursement',
  'orders.refundAmountLabel': 'Montant du remboursement',
  'orders.paidOf': 'Payé {paid} sur {total} ₴',
  'orders.payRemaining': 'Payer le reste',
  'orders.payAmountLabel': 'Montant du paiement',
  'orders.fullAmount': 'montant total',
  'orders.returnProducts': 'Retourner produits',
  'orders.returnTitle': 'Retour de produits',
  'orders.returnHint': 'Indiquez les quantités à retourner en stock',
  'orders.confirmReturn': 'Confirmer le retour',
  'orders.returnFrom': 'Retour de commande',
  'orders.fullyReturned': 'Produits retournés',
  'orders.partiallyReturned': 'Retour partiel',
  'orders.action_confirmed': 'Confirmer',
  'orders.action_packed': 'Emballer',
  'orders.action_shipped': 'Expédier',
  'orders.action_delivered': 'Reçu',
  'orders.action_cancelled': 'Annuler',
  'orders.markPaid': 'Marquer payé',
  'orders.payBtn': 'Payer',
  'orders.cashGiven': 'Le client a donné',
  'orders.change': 'Monnaie',
  'orders.notEnough': 'Pas assez',
  'orders.confirmPayment': 'Confirmer le paiement',
  'orders.back': 'Retour',
  'orders.edit': 'Modifier',
  'orders.errCustomerName': 'Entrez le nom du client',
  'orders.errItems': 'Ajoutez au moins un produit',
  'orders.errWarehouse': 'Sélectionnez un entrepôt',
  'orders.errStockInsufficient': 'Stock insuffisant',
  'orders.errNegPrice': 'Le prix ne peut pas être négatif',
  'orders.errQuantity': 'Indiquez la quantité pour les produits sélectionnés',
  'orders.inStock': 'En stock',
  'orders.available': 'disponible',
  'orders.needed': 'nécessaire',
  'orders.paymentDescription': 'Vente de produits',
  'orders.sectionCustomer': 'Client',
  'orders.sectionProducts': 'Produits',
  'orders.sectionPayment': 'Paiement',
  'orders.labelName': 'Nom',
  'orders.namePlaceholder': 'Nom du client',
  'orders.labelPhone': 'Téléphone',
  'orders.labelTariff': 'Plan tarifaire',
  'orders.standardPrice': 'Prix standard',
  'orders.labelEmail': 'Email',
  'orders.labelWarehouse': 'Entrepôt',
  'orders.selectWarehouse': 'Sélectionnez un entrepôt',
  'orders.labelPaymentMethod': 'Mode de paiement',
  'orders.pm_cash': 'Espèces',
  'orders.pm_terminal': 'Terminal',
  'orders.pm_transfer': 'Virement',
  'orders.pm_online': 'En ligne',
  'orders.selectProduct': 'Sélectionnez un produit',
  'orders.qty': 'Quantité',
  'orders.price': 'Prix',
  'orders.addItem': 'Ajouter un produit',
  'orders.colProduct': 'Produit',
  'orders.colWarehouse': 'Entrepôt',
  'orders.colQty': 'Qté',
  'orders.colPrice': 'Prix',
  'orders.colDiscount': 'Remise',
  'orders.colSum': 'Total',
  'orders.labelDiscount': 'Remise (₴)',
  'orders.labelNote': 'Note',
  'orders.notePlaceholder': 'Commentaire de commande...',
  'orders.cancel': 'Annuler',
  'orders.save': 'Enregistrer',
  'orders.saving': 'Enregistrement…',
  'orders.searchProduct': 'Rechercher un produit...',
  'orders.noProducts': 'Aucun produit trouvé',
  'orders.changeProduct': 'Changer de produit',
  'orders.noWarehouse': 'Aucun entrepôt avec stock',
  'orders.noCategory': 'Sans catégorie',
  'orders.printInvoice': 'Facture',
  'orders.printBill': 'Devis',
  'orders.sectionShipping': 'Livraison',
  'orders.labelShippingMethod': 'Mode de livraison',
  'orders.labelShippingAddress': 'Adresse de livraison',
  'orders.shippingNone': 'Sans livraison (retrait)',
  'orders.shippingNP': 'Nova Poshta',
  'orders.shippingPickup': 'Retrait',
  'orders.shippingCourier': 'Coursier',
  'orders.shippingOther': 'Autre',
  'orders.shipping_novaposhta': 'Nova Poshta',
  'orders.shipping_pickup': 'Retrait',
  'orders.shipping_courier': 'Coursier',
  'orders.shipping_other': 'Autre livraison',
  'orders.npCity': 'Ville',
  'orders.npCityPlaceholder': 'Entrez le nom de la ville...',
  'orders.npWarehouse': 'Bureau / Point relais',
  'orders.npWarehousePlaceholder': 'Rechercher un bureau...',
  'orders.npTTN': 'Numéro de suivi',
  'orders.npTTNPlaceholder': 'Numéro de lettre de voiture',
  'orders.npTrack': 'Suivre',
  'orders.npStatus': 'Statut',
  'orders.npFrom': 'De',
  'orders.npTo': 'À',
  'orders.npDeliveryTo': 'Livraison',
  'orders.npDeliveryDate': 'Date de livraison',
  'orders.npTTNOnlyPacked': 'Le TTN ne peut être créé qu\'au statut «Emballé»',
  'orders.npSyncTracking': 'Actualiser suivi',
  'orders.npSyncing': 'Synchronisation...',
  'orders.npAutoSyncActive': 'Le statut sera mis à jour automatiquement via Nova Poshta',
  'orders.meestAutoSyncActive': 'Le statut sera mis à jour automatiquement via Meest Express',
  'orders.meestAll': 'Tous',
  'orders.meestOffice': 'Bureaux',
  'orders.meestParcelLocker': 'Consignes à colis',
  'orders.npCodConfirmTitle': 'Créer un bordereau Nova Poshta',
  'orders.meestCodConfirmTitle': 'Créer un envoi Meest',
  'orders.codChoiceMessage': 'La commande n\'est pas payée. Vous pouvez créer l\'envoi en Contre Remboursement.',
  'orders.codWithCod': 'Oui, avec Contre Remboursement',
  'orders.codWithoutCod': 'Non, sans Contre Remboursement',
  'orders.codCancel': 'Annuler la création du bordereau',
  'orders.addressPlaceholder': 'Adresse de livraison...',
  'orders.courierAddressPlaceholder': 'Adresse pour le coursier...',
  'orders.npSettingsRequired': 'Configurez d\'abord Nova Poshta dans Système → Nova Poshta',
  'orders.npResaveSettings': 'Veuillez réenregistrer les paramètres Nova Poshta (Système → Nova Poshta → Enregistrer) pour mettre à jour les données de l\'expéditeur.',
  'orders.npMissingFields': 'Données manquantes pour la création du bordereau. Allez dans Système → Nova Poshta et réenregistrez. Champs manquants',
  'orders.npAddressRequired': 'Indiquez la ville et le bureau NP dans la commande',
  'orders.npRecipientRequired': 'Saisissez le nom et le téléphone du destinataire',
  'orders.npCreateTTN': 'Créer lettre de voiture',
  'orders.npTTNCreated': 'Lettre de voiture créée',
  'orders.npTTNError': 'Erreur de création',
  'orders.npPrintSticker': 'Imprimer étiquette',
  'orders.npDeliveryPriceLabel': 'Coût de livraison estimé',
  'orders.npUAH': 'UAH',
  'orders.npCalcPrice': 'Calcul du coût',
  'orders.author': 'Auteur',
  'invoice.title': 'Bon de livraison',
  'invoice.date': 'Date',
  'invoice.status': 'Statut',
  'invoice.customer': 'Client',
  'invoice.note': 'Note',
  'invoice.items': 'Articles',
  'invoice.product': 'Désignation',
  'invoice.unit': 'Unité',
  'invoice.qty': 'Qté',
  'invoice.price': 'Prix',
  'invoice.discountCol': 'Remise',
  'invoice.sum': 'Montant',
  'invoice.discount': 'Remise',
  'invoice.total': 'Total',
  'invoice.paid': 'Payé',
  'invoice.remaining': 'Reste',
  'invoice.seller': 'Vendeur',
  'invoice.bankAccount': 'Compte',
  'invoice.sellerSign': 'Signature vendeur',
  'invoice.buyerSign': 'Signature acheteur',
  'invoice.pcs': 'pcs',

  // ── Bill ──
  'bill.title': 'Devis',
  'bill.amountDue': 'Montant dû',
  'bill.payTo': 'Coordonnées de paiement',
  'bill.service': 'service',
  'bill.itemName': 'Désignation',

  // ── Services: default materials ──
  'services.materials': 'Matériaux',
  'services.hasMaterials': 'Matériaux par défaut',
  'services.defaultMaterials': 'Matériaux par défaut',
  'services.defaultMaterialsHint': 'Ces matériaux seront ajoutés automatiquement lors de la sélection de ce service',
  'services.addMaterial': 'Ajouter un matériau',
  'services.noProductsAvailable': 'Aucun produit disponible',

  'nav.production': 'Production',

  'production.title': 'Production',
  'production.subtitle': 'Spécifications et fabrication',
  'production.recipesCount': 'Spécifications',
  'production.operationsCount': 'Opérations',
  'production.tab_recipes': 'Spécifications',
  'production.tab_produce': 'Produire',
  'production.tab_history': 'Historique',
  'production.newRecipe': 'Nouvelle spécification',
  'production.newProduction': 'Nouvelle opération',
  'production.searchRecipes': 'Rechercher des spécifications...',
  'production.searchHistory': 'Rechercher dans l\'historique...',
  'production.noRecipes': 'Pas encore de spécifications',
  'production.noRecipesHint': 'Créez une spécification pour fabriquer des produits à partir de matières premières',
  'production.createRecipeFirst': 'Créez d\'abord une spécification dans l\'onglet "Spécifications"',
  'production.noHistory': 'L\'historique de production est vide',
  'production.output': 'Sortie',
  'production.inputs': 'Entrées',
  'production.produce': 'Produire',
  'production.edit': 'Modifier',
  'production.delete': 'Supprimer',
  'production.stockOk': 'En stock',
  'production.stockLow': 'Insuffisant',
  'production.inputCost': 'Coût des matières',
  'production.unitCost': 'Coût unitaire',
  'production.uah': 'UAH',
  'production.warehouse': 'Entrepôt',
  'production.recipeName': 'Nom de la spécification',
  'production.recipeNamePlaceholder': 'Ex. "Crème pour les mains 100ml"',
  'production.selectWarehouse': 'Sélectionner un entrepôt',
  'production.noInputsYet': 'Ajoutez des matières premières à la spécification',
  'production.outputSection': 'Produit fini',
  'production.outputProduct': 'Produit de sortie',
  'production.selectProduct': 'Sélectionner un produit',
  'production.outputQty': 'Quantité',
  'production.inputsSection': 'Matières premières',
  'production.addInput': 'Ajouter une entrée',
  'production.searchProduct': 'Rechercher un produit...',
  'production.qty': 'Qté',
  'production.cancel': 'Annuler',
  'production.save': 'Enregistrer',
  'production.create': 'Créer',
  'production.editRecipe': 'Modifier la spécification',
  'production.recipeCreated': 'Spécification créée',
  'production.recipeUpdated': 'Spécification mise à jour',
  'production.recipeDeleted': 'Spécification supprimée',
  'production.cannotDeleteRecipe': 'Impossible de supprimer — utilisée en production',
  'production.executeProduction': 'Exécuter la production',
  'production.selectRecipeLabel': 'Spécification',
  'production.selectRecipe': 'Sélectionner une spécification',
  'production.multiplier': 'Multiplicateur (lots)',
  'production.preview': 'Aperçu',
  'production.willConsume': 'Sera consommé',
  'production.willProduce': 'Sera produit',
  'production.need': 'besoin',
  'production.available': 'disponible',
  'production.note': 'Note',
  'production.notePlaceholder': 'Commentaire sur l\'opération',
  'production.executeProduce': 'Produire',
  'production.produced': 'Produit : {qty} × {name}',
  'production.errNameRequired': 'Nom de spécification requis',
  'production.errOutputRequired': 'Sélectionnez le produit de sortie',
  'production.errInputsRequired': 'Ajoutez au moins une matière première',
  'production.errOutputInInputs': 'Le produit de sortie ne peut pas être parmi les entrées',
  'production.errSelectRecipe': 'Sélectionnez une spécification',
  'production.errSelectWarehouse': 'Sélectionnez un entrepôt',
  'production.errMultiplier': 'Le multiplicateur doit être >= 1',
  'production.cancelTitle': 'Annuler la production',
  'production.cancelMessage': 'Annuler la production "{name}" ×{qty} ?',
  'production.cancelDescription': 'Le produit fini sera déduit du stock, les matières premières seront restituées',
  'production.cancelWarning': 'Cette action est irréversible',
  'production.confirmCancel': 'Confirmer l\'annulation',
  'production.cancelledLabel': 'Annulé',
  'production.cancelBtn': 'Annuler',
  'production.alreadyCancelled': 'Cette production a déjà été annulée',
  'production.cancelNotEnoughStock': 'Impossible d\'annuler — seulement {available} sur {needed} unités restent en stock. Le produit a déjà été expédié.',
  'production.cancelNote': 'Annulation de production',
  'production.cancelledSuccess': 'Production annulée',

  'invMov.typeProductionOut': 'Production (consommé)',
  'invMov.typeProductionIn': 'Production (sortie)',
  'invMov.filterProduction': 'Production',

  // ── Navigation: audit log ──
  'nav.auditLog': 'Journal d\'audit',

  // ── Audit Log ──
  'auditLog.title': 'Journal d\'audit',
  'auditLog.dateTime': 'Date et heure',
  'auditLog.user': 'Utilisateur',
  'auditLog.action': 'Action',
  'auditLog.collection': 'Section',
  'auditLog.documentId': 'ID du document',
  'auditLog.document': 'Document',
  'auditLog.details': 'Détails',
  'auditLog.actionCreate': 'Création',
  'auditLog.actionUpdate': 'Modification',
  'auditLog.actionDelete': 'Suppression',
  'auditLog.filterCollection': 'Section',
  'auditLog.filterAction': 'Action',
  'auditLog.filterFrom': 'De',
  'auditLog.filterTo': 'À',
  'auditLog.allCollections': 'Toutes les sections',
  'auditLog.allActions': 'Toutes les actions',
  'auditLog.noEntries': 'Aucune entrée trouvée',
  'auditLog.loadMore': 'Charger plus',
  'auditLog.changes': 'Modifications',
  'auditLog.field': 'Champ',
  'auditLog.oldValue': 'Avant',
  'auditLog.newValue': 'Après',
  'auditLog.deletedData': 'Données supprimées',
  'auditLog.newRecord': 'Nouvel enregistrement créé',
  'auditLog.fieldsChanged': 'champs modifiés',
  'auditLog.colCustomers': 'Clients',
  'auditLog.colStaff': 'Personnel',
  'auditLog.colAppointments': 'Rendez-vous',
  'auditLog.colTransactions': 'Transactions',
  'auditLog.colOrders': 'Commandes',
  'auditLog.colProducts': 'Produits',
  'auditLog.colStock': 'Stock',
  'auditLog.colStockMovements': 'Mouvements de stock',
  'auditLog.colServices': 'Services',
  'auditLog.colCategories': 'Catégories',
  'auditLog.colLocations': 'Emplacements',
  'auditLog.colRoles': 'Rôles',
  'auditLog.colUsers': 'Utilisateurs',
  'auditLog.colSalaryHistory': 'Historique des salaires',
  'auditLog.colSalarySchemes': 'Schémas de salaire',
  'auditLog.colFixedExpenses': 'Charges fixes',
  'auditLog.colWarehouses': 'Entrepôts',
  'auditLog.colScheduleTemplates': 'Modèles de planning',
  'auditLog.colCashShifts': 'Quarts de caisse',
  'auditLog.colProductions': 'Production',
  'auditLog.colTechCards': 'Fiches techniques',

  // ── Loyalty (4 modules) ──
  'nav.loyalty': 'Programmes de fidélité',
  'loyalty.title': 'Programmes de fidélité',
  'loyalty.subtitle': 'Points, niveaux, codes promo et abonnements',
  'custModal.tabLoyalty': 'Fidélité',
  'loyalty.tabPoints': 'Points',
  'loyalty.tabTiers': 'Niveaux',
  'loyalty.tabCoupons': 'Codes Promo',
  'loyalty.tabSubscriptions': 'Abonnements',
  'loyalty.tabSettings': 'Paramètres',
  'loyalty.tabBalances': 'Soldes',
  'loyalty.tabHistory': 'Historique',
  'loyalty.tabTierOverview': 'Aperçu clients',
  'loyalty.tabPlans': 'Plans',
  'loyalty.tabPlansSettings': 'Paramètres des plans',
  'loyalty.tabActiveSubs': 'Abonnements actifs',
  'loyalty.statMembers': 'membres',
  'loyalty.statPoints': 'points actifs',
  'loyalty.saveSettings': 'Enregistrer',
  'loyalty.saved': 'Paramètres enregistrés',
  'loyalty.searchCustomer': 'Rechercher un client...',
  'loyalty.days': 'jours',
  'loyalty.pts': 'points',
  'loyalty.cancel': 'Annuler',
  'loyalty.colCustomer': 'Client',
  'loyalty.colTier': 'Niveau',
  'loyalty.colBalance': 'Solde',
  'loyalty.colTotalEarned': 'Accumulés',
  'loyalty.colTotalRedeemed': 'Échangés',
  'loyalty.colTotalSpent': 'Total dépensé',
  'loyalty.colDate': 'Date',
  'loyalty.colType': 'Type',
  'loyalty.colPoints': 'Points',
  'loyalty.colNote': 'Note',
  'loyalty.colStatus': 'Statut',
  'loyalty.enablePoints': 'Activer le programme de points',
  'loyalty.pointsDisabled': 'Programme de points désactivé',
  'loyalty.sectionEarning': 'Accumulation de points',
  'loyalty.currencyPerPoint': 'Montant par point',
  'loyalty.currencyPerPointHint': 'Combien dépenser pour obtenir des points',
  'loyalty.pointsPerUnit': 'Points par unité',
  'loyalty.sectionRedemption': 'Échange de points',
  'loyalty.pointValue': 'Valeur du point',
  'loyalty.maxRedeemPercent': 'Max. % payable en points',
  'loyalty.sectionAutoBonuses': 'Bonus automatiques',
  'loyalty.birthdayBonus': 'Bonus anniversaire',
  'loyalty.referralBonus': 'Bonus de parrainage',
  'loyalty.inactivityDays': "Jours d'inactivité",
  'loyalty.inactivityBonus': 'Bonus de retour',
  'loyalty.noBalances': 'Pas encore de membres',
  'loyalty.noBalancesHint': 'Les points seront accumulés automatiquement lors du paiement',
  'loyalty.noHistory': 'Historique vide',
  'loyalty.txEarn': 'Accumulation',
  'loyalty.txRedeem': 'Échange',
  'loyalty.txBirthday': 'Anniversaire',
  'loyalty.txReferral': 'Parrainage',
  'loyalty.txInactivity': 'Retour',
  'loyalty.txManual': 'Manuel',
  'loyalty.sectionPoints': 'Points',
  'loyalty.pointsBalance': 'points',
  'loyalty.earned': 'accumulés',
  'loyalty.redeemed': 'échangés',
  'loyalty.manualPlaceholder': '±points',
  'loyalty.manualApply': 'Appliquer',
  'loyalty.manualAdd': 'Crédit manuel',
  'loyalty.manualDeduct': 'Débit manuel',
  'loyalty.history': 'Historique des points',
  'loyalty.noTransactions': "Pas encore d'opérations",
  'loyalty.enableTiers': 'Activer le programme de niveaux',
  'loyalty.tiersDisabled': 'Programme de niveaux désactivé',
  'loyalty.tierPeriod': 'Période de calcul',
  'loyalty.periodAllTime': 'Tout le temps',
  'loyalty.periodMonths': 'Derniers {n} mois',
  'loyalty.tierPeriodHint': 'Période pour calculer les dépenses et déterminer le niveau',
  'loyalty.sectionTiers': 'Niveaux clients',
  'loyalty.tiersHint': 'La remise est déterminée automatiquement par les dépenses totales du client',
  'loyalty.tierName': 'Nom',
  'loyalty.tierMinSpent': 'Dépense min.',
  'loyalty.tierDiscount': 'Remise',
  'loyalty.tierLoadingBtn': 'Calcul de la remise',
  'loyalty.tierLoadingHint': 'Calcul de la remise par niveau…',
  'loyalty.addTier': 'Ajouter un niveau',
  'loyalty.noTierCustomers': 'Pas encore de clients avec des dépenses',
  'loyalty.sectionTierStatus': 'Niveau du client',
  'loyalty.tierDiscountLabel': 'Remise du niveau',
  'loyalty.nextTier': 'Niveau suivant',
  'loyalty.enableCoupons': 'Activer les codes promo',
  'loyalty.couponsDisabled': 'Codes promo désactivés',
  'loyalty.searchCoupon': 'Rechercher un code promo...',
  'loyalty.addCoupon': 'Créer un code promo',
  'loyalty.newCoupon': 'Nouveau code promo',
  'loyalty.editCoupon': 'Modifier le code promo',
  'loyalty.saveCoupon': 'Enregistrer le code promo',
  'loyalty.couponCode': 'Code',
  'loyalty.couponType': 'Type de remise',
  'loyalty.couponPercent': 'Pourcentage',
  'loyalty.couponFixed': 'Montant fixe',
  'loyalty.couponValue': 'Valeur de la remise',
  'loyalty.couponMinOrder': 'Commande minimum',
  'loyalty.couponMaxUses': 'Utilisations max.',
  'loyalty.couponMaxUsesHint': '0 = illimité',
  'loyalty.couponExpiry': "Valable jusqu'au",
  'loyalty.couponUsed': 'Utilisé',
  'loyalty.generateCode': 'Générer',
  'loyalty.noCoupons': 'Pas encore de codes promo',
  'loyalty.statusActive': 'Actif',
  'loyalty.statusInactive': 'Inactif',
  'loyalty.statusExpired': 'Expiré',
  'loyalty.statusMaxed': 'Épuisé',
  'loyalty.enableSubscriptions': 'Activer les abonnements',
  'loyalty.subscriptionsDisabled': 'Abonnements désactivés',
  'loyalty.disableConfirmTitle': 'Désactiver le programme ?',
  'loyalty.disableConfirmMessage': 'Êtes-vous sûr de vouloir désactiver ce programme de fidélité ? Il cessera de fonctionner pour les clients.',
  'loyalty.disableConfirm': 'Désactiver',
  'loyalty.addPlan': 'Créer un plan',
  'loyalty.newPlan': 'Nouveau plan',
  'loyalty.editPlan': 'Modifier le plan',
  'loyalty.savePlan': 'Enregistrer le plan',
  'loyalty.planName': 'Nom du plan',
  'loyalty.planType': 'Type',
  'loyalty.planTypeVisits': 'Par visites',
  'loyalty.planTypeTime': 'Par durée',
  'loyalty.planTotalVisits': 'Total de visites',
  'loyalty.planValidDays': 'Période de validité',
  'loyalty.planPrice': 'Prix',
  'loyalty.planServices': 'Services',
  'loyalty.planServicesHint': 'Sélectionnez des services ou laissez vide pour tous',
  'loyalty.allServices': 'Tous les services',
  'loyalty.noPlans': 'Pas encore de plans',
  'loyalty.visits': 'visites',
  'loyalty.noActiveSubs': 'Pas encore d\'abonnements actifs',
  'loyalty.subVisits': 'Visites',
  'loyalty.subExpires': 'Expire',
  'loyalty.consumedVisitsTitle': 'Visites utilisées',
  'loyalty.noConsumedVisits': 'Aucune visite utilisée',
  'loyalty.subStatus_active': 'Actif',
  'loyalty.subStatus_expired': 'Expiré',
  'loyalty.subStatus_used_up': 'Épuisé',
  'loyalty.sectionSubscriptions': 'Abonnements',
  'loyalty.sellSubscription': 'Vendre un abonnement',
  'loyalty.sellSubTitle': 'Vente d\'abonnement',
  'loyalty.selectCustomer': 'Sélectionner un client',
  'loyalty.selectPlan': 'Sélectionner un plan',
  'loyalty.confirmSell': 'Confirmer',
  'loyalty.toPayment': 'Passer au paiement',
  'loyalty.paymentTitle': 'Paiement d\'abonnement',
  'loyalty.subSold': 'Abonnement vendu avec succès',
  'loyalty.refund': 'Remboursement',
  'loyalty.refundConfirm': 'Rembourser l\'abonnement "{name}" ? Il sera désactivé.',
  'loyalty.subRefunded': 'Remboursé, abonnement désactivé',
  'loyalty.subStatus_refunded': 'Remboursé',
  'loyalty.subPurchased': 'Acheté',
  'loyalty.subPrice': 'Prix',
  'loyalty.noActiveModules': 'Aucun programme de fidélité actif',

  // ── Loyalty integration (checkout) ──
  'loyalty.usePoints': 'Utiliser des points',
  'loyalty.balance': 'Solde',
  'loyalty.max': 'Max.',
  'loyalty.apply': 'Appliquer',
  'loyalty.enterCoupon': 'Entrez le code promo',
  'loyalty.couponNotFound': 'Code promo introuvable',
  'loyalty.couponInvalid': 'Code promo invalide',
  'loyalty.couponErr_not_found': 'Code promo introuvable',
  'loyalty.couponErr_inactive': 'Code promo inactif',
  'loyalty.couponErr_expired': 'Code promo expiré',
  'loyalty.couponErr_maxed': 'Code promo épuisé',
  'loyalty.couponErr_min_order': 'Montant inférieur au minimum du code promo',
  'loyalty.payBySubscription': 'Payer par abonnement',
  'loyalty.subscription': 'Abonnement',
  'loyalty.pointsRedeemed': 'Points échangés lors du paiement',
  'presence.editing': 'Cet enregistrement est en cours de modification par',

  // ── Rozetka integration ──
  'rozetka.title': 'Rozetka Marketplace',
  'rozetka.subtitle': 'Intégration avec le marketplace Rozetka pour la synchronisation des commandes',
  'rozetka.login': 'Login (email vendeur)',
  'rozetka.loginRequired': 'Entrez le login',
  'rozetka.password': 'Mot de passe',
  'rozetka.save': 'Enregistrer',
  'rozetka.saved': 'Paramètres enregistrés',
  'rozetka.error': 'Erreur : ',
  'rozetka.testConnection': 'Tester la connexion',
  'rozetka.testSuccess': 'Connexion réussie',
  'rozetka.testError': 'Échec de la connexion',
  'rozetka.ordersCount': 'Commandes',
  'rozetka.help': 'Un compte vendeur Rozetka est requis. Utilisez les mêmes identifiants que pour seller.rozetka.com.ua',

  // ── Prom.ua integration ──
  'prom.title': 'Prom.ua',
  'prom.subtitle': 'Intégration avec le marketplace Prom.ua pour la synchronisation des commandes',
  'prom.apiToken': 'Token API',
  'prom.tokenRequired': 'Entrez le token API',
  'prom.save': 'Enregistrer',
  'prom.saved': 'Paramètres enregistrés',
  'prom.error': 'Erreur : ',
  'prom.testConnection': 'Tester la connexion',
  'prom.testSuccess': 'Connexion réussie',
  'prom.testError': 'Échec de la connexion',
  'prom.help': 'Pour obtenir un token API : Cabinet vendeur → Paramètres → Gestion des tokens API. Créez un token avec les droits commandes et produits.',

  // ── POS (vente rapide) ──
  'pos.title': 'Boutique',
  'pos.selectWarehouse': 'Sélectionnez un entrepôt',
  'pos.noWarehouseHint': 'Sélectionnez un entrepôt pour commencer la vente',
  'pos.tariffPlan': 'Plan tarifaire',
  'pos.standardPrice': 'Prix standard',
  'pos.search': 'Rechercher un produit...',
  'pos.allCategories': 'Tous',
  'pos.outOfStock': 'Rupture',
  'pos.noProducts': 'Aucun produit trouvé',
  'pos.cart': 'Panier',
  'pos.emptyCart': 'Le panier est vide',
  'pos.subtotal': 'Sous-total',
  'pos.discount': 'Remise',
  'pos.loyaltyPoints': 'Points de fidélité',
  'pos.available': 'disponible',
  'pos.total': 'Total',
  'pos.coupon': 'Coupon',
  'pos.couponPlaceholder': 'Enter coupon code...',
  'pos.applyCoupon': 'Apply',
  'pos.invalidCoupon': 'Coupon is invalid or not found',
  'pos.cash': 'Espèces',
  'pos.card': 'Carte',
  'pos.transfer': 'Virement',
  'pos.cashGiven': 'Reçu',
  'pos.change': 'Monnaie',
  'pos.confirm': 'Confirmer',
  'pos.saleComplete': 'Vente terminée !',
  'pos.returnTitle': 'Retour de produit',
  'pos.returnHint': 'Indiquez les quantités à retourner',
  'pos.returnAmount': 'Montant du retour',
  'pos.confirmReturn': 'Retourner',
  'pos.tabSale': 'Vente',
  'pos.tabHistory': 'Historique',
  'pos.historyEmpty': 'Aucune vente pour le moment',
  'pos.historyDate': 'Date',
  'pos.historyItems': 'Articles',
  'pos.historyTotal': 'Total',
  'pos.historyMethod': 'Méthode',
  'pos.historyAuthor': 'Auteur',
  'pos.historyCancel': 'Annuler',
  'pos.historyCancelConfirm': 'Annuler cette vente ? Les articles seront retournés au stock.',
  'pos.historyCancelled': 'Vente annulée',
  'pos.historyCustomer': 'Client',
  'pos.historyReturn': 'Retour',
  'pos.historyReturned': 'Retour',
  'pos.partialReturn': 'Retour partiel',
  'pos.warehouse': 'Entrepôt',
  'pos.customer': 'Client',
  'pos.selectCustomer': 'Rechercher un client...',
  'bizMonitor.title': 'Moniteur d\'affaires',
  'bizMonitor.subtitle': 'Vue stratégique pour le propriétaire',
  'bizMonitor.revenue': 'Chiffre d\'affaires', 'bizMonitor.profit': 'Bénéfice', 'bizMonitor.profitability': 'Rentabilité',
  'bizMonitor.activeClients': 'Clients actifs', 'bizMonitor.retention': 'Rétention',
  'bizMonitor.services': 'Services', 'bizMonitor.goods': 'Produits',
  'bizMonitor.new': 'Nouveaux', 'bizMonitor.returning': 'Récurrents', 'bizMonitor.prevMonth': 'Mois préc.',
  'bizMonitor.revenueTrend': 'Tendance du CA', 'bizMonitor.clientHealth': 'Santé des clients',
  'bizMonitor.viewDetails': 'Voir détails', 'bizMonitor.newClients': 'Nouveaux', 'bizMonitor.returningClients': 'Récurrents',
  'bizMonitor.sleeping': 'Inactifs (30j+)', 'bizMonitor.avgCheckServices': 'Panier moyen services',
  'bizMonitor.avgCheckProducts': 'Panier moyen produits', 'bizMonitor.channels': 'Canaux de vente',
  'bizMonitor.channelAppts': 'RDV', 'bizMonitor.channelOrders': 'Commandes', 'bizMonitor.channelPos': 'POS',
  'bizMonitor.topStaff': 'Top employés', 'bizMonitor.topServices': 'Top services', 'bizMonitor.topProducts': 'Top produits',
  'bizMonitor.appointments': 'RDV', 'bizMonitor.times': 'fois', 'bizMonitor.pcs': 'pcs', 'bizMonitor.margin': 'Marge',
  'bizMonitor.stockAnalytics': 'Stock', 'bizMonitor.stockValue': 'Valeur stock', 'bizMonitor.positions': 'articles',
  'bizMonitor.lowStockCount': 'Stock faible', 'bizMonitor.noMovementCount': 'Sans mouvement 30j+',
  'bizMonitor.alerts': 'Nécessite attention', 'bizMonitor.alertFinance': 'Finances', 'bizMonitor.alertClients': 'Clients',
  'bizMonitor.alertStock': 'Produits/Stock', 'bizMonitor.alertStaff': 'Personnel', 'bizMonitor.noData': 'Pas de données',
  'sidebar.businessMonitor': 'Moniteur d\'affaires',

  // ── Communication : clés manquantes par rapport à uk (2026-09-25) ──
  'nav.instagram': 'Instagram',
  'nav.messenger': 'Messenger',
  'instagram.tagline': 'Les messages directs de votre compte Instagram Business — dans le CRM',
  'instagram.connected': 'Connecté',
  'instagram.notConnected': 'Non connecté',
  'instagram.connectIntro': 'Connectez votre compte Instagram Business via OAuth pour recevoir les messages directs de vos clients dans le CRM.',
  'instagram.connectBtn': 'Connecter Instagram',
  'instagram.tabOpened': 'Instagram s’est ouvert dans un nouvel onglet. Connectez-vous puis revenez ici.',
  'instagram.connectFailed': 'Erreur de connexion :',
  'instagram.confirmDisconnect': 'Déconnecter l’intégration Instagram ?',
  'instagram.disconnected': 'Instagram déconnecté',
  'instagram.disconnectBtn': 'Déconnecter',
  'instagram.testBtn': 'Tester la connexion',
  'instagram.testOk': 'La connexion fonctionne :',
  'instagram.testFailed': 'Échec du test',
  'instagram.account': 'Compte',
  'instagram.userId': 'IG User ID',
  'instagram.scope': 'Autorisations',
  'instagram.connectedAt': 'Connecté le',
  'instagram.expiresAt': 'Valide jusqu’au',
  'instagram.reconnectRequired': 'Nouvelle autorisation requise',
  'instagram.reconnectExplain': 'Le jeton longue durée n’a pas pu être renouvelé (généralement après plus de 60 jours d’inactivité ou un changement de mot de passe Instagram). Cliquez sur « Connecter Instagram » pour continuer à recevoir les messages.',
  'instagram.howItWorks': 'Comment ça marche',
  'instagram.step1': 'Cliquez sur « Connecter Instagram » : l’autorisation Instagram s’ouvre dans un nouvel onglet.',
  'instagram.step2': 'Connectez-vous à votre compte Instagram Business (compte professionnel lié à une Page Facebook) et autorisez l’application à accéder aux messages directs.',
  'instagram.step3': 'Revenez sur cet onglet : le statut se met à jour automatiquement ; vérifiez avec « Tester la connexion ».',
  'instagram.capabilities': 'Ce que la connexion apporte',
  'instagram.capInboxTitle': 'Messages directs — dans le CRM',
  'instagram.capInboxText': 'Tous les messages Instagram Direct arrivent dans Communication en temps réel via les webhooks Meta, aux côtés de Telegram, des SMS et des e-mails.',
  'instagram.capOutboundTitle': 'Répondre depuis le CRM directement sur Instagram',
  'instagram.capOutboundText': 'Ouvrez le fil dans Communication et choisissez le canal « Instagram » : le message part dans le Direct du client.',
  'instagram.limitations': 'Limitations',
  'instagram.limitationsText': 'Fonctionne uniquement avec un compte professionnel Instagram (Business ou Creator) lié à une Page Facebook. Meta ne prend pas en charge les comptes personnels dans la Messaging API.',
  'instagram.resubscribed': 'Abonnement aux webhooks renouvelé. Cliquez sur « Tester la connexion » pour voir le nouvel état.',
  'instagram.resubscribeFailed': 'Impossible de renouveler l’abonnement :',
  'instagram.errorPrefix': 'Erreur :',
  'custModal.subscriptionPurchase': 'Achat d’abonnement',
  'custModal.subscriptionRefund': 'Remboursement d’abonnement',
  'custModal.methodOnline': 'En ligne',
  'custModal.methodSubscription': 'Abonnement',
  'custModal.servicesLabel': 'Services',
  'custModal.messageSent': 'Envoyé',
  'emailSet.provider': 'Service de messagerie',
  'emailSet.presetGmail': 'Gmail / Google Workspace',
  'emailSet.presetOutlook': 'Outlook / Microsoft 365',
  'emailSet.presetUkrnet': 'Ukr.net',
  'emailSet.presetMeta': 'Meta.ua',
  'emailSet.presetCustom': 'SMTP personnalisé',
  'emailSet.hintGmail': 'Nécessite un mot de passe d’application depuis myaccount.google.com/apppasswords (activez d’abord la validation en deux étapes)',
  'emailSet.hintOutlook': 'L’identifiant est l’adresse complète (you@outlook.com). Avec la validation en deux étapes, un mot de passe d’application peut être nécessaire',
  'emailSet.hintUkrnet': 'Dans Ukr.net : Paramètres → Courrier → Autoriser l’accès des clients de messagerie externes',
  'emailSet.hintMeta': 'Dans Meta.ua : Paramètres → IMAP/SMTP → Activer',
  'emailSet.hintCustom': 'Saisissez manuellement l’hôte, le port et les identifiants de votre serveur de messagerie',
  'emailSet.host': 'Serveur SMTP',
  'emailSet.port': 'Port',
  'emailSet.secure': 'TLS/SSL',
  'emailSet.smtpUser': 'Identifiant SMTP',
  'emailSet.smtpUserHint': 'Généralement l’adresse e-mail complète',
  'emailSet.password': 'Mot de passe SMTP',
  'emailSet.passwordHint': 'Pour Gmail/Outlook : mot de passe d’application, pas le mot de passe principal',
  'emailSet.fromEmail': 'Adresse de l’expéditeur',
  'emailSet.fromEmailHint': 'Si vide, l’identifiant SMTP est utilisé',
  'emailSet.invalidEmail': 'Adresse e-mail invalide (format attendu : user@domain.com)',
  'emailSet.sectionProvider': 'Service de messagerie et serveur',
  'emailSet.sectionCredentials': 'Identifiants',
  'emailSet.sectionFrom': 'Expéditeur',
  'emailSet.howToConnect': 'Comment connecter {provider}',
  'emailSet.instrGmail': '<ol><li>Activez la validation en deux étapes sur votre compte Google : <a href="https://myaccount.google.com/security" target="_blank">myaccount.google.com/security</a> → <strong>Validation en deux étapes</strong> → <strong>Activer</strong>.</li><li>Ouvrez <a href="https://myaccount.google.com/apppasswords" target="_blank">myaccount.google.com/apppasswords</a>.</li><li>Créez un mot de passe d’application : type <strong>Mail</strong> (ou <strong>Autre</strong> avec le nom <code>Systemic CRM</code>).</li><li>Copiez le mot de passe de 16 caractères (de la forme <code>abcd efgh ijkl mnop</code>).</li><li>Collez-le dans le champ <strong>Mot de passe SMTP</strong> ci-dessus et cliquez sur <strong>Envoyer un e-mail de test</strong>.</li></ol>',
  'emailSet.instrOutlook': '<ol><li>Connectez-vous sur <a href="https://account.microsoft.com/security" target="_blank">account.microsoft.com/security</a>.</li><li>Ouvrez <strong>Options de sécurité avancées</strong>.</li><li>Dans <strong>Mots de passe d’application</strong>, cliquez sur <strong>Créer un nouveau mot de passe</strong>.</li><li>Copiez le mot de passe généré et collez-le dans <strong>Mot de passe SMTP</strong>.</li><li><em>Si l’option « Mots de passe d’application » est absente, activez d’abord la validation en deux étapes.</em></li></ol>',
  'emailSet.instrUkrnet': '<ol><li>Connectez-vous à la messagerie Ukr.net.</li><li>Ouvrez <strong>Paramètres → Tous les paramètres → Programmes de messagerie</strong>.</li><li>Activez l’<strong>accès IMAP/SMTP</strong>.</li><li>Dans <strong>Mot de passe SMTP</strong>, indiquez le mot de passe principal de la messagerie Ukr.net.</li><li><em>Si la validation en deux étapes est activée, créez un mot de passe d’application distinct dans les paramètres de sécurité.</em></li></ol>',
  'emailSet.instrMeta': '<ol><li>Connectez-vous à la messagerie Meta.ua.</li><li>Ouvrez <strong>Paramètres → IMAP/SMTP</strong>.</li><li>Activez le protocole SMTP.</li><li>Indiquez le mot de passe principal de la messagerie dans le champ <strong>Mot de passe SMTP</strong>.</li></ol>',
  'emailSet.instrCustom': '<ol><li>Demandez à votre administrateur système ou à votre hébergeur les paramètres SMTP de votre serveur de messagerie.</li><li>Il faut généralement : <strong>hôte</strong> (smtp.votre-domaine.com), <strong>port</strong> (587 ou 465), <strong>TLS/SSL</strong> (activé pour 465).</li><li>L’identifiant est l’adresse e-mail complète.</li><li>Le mot de passe est celui de votre messagerie (ou un mot de passe SMTP distinct si votre fournisseur en délivre un).</li></ol>',
  'notifAuto.title': 'Paramètres de communication',
  'notifAuto.subtitle': 'Priorité des canaux, messages automatiques et rappels',
  'notifAuto.navItem': 'Paramètres de communication',
  'notifAuto.sectionDefaultPriority': 'Priorité par défaut pour les messages manuels',
  'notifAuto.defaultPriorityHint': 'Quand l’administrateur écrit à un client dans Communication pour la première fois, le premier canal disponible de cette liste est choisi ; ensuite, le canal utilisé en dernier avec ce client est conservé. Glissez pour réordonner, désactivez ceux que vous n’utilisez pas.',
  'notifAuto.sectionBooking': 'Message à la création d’un rendez-vous',
  'notifAuto.sectionOrder': 'Message à la création d’une commande de produits',
  'notifAuto.enable': 'Activer',
  'notifAuto.mode': 'Mode d’envoi',
  'notifAuto.modePriority': 'Priorité (premier canal disponible)',
  'notifAuto.modeAll': 'Tous les canaux en même temps',
  'notifAuto.channelsOrder': 'Priorité des canaux (glissez pour réordonner)',
  'notifAuto.channelsEmpty': 'Aucun canal activé : activez-en au moins un ci-dessous',
  'notifAuto.otherChannels': 'Autres canaux',
  'notifAuto.dragHint': 'Glissez pour changer l’ordre',
  'notifAuto.channelNotConfigured': 'Le canal n’est pas configuré dans sa section : le message ne sera pas envoyé',
  'notifAuto.channelTelegram': 'Telegram',
  'notifAuto.channelSms': 'SMS',
  'notifAuto.channelEmail': 'E-mail',
  'notifAuto.channelWeb': 'Chat du site',
  'notifAuto.template': 'Modèle de message',
  'notifAuto.templateHint': 'Variables disponibles : {clientName}, {date}, {time}, {serviceName}, {staffName}, {locationName}, {phone}, {orderNumber}, {total}, {items}',
  'notifAuto.templateHtmlNote': 'HTML pris en charge pour Telegram/E-mail ; pour les SMS, converti automatiquement en texte brut',
  'notifAuto.preview': 'Aperçu',
  'notifAuto.previewHint': 'Exemple avec des données de test',
  'notifAuto.save': 'Enregistrer',
  'notifAuto.saved': 'Paramètres enregistrés',
  'notifAuto.moveUp': 'Monter',
  'notifAuto.moveDown': 'Descendre',
  'notifAuto.defaultBookingTemplate': 'Bonjour {clientName} ! Votre rendez-vous est confirmé le {date} à {time}. Prestation : {serviceName}, spécialiste : {staffName}. À bientôt !',
  'notifAuto.defaultOrderTemplate': 'Merci pour votre commande n°{orderNumber} d’un montant de {total} ₴. Nous vous contacterons pour confirmer la livraison.',
  'notifAuto.sectionReminders': 'Rappels avant la visite',
  'notifAuto.remindersHint': 'Vous pouvez ajouter plusieurs règles avec des délais différents (par exemple 24 heures et 2 heures avant). Minimum : 1 heure.',
  'notifAuto.noReminders': 'Aucun rappel configuré pour le moment',
  'notifAuto.addReminder': 'Ajouter un rappel',
  'notifAuto.removeReminder': 'Supprimer le rappel',
  'notifAuto.hoursBefore': 'Combien de temps avant la visite',
  'notifAuto.hoursBeforeUnit': 'heures',
  'notifAuto.defaultReminderTemplate': 'Rappel : votre visite est le {date} à {time}. Prestation : {serviceName}, spécialiste : {staffName}. À bientôt !',
  'comm.filterAll': 'Tous',
  'comm.channelWeb': 'Chat du site',
  'comm.noChannelsForClient': 'Le client n’a aucun canal de contact connecté',
  'comm.addContactToCard': 'Ajoutez un téléphone ou un e-mail dans la fiche client, ou envoyez-lui le lien vers le bot Telegram',
  'sms.testText': 'Systemic CRM : message de test.',
  'sms.testSent': 'Envoyé : vérifiez le téléphone',
  'sms.testNotSent': 'Non envoyé',
  'sms.senderRule1': '11 caractères latins maximum, sans espaces : c’est la limite du standard GSM. Le nom doit être',
  'sms.senderRuleStrong': 'enregistré dans l’espace client du fournisseur',
  'sms.senderRule2': 'et correspondre caractère par caractère, casse comprise.',
  'sms.lastFailed': 'Le dernier envoi a échoué',
  'sms.lastOk': 'Dernier envoi réussi',
  'sms.testLabel': 'Test avec un vrai SMS',
  'telegram.statusChecking': 'Vérification de l’état du bot…',
  'telegram.statusRecheck': 'Vérifier',
  'telegram.statusLastError': 'Dernière erreur :',
  'telegram.statusBot': 'Bot',
  'telegram.statusWebhook': 'Webhook',
  'telegram.statusWebhookNone': 'non défini',
  'telegram.statusWebhookExpected': 'attendu',
  'telegram.statusQueue': 'En file d’attente',
  'telegram.statusSubscribers': 'Abonnés',
  'telegram.statusSubscribersSub': 'clients ayant appuyé sur « Démarrer »',
  'telegram.verdictOk': 'Le bot est connecté et fonctionne',
  'telegram.verdictNoToken': 'Le bot n’est pas configuré',
  'telegram.verdictNoTokenHint': 'Collez le jeton de @BotFather et cliquez sur « Enregistrer et connecter ».',
  'telegram.verdictBadToken': 'Jeton invalide',
  'telegram.verdictBadTokenHint': 'Le bot a été supprimé ou le jeton a été régénéré dans @BotFather. Collez le nouveau.',
  'telegram.verdictNoWebhook': 'Webhook non défini',
  'telegram.verdictNoWebhookHint': 'Telegram ne sait pas où envoyer les mises à jour. Cliquez sur « Enregistrer et connecter ».',
  'telegram.verdictHostMismatch': 'Le webhook pointe vers une autre adresse',
  'telegram.verdictHostMismatchHint': 'Cela arrive souvent quand le bot a été connecté depuis un lien de test. Cliquez sur « Enregistrer et connecter » à cette adresse.',
  'telegram.verdictWebhookError': 'Telegram n’arrive pas à nous joindre',
  'telegram.verdictPending': 'Des mises à jour sont bloquées dans la file',
  'telegram.verdictPendingHint': 'Telegram a accumulé des mises à jour qu’il n’a pas pu livrer.',
  'telegram.verdictNoSubscribers': 'Le bot fonctionne, mais n’a aucun abonné',
  'telegram.verdictNoSubscribersHint': 'Aucun client n’a encore appuyé sur « Démarrer » dans le bot. Le lien personnel se trouve dans la fiche client.',
  'telegram.verdictUnreachable': 'Impossible de vérifier l’état',
  'telegram.statusForward': 'Transfert',
  'telegram.statusForwardOk': 'fonctionne',
  'telegram.statusForwardError': 'erreur',
  'telegram.statusForwardPending': 'pas encore de mises à jour',
  'telegram.fwdTitle': 'Bot externe : menus et scénarios',
  'telegram.fwdIntro': 'Si ce bot a un serveur séparé pour les menus (boutons, scénarios), Systemic reste propriétaire du webhook et lui transfère une copie de chaque mise à jour. Les conversations et les réponses des opérateurs restent ici, comme avant.',
  'telegram.fwdUrl': 'Adresse de transfert (https)',
  'telegram.fwdUrlHint': 'Laissez vide pour désactiver le transfert.',
  'telegram.fwdSecret': 'Mot de passe de transfert',
  'telegram.fwdSecretHint': 'Une chaîne de votre choix. Systemic l’envoie dans l’en-tête X-Systemic-Secret et une signature du corps dans X-Systemic-Signature, pour que le serveur externe vérifie que la requête vient de nous.',
  'telegram.fwdSecretStored': 'Le mot de passe est stocké sur le serveur et n’est jamais renvoyé au navigateur. Saisissez-en un nouveau pour le remplacer.',
  'telegram.fwdSave': 'Enregistrer le transfert',
  'telegram.fwdSaved': 'Transfert enregistré',
  'telegram.fwdInvalidUrl': 'L’adresse doit commencer par https://',
  'telegram.fwdHowTitle': 'Comment ça marche et points d’attention',
  'telegram.fwdHow1': 'Le webhook du bot reste chez Systemic. Le serveur externe ne doit pas le modifier : la carte d’état afficherait « Le webhook pointe vers une autre adresse » et « Enregistrer et connecter » le reprendrait.',
  'telegram.fwdHow2': 'Systemic traite chaque mise à jour (conversations, rattachement du client, téléphone) et transfère en parallèle une copie à l’adresse indiquée, y compris les appuis sur les boutons, que Systemic ignore.',
  'telegram.fwdHow3': 'Le serveur externe affiche les menus via le jeton du bot. C’est de l’interface, pas de la conversation : cela n’arrive pas dans Communication. Les opérateurs répondent aux clients depuis Systemic.',
  'telegram.fwdHow4': 'Construisez les menus avec des boutons inline (sous le message). Le clavier du bas envoie les appuis comme du texte, et le fil de l’opérateur se remplit de « Services », « Retour ».',
  'telegram.fwdHow5': 'Systemic répond déjà à /start : il salue et demande le numéro pour retrouver le client. Affichez le menu après cela ou sur une commande distincte, sinon le client reçoit deux messages d’affilée.',
  'telegram.fwdHow6': 'Le serveur doit répondre 200 en 4 secondes. Pas de nouvelle tentative ; l’état du dernier transfert est visible dans la carte d’état ci-dessus.',
  'messengerSet.tagline': 'Les messages de votre Page Facebook — dans le CRM',
  'messengerSet.tabOpened': 'Facebook s’est ouvert dans un nouvel onglet. Connectez-vous puis revenez ici.',
  'messengerSet.connectFailed': 'Erreur de connexion :',
  'messengerSet.confirmDisconnect': 'Déconnecter l’intégration Messenger ?',
  'messengerSet.disconnected': 'Messenger déconnecté',
  'messengerSet.pageActivated': 'Page « {name} » activée',
  'messengerSet.subscribeFailed': 'Page activée, mais l’abonnement au webhook a échoué : {error}. Cliquez sur « Renouveler l’abonnement aux webhooks ».',
  'messengerSet.activateFailed': 'Impossible d’activer la page',
  'messengerSet.errorPrefix': 'Erreur :',
  'messengerSet.pagesRefreshed': 'Liste des pages actualisée',
  'messengerSet.resubscribed': 'Abonnement aux webhooks renouvelé. Cliquez sur « Tester la connexion ».',
  'messengerSet.resubscribeFailed': 'Impossible de renouveler l’abonnement :',
  'messengerSet.needsReconnect': 'Nouvelle autorisation requise',
  'messengerSet.reconnectHint': 'Facebook a révoqué le jeton. Cliquez sur « Connecter » pour continuer.',
  'messengerSet.howTitle': 'Comment ça marche',
  'messengerSet.how1': 'Cliquez sur « Connecter Messenger » : Facebook ouvre l’autorisation dans un nouvel onglet.',
  'messengerSet.how2': 'Autorisez l’application à gérer les messages de vos pages.',
  'messengerSet.how3': 'Revenez ici : vous verrez la liste de vos Pages Facebook. Choisissez-en une pour le CRM.',
  'messengerSet.how4': 'C’est tout. Les messages de cette page arrivent automatiquement dans Communication.',
  'messengerSet.givesTitle': 'Ce que la connexion apporte',
  'messengerSet.capInboxTitle': 'Messages de la Page Facebook — dans le CRM',
  'messengerSet.capInboxText': 'Tous les messages adressés à votre page arrivent dans Communication en temps réel, aux côtés de Telegram, des SMS et des e-mails.',
  'messengerSet.capReplyTitle': 'Répondre depuis le CRM directement sur Messenger',
  'messengerSet.capReplyText': 'Ouvrez le fil dans Communication et choisissez le canal « Messenger » : la réponse part au client. Meta autorise les réponses dans les 24 heures suivant son message.',
  'messengerSet.limitsLabel': 'Limitations :',
  'messengerSet.limitsText': 'Fonctionne uniquement avec les Pages professionnelles Facebook, pas avec les profils personnels.',
  'messengerSet.statusOff': 'Non connecté',
  'messengerSet.statusPending': 'En attente du choix de la page',
  'messengerSet.statusOn': 'Connecté',
  'messengerSet.connectIntro': 'Connectez votre compte Facebook et choisissez la Page dont les messages arriveront dans le CRM.',
  'messengerSet.connectBtn': 'Connecter Messenger',
  'messengerSet.noPages': 'Aucune Page Facebook trouvée sur ce compte. Créez-en une sur facebook.com → Pages, puis actualisez la liste.',
  'messengerSet.refreshPages': 'Actualiser la liste des pages',
  'messengerSet.disconnectBtn': 'Déconnecter',
  'messengerSet.pickIntro': 'Choisissez la Page Facebook dont le CRM recevra les messages :',
  'messengerSet.pageActive': 'Active',
  'messengerSet.pageUse': 'Utiliser',
  'messengerSet.refreshList': 'Actualiser la liste',
  'messengerSet.fbAccount': 'Compte Facebook :',
  'messengerSet.activePage': 'Page active :',
  'messengerSet.connectedAt': 'Connecté le :',
  'messengerSet.userTokenUntil': 'Jeton utilisateur valide jusqu’au :',
  'messengerSet.unknown': '(inconnu)',
  'messengerSet.testBtn': 'Tester la connexion',
  'messengerSet.resubscribeBtn': 'Renouveler l’abonnement aux webhooks',
  'messengerSet.switchPage': 'Changer de page',
  'messengerSet.patOk': '✓ Le jeton de la page est valide :',
  'messengerSet.patFailed': '✗ Le jeton de la page n’a pas passé la vérification :',
  'messengerSet.subsTitle': 'Abonnements aux webhooks :',
  'messengerSet.noApps': 'Aucune application n’est abonnée à cette page. Cliquez sur « Renouveler l’abonnement aux webhooks ».',
  'messengerSet.subscribedFields': 'Champs abonnés :',
  'messengerSet.noMessagesField': '⚠ Le champ « messages » est absent : Meta ne livrera pas les messages. Cliquez sur « Renouveler l’abonnement aux webhooks ».',
  'messengerSet.subsFailed': '✗ La vérification des abonnements a échoué :',
};

export default fr;
